{
  "_sync": {
    "generatedBy": "configurator/scripts/sync-api.mjs",
    "source": "docs/api-index.json",
    "tokensHash": "f0ec75d2a64d",
    "bundles": [
      "full",
      "optimal"
    ],
    "counts": {
      "tokens": 734,
      "byTier": {
        "PUBLIC": 688,
        "PUBLIC-ADVANCED": 45,
        "INTERNAL": 1
      },
      "byCategory": {
        "Layout tokens": 53,
        "Core tokens": 604,
        "Component tokens": 46,
        "Macro tokens": 31
      }
    }
  },
  "tokens": [
    {
      "name": "--sf-alternate-gap",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "alternate",
      "category": "Layout tokens",
      "group": "Alternate (zigzag)",
      "description": "Gap tokens for the alternating content/media (zigzag) layout.",
      "note": "Gap between items in the alternating zigzag layout.",
      "value": "var(--sf-content-gap)",
      "aliasOf": "--sf-content-gap",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-alternate-inner-gap",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "alternate",
      "category": "Layout tokens",
      "group": "Alternate (zigzag)",
      "description": "Gap tokens for the alternating content/media (zigzag) layout.",
      "note": "Gap between content and media within each zigzag item.",
      "value": "var(--sf-gap)",
      "aliasOf": "--sf-gap",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-animation-blink",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "animation",
      "category": "Core tokens",
      "group": "Animation presets",
      "description": "Complete animation shorthand values — pair named @keyframes with duration and easing. Use directly as animation property values.",
      "note": "Blinking visibility loop. Use for cursor indicators or critical attention cues. Respect prefers-reduced-motion.",
      "value": "sf-blink calc(1s * var(--sf-motion-scale)) steps(1, end) infinite",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-animation-color-pulse",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "animation",
      "category": "Core tokens",
      "group": "Animation presets",
      "description": "Complete animation shorthand values — pair named @keyframes with duration and easing. Use directly as animation property values.",
      "note": "Pulsing color loop. Use for live-status badges (recording, live). Respect prefers-reduced-motion.",
      "value": "sf-color-pulse var(--sf-duration-slow) var(--sf-ease-in-out) infinite",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-animation-fade-in",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "animation",
      "category": "Core tokens",
      "group": "Animation presets",
      "description": "Complete animation shorthand values — pair named @keyframes with duration and easing. Use directly as animation property values.",
      "note": "Fade-in entrance animation shorthand. Use directly as animation property value.",
      "value": "sf-fade-in var(--sf-duration-normal) var(--sf-ease-out) both",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-animation-fade-out",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "animation",
      "category": "Core tokens",
      "group": "Animation presets",
      "description": "Complete animation shorthand values — pair named @keyframes with duration and easing. Use directly as animation property values.",
      "note": "Fade-out exit animation shorthand.",
      "value": "sf-fade-out var(--sf-duration-normal) var(--sf-ease-in) both",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-animation-float",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "animation",
      "category": "Core tokens",
      "group": "Animation presets",
      "description": "Complete animation shorthand values — pair named @keyframes with duration and easing. Use directly as animation property values.",
      "note": "Gentle floating / levitating loop. Use for hero illustrations or floating UI elements. Decorative — disable for prefers-reduced-motion.",
      "value": "sf-float calc(3s * var(--sf-motion-scale)) var(--sf-ease-in-out) infinite",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-animation-ping",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "animation",
      "category": "Core tokens",
      "group": "Animation presets",
      "description": "Complete animation shorthand values — pair named @keyframes with duration and easing. Use directly as animation property values.",
      "note": "Expanding ping / ripple loop. Use for notification badges and live-indicator dots.",
      "value": "sf-ping var(--sf-duration-slow) var(--sf-ease-out) infinite",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-animation-scale-down",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "animation",
      "category": "Core tokens",
      "group": "Animation presets",
      "description": "Complete animation shorthand values — pair named @keyframes with duration and easing. Use directly as animation property values.",
      "note": "Scale-down exit animation. Pairs with --sf-animation-scale-up for enter/leave transitions.",
      "value": "sf-scale-down var(--sf-duration-normal) var(--sf-ease-in) both",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-animation-scale-up",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "animation",
      "category": "Core tokens",
      "group": "Animation presets",
      "description": "Complete animation shorthand values — pair named @keyframes with duration and easing. Use directly as animation property values.",
      "note": "Scale-up entrance animation. Use for modals, popovers, and tooltips appearing.",
      "value": "sf-scale-up var(--sf-duration-normal) var(--sf-ease-overshoot) both",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-animation-shimmer",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "animation",
      "category": "Core tokens",
      "group": "Animation presets",
      "description": "Complete animation shorthand values — pair named @keyframes with duration and easing. Use directly as animation property values.",
      "note": "Shimmer / skeleton-loading sweep. Apply on placeholder elements while content loads.",
      "value": "sf-shimmer calc(1.5s * var(--sf-motion-scale)) var(--sf-ease-in-out) infinite",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-animation-slide-in-down",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "animation",
      "category": "Core tokens",
      "group": "Animation presets",
      "description": "Complete animation shorthand values — pair named @keyframes with duration and easing. Use directly as animation property values.",
      "note": "Slide-in from above. Use for dropdown menus and top-attached sheets.",
      "value": "sf-slide-in-down var(--sf-duration-normal) var(--sf-ease-out) both",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-animation-slide-in-left",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "animation",
      "category": "Core tokens",
      "group": "Animation presets",
      "description": "Complete animation shorthand values — pair named @keyframes with duration and easing. Use directly as animation property values.",
      "note": "Slide-in from the left. Use for left-side drawers and navigation panels.",
      "value": "sf-slide-in-left var(--sf-duration-normal) var(--sf-ease-out) both",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-animation-slide-in-right",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "animation",
      "category": "Core tokens",
      "group": "Animation presets",
      "description": "Complete animation shorthand values — pair named @keyframes with duration and easing. Use directly as animation property values.",
      "note": "Slide-in from the right. Use for right-side drawers and detail panels.",
      "value": "sf-slide-in-right var(--sf-duration-normal) var(--sf-ease-out) both",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-animation-slide-in-up",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "animation",
      "category": "Core tokens",
      "group": "Animation presets",
      "description": "Complete animation shorthand values — pair named @keyframes with duration and easing. Use directly as animation property values.",
      "note": "Slide-in from below. Use for bottom sheets, toasts, and floating action buttons.",
      "value": "sf-slide-in-up var(--sf-duration-normal) var(--sf-ease-out) both",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-animation-slide-out-down",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "animation",
      "category": "Core tokens",
      "group": "Animation presets",
      "description": "Complete animation shorthand values — pair named @keyframes with duration and easing. Use directly as animation property values.",
      "note": "Ready-made animation shorthand: slides the element out downward (sf-slide-out-down) at the normal duration with ease-in.",
      "value": "sf-slide-out-down var(--sf-duration-normal) var(--sf-ease-in) both",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-animation-slide-out-left",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "animation",
      "category": "Core tokens",
      "group": "Animation presets",
      "description": "Complete animation shorthand values — pair named @keyframes with duration and easing. Use directly as animation property values.",
      "note": "Ready-made animation shorthand: slides the element out to the left (sf-slide-out-left) at the normal duration with ease-in.",
      "value": "sf-slide-out-left var(--sf-duration-normal) var(--sf-ease-in) both",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-animation-slide-out-right",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "animation",
      "category": "Core tokens",
      "group": "Animation presets",
      "description": "Complete animation shorthand values — pair named @keyframes with duration and easing. Use directly as animation property values.",
      "note": "Ready-made animation shorthand: slides the element out to the right (sf-slide-out-right) at the normal duration with ease-in.",
      "value": "sf-slide-out-right var(--sf-duration-normal) var(--sf-ease-in) both",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-animation-slide-out-up",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "animation",
      "category": "Core tokens",
      "group": "Animation presets",
      "description": "Complete animation shorthand values — pair named @keyframes with duration and easing. Use directly as animation property values.",
      "note": "Ready-made animation shorthand: slides the element out upward (sf-slide-out-up) at the normal duration with ease-in.",
      "value": "sf-slide-out-up var(--sf-duration-normal) var(--sf-ease-in) both",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-animation-spin",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "animation",
      "category": "Core tokens",
      "group": "Animation presets",
      "description": "Complete animation shorthand values — pair named @keyframes with duration and easing. Use directly as animation property values.",
      "note": "Continuous rotation loop. Use for loading spinners and progress indicators.",
      "value": "sf-spin var(--sf-duration-slower) linear infinite",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-bento-cols-default",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "bento",
      "category": "Layout tokens",
      "group": "Bento grid",
      "description": "Configuration tokens for the bento-grid layout primitive.",
      "note": "Default column count for the bento grid.",
      "value": "4",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-bento-gap",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "bento",
      "category": "Layout tokens",
      "group": "Bento grid",
      "description": "Configuration tokens for the bento-grid layout primitive.",
      "note": "Gap between bento grid cells.",
      "value": "var(--sf-gap)",
      "aliasOf": "--sf-gap",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-bento-row-compact",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "bento",
      "category": "Layout tokens",
      "group": "Bento grid",
      "description": "Configuration tokens for the bento-grid layout primitive.",
      "note": "Row height for compact-variant bento items.",
      "value": "6rem",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-bento-row-default",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "bento",
      "category": "Layout tokens",
      "group": "Bento grid",
      "description": "Configuration tokens for the bento-grid layout primitive.",
      "note": "Default row height for standard bento grid cells.",
      "value": "10rem",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-bento-row-tall",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "bento",
      "category": "Layout tokens",
      "group": "Bento grid",
      "description": "Configuration tokens for the bento-grid layout primitive.",
      "note": "Tall row height for visually prominent or hero bento cells.",
      "value": "16rem",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-bg-layer-fit",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "bg",
      "category": "Layout tokens",
      "group": "Background layer (.sf-bg-layer)",
      "description": "object-fit applied to .sf-bg-layer when used as a bare media element, and to .sf-bg-layer > img / video / picture children. Defaults to cover.",
      "note": "object-fit applied to .sf-bg-layer when used as a bare media element, and to .sf-bg-layer > img / video / picture children. Defaults to cover.",
      "value": "cover",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-bg-layer-inset",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "bg",
      "category": "Layout tokens",
      "group": "Background layer (.sf-bg-layer)",
      "description": "Inset from every edge of the parent. A single length applied uniformly; the layer size is derived from it so a non-zero inset still fills correctly.",
      "note": "Inset from every edge of the parent. A single length applied uniformly; the layer size is derived from it so a non-zero inset still fills correctly.",
      "value": "0px",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-bg-layer-position",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "bg",
      "category": "Layout tokens",
      "group": "Background layer (.sf-bg-layer)",
      "description": "object-position controlling where the media is anchored within the layer. Defaults to center (50% 50%).",
      "note": "object-position controlling where the media is anchored within the layer. Defaults to center (50% 50%).",
      "value": "50% 50%",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-bg-layer-radius",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "bg",
      "category": "Layout tokens",
      "group": "Background layer (.sf-bg-layer)",
      "description": "border-radius applied to the .sf-bg-layer layer and its img/video/picture children. Defaults to 0; set to match the parent's radius when clipping is needed.",
      "note": "border-radius applied to the .sf-bg-layer layer and its img/video/picture children. Defaults to 0; set to match the parent's radius when clipping is needed.",
      "value": "0",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-bg-layer-z",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "bg",
      "category": "Layout tokens",
      "group": "Background layer (.sf-bg-layer)",
      "description": "z-index of the background layer. Defaults to -2 so it sits behind sibling content but above the parent's own background.",
      "note": "z-index of the background layer. Defaults to -2 so it sits behind sibling content but above the parent's own background.",
      "value": "-2",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-blur",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "blur",
      "category": "Core tokens",
      "group": "Blur & opacity",
      "description": "Backdrop-filter blur scale and background-opacity tokens.",
      "note": "Backdrop-filter blur amount for frosted-glass surfaces (navbars, overlays, dialogs). Default 12px. Pair with a semi-transparent background.",
      "value": "12px",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-body-color",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "body",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Text color for body copy. Alias of --sf-color-text. Override here to deviate body text from the global text color.",
      "value": "var(--sf-color-text)",
      "aliasOf": "--sf-color-text",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-body-em-style",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "body",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "font-style for <em> inside body text (italic by default). Override to suppress italics if your typeface has no italic variant.",
      "value": "italic",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-body-font-family",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "body",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Font family for body text. Alias of --sf-font-body.",
      "value": "var(--sf-font-body)",
      "aliasOf": "--sf-font-body",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-body-font-size",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "body",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Base font size for body paragraphs. Alias of --sf-text-m.",
      "value": "var(--sf-text-m)",
      "aliasOf": "--sf-text-m",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-body-font-weight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "body",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Font weight for body text. Alias of --sf-font-weight-body.",
      "value": "var(--sf-font-weight-body)",
      "aliasOf": "--sf-font-weight-body",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-body-line-height",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "body",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Line height for body paragraphs. Alias of --sf-leading-normal.",
      "value": "var(--sf-leading-normal)",
      "aliasOf": "--sf-leading-normal",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-body-strong-weight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "body",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Font weight for <strong> inside body text. Override to choose a specific weight instead of inheriting bold.",
      "value": "var(--sf-font-weight-strong)",
      "aliasOf": "--sf-font-weight-strong",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-body-text-wrap",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "body",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "text-wrap mode for body paragraphs. 'pretty' prevents orphaned last words; 'balance' equalises line lengths.",
      "value": "pretty",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-border",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "border",
      "category": "Core tokens",
      "group": "Border shorthands",
      "description": "Ready-to-use border shorthand values (width + style + color) for the three most common border weights.",
      "note": "Default border shorthand (width + solid + color). Apply directly to border property.",
      "value": "var(--sf-border-width-1) var(--sf-border-style) var(--sf-color-border)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-border-scale",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "border",
      "category": "Core tokens",
      "group": "Border widths",
      "description": "Raw border-width values. Use the shorthands above unless you need to override just the width.",
      "note": "Global border-width multiplier. Set to 0 for borderless UI; 0.5 for hairline-only; 2 to double all border widths across the system.",
      "value": "1",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-border-strong",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "border",
      "category": "Core tokens",
      "group": "Border shorthands",
      "description": "Ready-to-use border shorthand values (width + style + color) for the three most common border weights.",
      "note": "Strong-emphasis border shorthand.",
      "value": "var(--sf-border-width-1) var(--sf-border-style) var(--sf-color-border--strong)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-border-style",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "border",
      "category": "Core tokens",
      "group": "Border style",
      "description": "Global border-style default (solid, dashed, etc.).",
      "note": "Global border-style default applied across all border tokens.",
      "value": "solid",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-border-subtle",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "border",
      "category": "Core tokens",
      "group": "Border shorthands",
      "description": "Ready-to-use border shorthand values (width + style + color) for the three most common border weights.",
      "note": "Low-contrast subtle border shorthand.",
      "value": "var(--sf-border-width-1) var(--sf-border-style) var(--sf-color-border--subtle)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-border-width-1",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "border",
      "category": "Core tokens",
      "group": "Border widths",
      "description": "Raw border-width values. Use the shorthands above unless you need to override just the width.",
      "note": "Standard 1px border width.",
      "value": "calc(1px * var(--sf-border-scale, 1))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-border-width-2",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "border",
      "category": "Core tokens",
      "group": "Border widths",
      "description": "Raw border-width values. Use the shorthands above unless you need to override just the width.",
      "note": "Medium 2px border width. Common for focus outlines.",
      "value": "calc(2px * var(--sf-border-scale, 1))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-border-width-3",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "border",
      "category": "Core tokens",
      "group": "Border widths",
      "description": "Raw border-width values. Use the shorthands above unless you need to override just the width.",
      "note": "Thick 3px border width.",
      "value": "calc(3px * var(--sf-border-scale, 1))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-border-width-4",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "border",
      "category": "Core tokens",
      "group": "Border widths",
      "description": "Raw border-width values. Use the shorthands above unless you need to override just the width.",
      "note": "Extra-thick 4px border width for decorative borders.",
      "value": "calc(4px * var(--sf-border-scale, 1))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-border-width-hairline",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "border",
      "category": "Core tokens",
      "group": "Border widths",
      "description": "Raw border-width values. Use the shorthands above unless you need to override just the width.",
      "note": "~0.5px hairline border. Browsers snap border-width to the nearest device pixel (rounding up to a minimum of 1 device pixel), so the rendered width is device-pixel- and browser-dependent: on 1x DPR it rounds up to 1px (visually matching --sf-border-width-1); at DPRs where 0.5px lands on a whole device-pixel boundary (2x, 4x, …) it renders as a true 0.5px hairline; at other DPRs (e.g. 3x) the snapped result is close to but not exactly 0.5px. Use for subtle separators where sub-pixel precision doesn't matter.",
      "value": "0.5px",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-box-border-color",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "box",
      "category": "Layout tokens",
      "group": "Box",
      "description": "Border, background, and padding tokens for the box layout primitive.",
      "note": "Border color for the box layout primitive.",
      "value": "var(--sf-color-border)",
      "aliasOf": "--sf-color-border",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-box-border-width",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "box",
      "category": "Layout tokens",
      "group": "Box",
      "description": "Border, background, and padding tokens for the box layout primitive.",
      "note": "Border width for the box layout primitive.",
      "value": "0",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-box-padding",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "box",
      "category": "Layout tokens",
      "group": "Box",
      "description": "Border, background, and padding tokens for the box layout primitive.",
      "note": "Inner padding for the box layout primitive.",
      "value": "var(--sf-space-m)",
      "aliasOf": "--sf-space-m",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-breakout-width",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "breakout",
      "category": "Layout tokens",
      "group": "Content grid (breakout pattern)",
      "description": "Breakout width and content width for the content-grid pattern (full-bleed breakouts inside a constrained column).",
      "note": "Width of full-bleed breakout elements inside a content grid.",
      "value": "var(--sf-container-wide)",
      "aliasOf": "--sf-container-wide",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-btn-border-width",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Border thickness for .sf-btn (used by all fill, outline, and secondary treatments).",
      "value": "var(--sf-border-width-1)",
      "aliasOf": "--sf-border-width-1",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-font-scale",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Uniform label-size multiplier for .sf-btn — scales every size's font-size by one factor while keeping the xs…xl ladder intact. The everyday 'bigger/smaller button text' knob.",
      "value": "1",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-font-size",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Flatten-all label font-size for .sf-btn — once set it overrides every size (--xs/--s/--l/--xl) to the same value. For proportional sizing use --sf-btn-font-scale; to retune a single rung use --sf-btn-{size}-font-size.",
      "value": "initial",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-font-weight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Label font-weight for .sf-btn. Defaults to the interactive weight.",
      "value": "var(--sf-font-weight-interactive)",
      "aliasOf": "--sf-font-weight-interactive",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-gap",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Gap between an icon and the label inside .sf-btn.",
      "value": "var(--sf-space-2xs)",
      "aliasOf": "--sf-space-2xs",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-l-font-size",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Label font-size for the large button (.sf-btn--l). Unset, falls through to --sf-text-l; set to retune this rung without touching the others.",
      "value": "initial",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-l-min-height",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Minimum target height for the large button (.sf-btn--l). Unset, falls through to that rung's scale default; set to retune this rung alone.",
      "value": "initial",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-l-padding-block",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Vertical (block) padding for the large button (.sf-btn--l). Unset, falls through to that rung's scale default; set to retune this rung alone.",
      "value": "initial",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-l-padding-inline",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Horizontal (inline) padding for the large button (.sf-btn--l). Unset, falls through to that rung's scale default; set to retune this rung alone.",
      "value": "initial",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-m-font-size",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Label font-size for the default (medium) button (.sf-btn). Unset, falls through to --sf-text-m; set to retune this rung without touching the others.",
      "value": "initial",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-m-min-height",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Minimum target height for the default (medium) button (.sf-btn). Unset, falls through to that rung's scale default; set to retune this rung alone.",
      "value": "initial",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-m-padding-block",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Vertical (block) padding for the default (medium) button (.sf-btn). Unset, falls through to that rung's scale default; set to retune this rung alone.",
      "value": "initial",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-m-padding-inline",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Horizontal (inline) padding for the default (medium) button (.sf-btn). Unset, falls through to that rung's scale default; set to retune this rung alone.",
      "value": "initial",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-min-height",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Flatten-all minimum target height for .sf-btn — once set it overrides every size to the same value. For per-rung control use --sf-btn-{size}-min-height.",
      "value": "initial",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-padding-block",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Flatten-all vertical (block) padding for .sf-btn — once set it overrides every size to the same value. For per-rung control use --sf-btn-{size}-padding-block.",
      "value": "initial",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-padding-inline",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Flatten-all horizontal (inline) padding for .sf-btn — once set it overrides every size to the same value. For per-rung control use --sf-btn-{size}-padding-inline.",
      "value": "initial",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-radius",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Corner radius for .sf-btn. Defaults to --sf-radius-m; gives buttons a distinct radius from form fields without touching global tokens.",
      "value": "var(--sf-radius-m)",
      "aliasOf": "--sf-radius-m",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-s-font-size",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Label font-size for the small button (.sf-btn--s). Unset, falls through to --sf-text-s; set to retune this rung without touching the others.",
      "value": "initial",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-s-min-height",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Minimum target height for the small button (.sf-btn--s). Unset, falls through to that rung's scale default; set to retune this rung alone.",
      "value": "initial",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-s-padding-block",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Vertical (block) padding for the small button (.sf-btn--s). Unset, falls through to that rung's scale default; set to retune this rung alone.",
      "value": "initial",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-s-padding-inline",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Horizontal (inline) padding for the small button (.sf-btn--s). Unset, falls through to that rung's scale default; set to retune this rung alone.",
      "value": "initial",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-xl-font-size",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Label font-size for the extra-large button (.sf-btn--xl). Unset, falls through to --sf-text-xl; set to retune this rung without touching the others.",
      "value": "initial",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-xl-min-height",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Minimum target height for the extra-large button (.sf-btn--xl). Unset, falls through to that rung's scale default; set to retune this rung alone.",
      "value": "initial",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-xl-padding-block",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Vertical (block) padding for the extra-large button (.sf-btn--xl). Unset, falls through to that rung's scale default; set to retune this rung alone.",
      "value": "initial",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-xl-padding-inline",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Horizontal (inline) padding for the extra-large button (.sf-btn--xl). Unset, falls through to that rung's scale default; set to retune this rung alone.",
      "value": "initial",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-xs-font-size",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Label font-size for the extra-small button (.sf-btn--xs). Unset, falls through to --sf-text-xs; set to retune this rung without touching the others.",
      "value": "initial",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-xs-min-height",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Minimum target height for the extra-small button (.sf-btn--xs). Unset, falls through to that rung's scale default; set to retune this rung alone.",
      "value": "initial",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-xs-padding-block",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Vertical (block) padding for the extra-small button (.sf-btn--xs). Unset, falls through to that rung's scale default; set to retune this rung alone.",
      "value": "initial",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-btn-xs-padding-inline",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "btn",
      "category": "Component tokens",
      "group": "BUTTON TOKENS",
      "description": "Sizing and geometry tokens — padding, min-height, label size, radius, gap, and border width — that control button appearance, including per-size (xs…xl) knobs. Override these to give buttons a distinct visual language from form fields.",
      "note": "Horizontal (inline) padding for the extra-small button (.sf-btn--xs). Unset, falls through to that rung's scale default; set to retune this rung alone.",
      "value": "initial",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-card-avatar-size",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "card",
      "category": "Component tokens",
      "group": "CARD TOKENS",
      "description": "Diameter of .sf-card__avatar. Defaults to 2.5rem.",
      "note": "Diameter of .sf-card__avatar. Defaults to 2.5rem.",
      "value": "2.5rem",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-card-bg",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "card",
      "category": "Component tokens",
      "group": "CARD TOKENS",
      "description": "Background surface for .sf-card. Defaults to --sf-color-surface.",
      "note": "Background surface for .sf-card. Defaults to --sf-color-surface.",
      "value": "var(--sf-color-surface)",
      "aliasOf": "--sf-color-surface",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-card-border-color",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "card",
      "category": "Component tokens",
      "group": "CARD TOKENS",
      "description": "Border colour for .sf-card. Defaults to --sf-color-border.",
      "note": "Border colour for .sf-card. Defaults to --sf-color-border.",
      "value": "var(--sf-color-border)",
      "aliasOf": "--sf-color-border",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-card-border-width",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "card",
      "category": "Component tokens",
      "group": "CARD TOKENS",
      "description": "Border thickness for .sf-card.",
      "note": "Border thickness for .sf-card.",
      "value": "var(--sf-border-width-1)",
      "aliasOf": "--sf-border-width-1",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-card-gap",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "card",
      "category": "Component tokens",
      "group": "CARD TOKENS",
      "description": "Divider spacing for .sf-card__header / __footer (padding + margin around the rule).",
      "note": "Divider spacing for .sf-card__header / __footer (padding + margin around the rule).",
      "value": "var(--sf-space-m)",
      "aliasOf": "--sf-space-m",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-card-heading-size",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "card",
      "category": "Component tokens",
      "group": "CARD TOKENS",
      "description": "Font-size for .sf-card__title. Defaults to --sf-text-xl.",
      "note": "Font-size for .sf-card__title. Defaults to --sf-text-xl.",
      "value": "var(--sf-text-xl)",
      "aliasOf": "--sf-text-xl",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-card-media-radius",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "card",
      "category": "Component tokens",
      "group": "CARD TOKENS",
      "description": "Corner radius for .sf-card__media. Mirrors the card's inner radius by default.",
      "note": "Corner radius for .sf-card__media. Mirrors the card's inner radius by default.",
      "value": "var(--sf-card-radius, var(--sf-radius-m))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-card-media-ratio",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "card",
      "category": "Component tokens",
      "group": "CARD TOKENS",
      "description": "Aspect ratio for .sf-card__media. Defaults to --sf-ratio-video (16/9).",
      "note": "Aspect ratio for .sf-card__media. Defaults to --sf-ratio-video (16/9).",
      "value": "var(--sf-ratio-video)",
      "aliasOf": "--sf-ratio-video",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-card-padding",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "card",
      "category": "Component tokens",
      "group": "CARD TOKENS",
      "description": "Inner padding for .sf-card. Also feeds the concentric-radius math (outer = inner radius + padding).",
      "note": "Inner padding for .sf-card. Also feeds the concentric-radius math (outer = inner radius + padding).",
      "value": "var(--sf-space-l)",
      "aliasOf": "--sf-space-l",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-card-radius",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "card",
      "category": "Component tokens",
      "group": "CARD TOKENS",
      "description": "Inner radius for .sf-card children such as __media. Combined with padding to derive the outer radius.",
      "note": "Inner radius for .sf-card children such as __media. Combined with padding to derive the outer radius.",
      "value": "var(--sf-radius-m)",
      "aliasOf": "--sf-radius-m",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-card-radius-outer",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "card",
      "category": "Component tokens",
      "group": "CARD TOKENS",
      "description": "Outer corner radius of .sf-card. Concentric with the inner radius: calc(--sf-card-radius + --sf-card-padding).",
      "note": "Outer corner radius of .sf-card. Concentric with the inner radius: calc(--sf-card-radius + --sf-card-padding).",
      "value": "calc(var(--sf-card-radius) + var(--sf-card-padding))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-card-shadow",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "card",
      "category": "Component tokens",
      "group": "CARD TOKENS",
      "description": "Base drop shadow for .sf-card. Defaults to --sf-shadow-s.",
      "note": "Base drop shadow for .sf-card. Defaults to --sf-shadow-s.",
      "value": "var(--sf-shadow-s)",
      "aliasOf": "--sf-shadow-s",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-card-shadow--elevated",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "card",
      "category": "Component tokens",
      "group": "CARD TOKENS",
      "description": "Drop shadow applied by the .sf-card--elevated modifier (border hidden, larger shadow).",
      "note": "Drop shadow applied by the .sf-card--elevated modifier (border hidden, larger shadow).",
      "value": "var(--sf-shadow-l)",
      "aliasOf": "--sf-shadow-l",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-card-shadow--hover",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "card",
      "category": "Component tokens",
      "group": "CARD TOKENS",
      "description": "Drop shadow applied on hover/focus by the .sf-card--interactive modifier.",
      "note": "Drop shadow applied on hover/focus by the .sf-card--interactive modifier.",
      "value": "var(--sf-shadow-l)",
      "aliasOf": "--sf-shadow-l",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-center-gutter",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "center",
      "category": "Layout tokens",
      "group": "Center",
      "description": "Max-width and gutter for the center layout primitive.",
      "note": "Minimum side gutter for the center layout.",
      "value": "var(--sf-gutter)",
      "aliasOf": "--sf-gutter",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-center-max",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "center",
      "category": "Layout tokens",
      "group": "Center",
      "description": "Max-width and gutter for the center layout primitive.",
      "note": "Maximum width for the center layout.",
      "value": "var(--sf-container-default)",
      "aliasOf": "--sf-container-default",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-cluster-align",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "cluster",
      "category": "Layout tokens",
      "group": "Cluster",
      "description": "Configuration tokens for the cluster layout (inline wrapped items).",
      "note": "Vertical alignment of cluster items (align-items value).",
      "value": "center",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-cluster-gap",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "cluster",
      "category": "Layout tokens",
      "group": "Cluster",
      "description": "Configuration tokens for the cluster layout (inline wrapped items).",
      "note": "Gap between wrapped inline items in the cluster layout.",
      "value": "var(--sf-gap)",
      "aliasOf": "--sf-gap",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-cluster-justify",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "cluster",
      "category": "Layout tokens",
      "group": "Cluster",
      "description": "Configuration tokens for the cluster layout (inline wrapped items).",
      "note": "Horizontal justification of the cluster (justify-content value).",
      "value": "flex-start",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-code-font-size",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "code",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Font size for inline <code> and <pre>. Usually slightly smaller than body text so monospace doesn't feel oversized.",
      "value": "0.875em",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "DARK SOURCE TOKENS (-dark, animatable)",
      "description": "OKLCH dark source tokens for brand and status colors. Registered as typed <color> so scoped [data-theme=\"dark\"] sections inherit correct absolute values rather than an unresolved var() text string.",
      "note": "Primary interactive color. Applied to filled buttons, active indicators, and brand accent surfaces.",
      "value": "light-dark(var(--sf-color-action-source-light), var(--sf-color-action-source-dark, oklch(from var(--sf-color-action-source-light) clamp(0.65, calc(0.95 - l * 0.5), 0.88) calc(c * 0.9) h)))",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action--active",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "action",
      "description": "Semantic action-color scale derived from --sf-color-action. Covers fills, hover/active states, and tint variants for primary interactive elements.",
      "note": "Action color at pressed/active brightness.",
      "value": "var(--sf-color-action-xdark)",
      "aliasOf": "--sf-color-action-xdark",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action--hover",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "action",
      "description": "Semantic action-color scale derived from --sf-color-action. Covers fills, hover/active states, and tint variants for primary interactive elements.",
      "note": "Action color at hover brightness.",
      "value": "var(--sf-color-action-darker)",
      "aliasOf": "--sf-color-action-darker",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action-100",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "action",
      "description": "Semantic action-color scale derived from --sf-color-action. Covers fills, hover/active states, and tint variants for primary interactive elements.",
      "note": "Very light action shade. Hover fills on white surfaces, badge backgrounds.",
      "value": "oklch(from var(--sf-color-action) max(l, calc(l + (var(--sf-palette-tint-l) - l) * 0.88)) calc(c * 0.3) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action-200",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "action",
      "description": "Semantic action-color scale derived from --sf-color-action. Covers fills, hover/active states, and tint variants for primary interactive elements.",
      "note": "Light action shade. Subtle fills and outlined badge backgrounds.",
      "value": "oklch(from var(--sf-color-action) max(l, calc(l + (var(--sf-palette-tint-l) - l) * 0.72)) calc(c * 0.5) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action-300",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "action",
      "description": "Semantic action-color scale derived from --sf-color-action. Covers fills, hover/active states, and tint variants for primary interactive elements.",
      "note": "Light-mid action shade. Borders on light backgrounds, low-emphasis fills.",
      "value": "oklch(from var(--sf-color-action) max(l, calc(l + (var(--sf-palette-tint-l) - l) * 0.52)) calc(c * 0.72) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action-400",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "action",
      "description": "Semantic action-color scale derived from --sf-color-action. Covers fills, hover/active states, and tint variants for primary interactive elements.",
      "note": "Mid-light action shade. Disabled state fills, decorative accents.",
      "value": "oklch(from var(--sf-color-action) max(l, calc(l + (var(--sf-palette-tint-l) - l) * 0.3)) calc(c * 0.88) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action-50",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "action",
      "description": "Semantic action-color scale derived from --sf-color-action. Covers fills, hover/active states, and tint variants for primary interactive elements.",
      "note": "Lightest action tint. Background fill for subtle action-tinted surfaces.",
      "value": "oklch(from var(--sf-color-action) max(l, calc(l + (var(--sf-palette-tint-l) - l) * 0.95)) calc(c * 0.2) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action-500",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "action",
      "description": "Semantic action-color scale derived from --sf-color-action. Covers fills, hover/active states, and tint variants for primary interactive elements.",
      "note": "Mid action shade — the 'pure' hue. Accessible on both light and dark backgrounds.",
      "value": "var(--sf-color-action)",
      "aliasOf": "--sf-color-action",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action-600",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "action",
      "description": "Semantic action-color scale derived from --sf-color-action. Covers fills, hover/active states, and tint variants for primary interactive elements.",
      "note": "Mid-dark action shade. Text on light surfaces, icon fills.",
      "value": "oklch(from var(--sf-color-action) min(l, calc(l + (var(--sf-palette-shade-l) - l) * 0.16)) calc(c * 0.96) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action-700",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "action",
      "description": "Semantic action-color scale derived from --sf-color-action. Covers fills, hover/active states, and tint variants for primary interactive elements.",
      "note": "Dark action shade. Strong text and icon fills on light backgrounds.",
      "value": "oklch(from var(--sf-color-action) min(l, calc(l + (var(--sf-palette-shade-l) - l) * 0.36)) calc(c * 0.88) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action-800",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "action",
      "description": "Semantic action-color scale derived from --sf-color-action. Covers fills, hover/active states, and tint variants for primary interactive elements.",
      "note": "Very dark action shade. High-contrast text on white.",
      "value": "oklch(from var(--sf-color-action) min(l, calc(l + (var(--sf-palette-shade-l) - l) * 0.58)) calc(c * 0.72) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action-900",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "action",
      "description": "Semantic action-color scale derived from --sf-color-action. Covers fills, hover/active states, and tint variants for primary interactive elements.",
      "note": "Near-black action shade. Extreme contrast on white surfaces.",
      "value": "oklch(from var(--sf-color-action) min(l, calc(l + (var(--sf-palette-shade-l) - l) * 0.78)) calc(c * 0.52) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action-950",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "action",
      "description": "Semantic action-color scale derived from --sf-color-action. Covers fills, hover/active states, and tint variants for primary interactive elements.",
      "note": "Darkest action tint. Near-black for dark-theme surface accents.",
      "value": "oklch(from var(--sf-color-action) min(l, calc(l + (var(--sf-palette-shade-l) - l) * 0.9)) calc(c * 0.38) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action-a10",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "action",
      "description": "Semantic action-color scale derived from --sf-color-action. Covers fills, hover/active states, and tint variants for primary interactive elements.",
      "note": "10% opacity action tint. Subtle hover or selected-row background.",
      "value": "oklch(from var(--sf-color-action) l c h / 0.10)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action-a30",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "action",
      "description": "Semantic action-color scale derived from --sf-color-action. Covers fills, hover/active states, and tint variants for primary interactive elements.",
      "note": "30% opacity action tint.",
      "value": "oklch(from var(--sf-color-action) l c h / 0.30)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action-a5",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "action",
      "description": "Semantic action-color scale derived from --sf-color-action. Covers fills, hover/active states, and tint variants for primary interactive elements.",
      "note": "5% opacity action tint. Barely-there hover highlight.",
      "value": "oklch(from var(--sf-color-action) l c h / 0.05)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action-a50",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "action",
      "description": "Semantic action-color scale derived from --sf-color-action. Covers fills, hover/active states, and tint variants for primary interactive elements.",
      "note": "50% opacity action tint. Mid-transparency badge or overlay.",
      "value": "oklch(from var(--sf-color-action) l c h / 0.50)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action-a80",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "action",
      "description": "Semantic action-color scale derived from --sf-color-action. Covers fills, hover/active states, and tint variants for primary interactive elements.",
      "note": "80% opacity action tint.",
      "value": "oklch(from var(--sf-color-action) l c h / 0.80)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action-darker",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "action",
      "description": "Semantic action-color scale derived from --sf-color-action. Covers fills, hover/active states, and tint variants for primary interactive elements.",
      "note": "Deep action shade — alias of --sf-color-action-600.",
      "value": "var(--sf-color-action-600)",
      "aliasOf": "--sf-color-action-600",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action-lighter",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "action",
      "description": "Semantic action-color scale derived from --sf-color-action. Covers fills, hover/active states, and tint variants for primary interactive elements.",
      "note": "Light action shade for soft accents — alias of --sf-color-action-400.",
      "value": "var(--sf-color-action-400)",
      "aliasOf": "--sf-color-action-400",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action-muted",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "action",
      "description": "Semantic action-color scale derived from --sf-color-action. Covers fills, hover/active states, and tint variants for primary interactive elements.",
      "note": "Medium action fill — outlined button hover backgrounds.",
      "value": "var(--sf-color-action-a30)",
      "aliasOf": "--sf-color-action-a30",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action-source-dark",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "color",
      "category": "Core tokens",
      "group": "DARK SOURCE TOKENS (-dark, animatable)",
      "description": "OKLCH dark source tokens for brand and status colors. Registered as typed <color> so scoped [data-theme=\"dark\"] sections inherit correct absolute values rather than an unresolved var() text string.",
      "note": "Registered <color> dark counterpart of --sf-color-action. Enables smooth CSS transitions when toggling between light and dark mode; without <color> registration the browser cannot interpolate and transitions snap at 50%.",
      "value": "oklch(0.70 0.198 235)",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action-source-light",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "color",
      "category": "Core tokens",
      "group": "BRAND COLORS (-source-light source tokens, animatable)",
      "description": "OKLCH lightness source for the action color. Animate this to smoothly transition between light and dark brand themes.",
      "note": "OKLCH lightness source for the action color. Animate this to smoothly transition between light and dark brand themes.",
      "value": "oklch(0.50 0.22 235)",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action-subtle",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "action",
      "description": "Semantic action-color scale derived from --sf-color-action. Covers fills, hover/active states, and tint variants for primary interactive elements.",
      "note": "Lightest action tint — selected rows, active nav, chips.",
      "value": "var(--sf-color-action-a10)",
      "aliasOf": "--sf-color-action-a10",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action-superdark",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "action",
      "description": "Semantic action-color scale derived from --sf-color-action. Covers fills, hover/active states, and tint variants for primary interactive elements.",
      "note": "Near-black action shade for maximum contrast on light surfaces — alias of --sf-color-action-950.",
      "value": "var(--sf-color-action-950)",
      "aliasOf": "--sf-color-action-950",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action-superlight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "action",
      "description": "Semantic action-color scale derived from --sf-color-action. Covers fills, hover/active states, and tint variants for primary interactive elements.",
      "note": "Near-white action shade — alias of --sf-color-action-50.",
      "value": "var(--sf-color-action-50)",
      "aliasOf": "--sf-color-action-50",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action-tint",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "action",
      "description": "Semantic action-color scale derived from --sf-color-action. Covers fills, hover/active states, and tint variants for primary interactive elements.",
      "note": "Near-transparent action tint (5% alpha) for hover-state washes and the most subtle backgrounds — alias of --sf-color-action-a5.",
      "value": "var(--sf-color-action-a5)",
      "aliasOf": "--sf-color-action-a5",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action-xdark",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "action",
      "description": "Semantic action-color scale derived from --sf-color-action. Covers fills, hover/active states, and tint variants for primary interactive elements.",
      "note": "Extra-dark action shade — alias of --sf-color-action-800.",
      "value": "var(--sf-color-action-800)",
      "aliasOf": "--sf-color-action-800",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-action-xlight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "action",
      "description": "Semantic action-color scale derived from --sf-color-action. Covers fills, hover/active states, and tint variants for primary interactive elements.",
      "note": "Extra-light action shade — alias of --sf-color-action-200.",
      "value": "var(--sf-color-action-200)",
      "aliasOf": "--sf-color-action-200",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-base",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "DARK SOURCE TOKENS (-dark, animatable)",
      "description": "OKLCH dark source tokens for brand and status colors. Registered as typed <color> so scoped [data-theme=\"dark\"] sections inherit correct absolute values rather than an unresolved var() text string.",
      "note": "Mode-adaptive base surface color. Drives the page canvas and the surface elevation family; not an interactive/brand role.",
      "value": "light-dark(var(--sf-color-base-source-light), var(--sf-color-base-source-dark, oklch(from var(--sf-color-base-source-light) clamp(0.16, calc(1.18 - l), 0.24) calc(c * 0.5) h)))",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-base--active",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "base",
      "description": "Semantic base-color scale derived from --sf-color-base. Covers fills, hover/active states, and tint variants for secondary interactive elements.",
      "note": "Pressed/active surface derived from --sf-color-base for subtle background interactions.",
      "value": "oklch(from var(--sf-color-base) clamp(0.01, calc(l - 0.08 + var(--sf-is-dark) * 0.16), 0.99) c h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-base--hover",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "base",
      "description": "Semantic base-color scale derived from --sf-color-base. Covers fills, hover/active states, and tint variants for secondary interactive elements.",
      "note": "Hover-state surface derived from --sf-color-base for subtle background interactions.",
      "value": "oklch(from var(--sf-color-base) clamp(0.01, calc(l - 0.04 + var(--sf-is-dark) * 0.08), 0.99) c h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-base-100",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "base",
      "description": "Semantic base-color scale derived from --sf-color-base. Covers fills, hover/active states, and tint variants for secondary interactive elements.",
      "note": "Very light base-surface level.",
      "value": "oklch(from var(--sf-color-base) 0.94 c h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-base-200",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "base",
      "description": "Semantic base-color scale derived from --sf-color-base. Covers fills, hover/active states, and tint variants for secondary interactive elements.",
      "note": "Light base-surface level.",
      "value": "oklch(from var(--sf-color-base) 0.88 c h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-base-300",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "base",
      "description": "Semantic base-color scale derived from --sf-color-base. Covers fills, hover/active states, and tint variants for secondary interactive elements.",
      "note": "Light-mid base-surface level.",
      "value": "oklch(from var(--sf-color-base) 0.78 c h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-base-400",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "base",
      "description": "Semantic base-color scale derived from --sf-color-base. Covers fills, hover/active states, and tint variants for secondary interactive elements.",
      "note": "Mid-light base-surface level.",
      "value": "oklch(from var(--sf-color-base) 0.65 c h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-base-50",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "base",
      "description": "Semantic base-color scale derived from --sf-color-base. Covers fills, hover/active states, and tint variants for secondary interactive elements.",
      "note": "Lightest base-surface level.",
      "value": "oklch(from var(--sf-color-base) 0.97 c h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-base-500",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "base",
      "description": "Semantic base-color scale derived from --sf-color-base. Covers fills, hover/active states, and tint variants for secondary interactive elements.",
      "note": "Mid base-surface level.",
      "value": "oklch(from var(--sf-color-base) 0.50 c h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-base-600",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "base",
      "description": "Semantic base-color scale derived from --sf-color-base. Covers fills, hover/active states, and tint variants for secondary interactive elements.",
      "note": "Mid-dark base-surface level.",
      "value": "oklch(from var(--sf-color-base) 0.37 c h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-base-700",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "base",
      "description": "Semantic base-color scale derived from --sf-color-base. Covers fills, hover/active states, and tint variants for secondary interactive elements.",
      "note": "Dark base-surface level.",
      "value": "oklch(from var(--sf-color-base) 0.27 c h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-base-800",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "base",
      "description": "Semantic base-color scale derived from --sf-color-base. Covers fills, hover/active states, and tint variants for secondary interactive elements.",
      "note": "Very dark base-surface level.",
      "value": "oklch(from var(--sf-color-base) 0.17 c h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-base-900",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "base",
      "description": "Semantic base-color scale derived from --sf-color-base. Covers fills, hover/active states, and tint variants for secondary interactive elements.",
      "note": "Near-black base-surface level.",
      "value": "oklch(from var(--sf-color-base) 0.11 c h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-base-950",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "base",
      "description": "Semantic base-color scale derived from --sf-color-base. Covers fills, hover/active states, and tint variants for secondary interactive elements.",
      "note": "Darkest base-surface level.",
      "value": "oklch(from var(--sf-color-base) 0.06 c h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-base-a10",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "base",
      "description": "Semantic base-color scale derived from --sf-color-base. Covers fills, hover/active states, and tint variants for secondary interactive elements.",
      "note": "10% opacity base-surface tint.",
      "value": "oklch(from var(--sf-color-base) l c h / 0.10)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-base-a30",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "base",
      "description": "Semantic base-color scale derived from --sf-color-base. Covers fills, hover/active states, and tint variants for secondary interactive elements.",
      "note": "30% opacity base-surface tint.",
      "value": "oklch(from var(--sf-color-base) l c h / 0.30)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-base-a5",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "base",
      "description": "Semantic base-color scale derived from --sf-color-base. Covers fills, hover/active states, and tint variants for secondary interactive elements.",
      "note": "5% opacity base-surface tint.",
      "value": "oklch(from var(--sf-color-base) l c h / 0.05)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-base-a50",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "base",
      "description": "Semantic base-color scale derived from --sf-color-base. Covers fills, hover/active states, and tint variants for secondary interactive elements.",
      "note": "50% opacity base-surface tint.",
      "value": "oklch(from var(--sf-color-base) l c h / 0.50)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-base-a80",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "base",
      "description": "Semantic base-color scale derived from --sf-color-base. Covers fills, hover/active states, and tint variants for secondary interactive elements.",
      "note": "80% opacity base-surface tint.",
      "value": "oklch(from var(--sf-color-base) l c h / 0.80)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-base-muted",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "base",
      "description": "Semantic base-color scale derived from --sf-color-base. Covers fills, hover/active states, and tint variants for secondary interactive elements.",
      "note": "Medium base-surface fill for muted containers or overlays.",
      "value": "var(--sf-color-base-a30)",
      "aliasOf": "--sf-color-base-a30",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-base-source-dark",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "color",
      "category": "Core tokens",
      "group": "DARK SOURCE TOKENS (-dark, animatable)",
      "description": "OKLCH dark source tokens for brand and status colors. Registered as typed <color> so scoped [data-theme=\"dark\"] sections inherit correct absolute values rather than an unresolved var() text string.",
      "note": "Registered <color> dark counterpart of --sf-color-base. Keep near-black for dark-mode surfaces and elevation offsets.",
      "value": "oklch(0.22 0.003 250)",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-base-source-light",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "color",
      "category": "Core tokens",
      "group": "BRAND COLORS (-source-light source tokens, animatable)",
      "description": "OKLCH source color for the light-mode base surface. Keep near-white so --sf-color-bg, --sf-color-surface, and raised/inset levels have room to separate.",
      "note": "OKLCH source color for the light-mode base surface. Keep near-white so --sf-color-bg, --sf-color-surface, and raised/inset levels have room to separate.",
      "value": "oklch(0.96 0.006 250)",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-base-subtle",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "base",
      "description": "Semantic base-color scale derived from --sf-color-base. Covers fills, hover/active states, and tint variants for secondary interactive elements.",
      "note": "Subtle base-surface tint for low-emphasis backgrounds.",
      "value": "var(--sf-color-base-a10)",
      "aliasOf": "--sf-color-base-a10",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-base-tint",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "base",
      "description": "Semantic base-color scale derived from --sf-color-base. Covers fills, hover/active states, and tint variants for secondary interactive elements.",
      "note": "Near-transparent base-surface tint (5% alpha) for hover-state washes and the most subtle backgrounds — alias of --sf-color-base-a5.",
      "value": "var(--sf-color-base-a5)",
      "aliasOf": "--sf-color-base-a5",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-bg",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Surfaces",
      "description": "Background surface tokens from page-level to raised cards. Layer these to communicate visual depth.",
      "note": "Base page / component background. The canvas all other surfaces layer on top of.",
      "value": "oklch(from var(--sf-color-base) calc(l + 0.02) c h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-bg--active",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Interactive states",
      "description": "Background fills for generic interactive states (hover, focus, active, selected, disabled). Apply to any element that needs state feedback.",
      "note": "Background tint for pressed/active interactive elements.",
      "value": "oklch(from var(--sf-color-neutral) l c h / 0.12)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-bg--disabled",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Interactive states",
      "description": "Background fills for generic interactive states (hover, focus, active, selected, disabled). Apply to any element that needs state feedback.",
      "note": "Background for disabled interactive elements.",
      "value": "var(--sf-color-inset)",
      "aliasOf": "--sf-color-inset",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-bg--focus",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Interactive states",
      "description": "Background fills for generic interactive states (hover, focus, active, selected, disabled). Apply to any element that needs state feedback.",
      "note": "Background tint for focused interactive elements.",
      "value": "oklch(from var(--sf-color-action) l c h / 0.06)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-bg--hover",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Interactive states",
      "description": "Background fills for generic interactive states (hover, focus, active, selected, disabled). Apply to any element that needs state feedback.",
      "note": "Background tint for hovered interactive elements (rows, list items, etc.).",
      "value": "oklch(from var(--sf-color-neutral) l c h / 0.08)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-bg--selected",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Interactive states",
      "description": "Background fills for generic interactive states (hover, focus, active, selected, disabled). Apply to any element that needs state feedback.",
      "note": "Background for selected items (checked rows, active nav links).",
      "value": "oklch(from var(--sf-color-action) l c h / 0.1)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-black",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Selection & backdrop",
      "description": "Absolute reference colors and overlay tints for selections, marks, and backdrops.",
      "note": "Absolute black reference value.",
      "value": "oklch(0% 0 0)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-border",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Borders",
      "description": "Semantic border colors for dividers, component edges, and focus indicators.",
      "note": "Default border for dividers and component edges.",
      "value": "light-dark( oklch(from var(--sf-color-neutral-source-light) clamp(0.70, calc(l + 0.35), 0.95) 0.005 h), oklch(from var(--sf-color-neutral) clamp(0.25, calc(l - 0.3), 0.55) 0.005 h) )",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-border--disabled",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Border alpha tokens",
      "description": "Semi-transparent border variants for overlays and glass-morphism effects.",
      "note": "Semi-transparent border for disabled element edges.",
      "value": "oklch(from var(--sf-color-border--subtle) l 0 h / 0.5)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-border--focus",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Borders",
      "description": "Semantic border colors for dividers, component edges, and focus indicators.",
      "note": "Focus indicator border, used alongside --sf-focus-ring-color.",
      "value": "var(--sf-color-action)",
      "aliasOf": "--sf-color-action",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-border--strong",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Borders",
      "description": "Semantic border colors for dividers, component edges, and focus indicators.",
      "note": "Stronger border for visually prominent edges and active outlines.",
      "value": "light-dark( oklch(from var(--sf-color-neutral-source-light) clamp(0.55, calc(l + 0.1), 0.85) 0.02 h), oklch(from var(--sf-color-neutral) clamp(0.38, calc(l - 0.1), 0.65) 0.02 h) )",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-border--subtle",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Borders",
      "description": "Semantic border colors for dividers, component edges, and focus indicators.",
      "note": "Low-contrast border for subtle separation without strong visual weight.",
      "value": "light-dark( oklch(from var(--sf-color-neutral-source-light) clamp(0.75, calc(l + 0.4), 0.97) 0.005 h), oklch(from var(--sf-color-neutral) clamp(0.20, calc(l - 0.38), 0.45) 0.005 h) )",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-border--translucent",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Border alpha tokens",
      "description": "Semi-transparent border variants for overlays and glass-morphism effects.",
      "note": "Translucent border for glass-morphism and frosted surfaces.",
      "value": "oklch(from var(--sf-color-neutral) l c h / 0.15)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-caret",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Focus / form colors",
      "description": "Focus ring and form caret colors. Centralised here so keyboard navigation is consistently styled.",
      "note": "Cursor caret color inside text inputs and contenteditable elements.",
      "value": "var(--sf-color-action)",
      "aliasOf": "--sf-color-action",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-code-bg",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Interactive states",
      "description": "Background fills for generic interactive states (hover, focus, active, selected, disabled). Apply to any element that needs state feedback.",
      "note": "Background for inline <code> elements. Usually a subtle tint of the inset surface.",
      "value": "var(--sf-color-inset)",
      "aliasOf": "--sf-color-inset",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-code-text",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Text-on-color",
      "description": "Accessible foreground colors guaranteed to pass WCAG contrast on each colored background surface.",
      "note": "Text color for inline code and monospace preformatted text.",
      "value": "oklch(from var(--sf-color-code-bg) clamp(0.1, sign(var(--sf-contrast-threshold) - l) * 999, 0.95) 0 0)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-danger",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "DARK SOURCE TOKENS (-dark, animatable)",
      "description": "OKLCH dark source tokens for brand and status colors. Registered as typed <color> so scoped [data-theme=\"dark\"] sections inherit correct absolute values rather than an unresolved var() text string.",
      "note": "Destructive / danger state color. Used for delete actions, error alerts, and critical warnings.",
      "value": "light-dark(var(--sf-color-danger-source-light), var(--sf-color-danger-source-dark, oklch(from var(--sf-color-danger-source-light) clamp(0.65, calc(0.95 - l * 0.5), 0.88) calc(c * 0.9) h)))",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-danger-muted",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Status triplets",
      "description": "Three-shade status triplets (subtle / muted / strong) for each status role. Use subtle for backgrounds, muted for fills, strong for text on light surfaces.",
      "note": "Medium danger fill for icon backgrounds and badge fills.",
      "value": "oklch(from var(--sf-color-danger) l c h / 0.3)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-danger-source-dark",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "color",
      "category": "Core tokens",
      "group": "DARK SOURCE TOKENS (-dark, animatable)",
      "description": "OKLCH dark source tokens for brand and status colors. Registered as typed <color> so scoped [data-theme=\"dark\"] sections inherit correct absolute values rather than an unresolved var() text string.",
      "note": "Registered <color> dark counterpart of --sf-color-danger.",
      "value": "oklch(0.71 0.198 12)",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-danger-source-light",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "color",
      "category": "Core tokens",
      "group": "STATUS COLORS (-source-light source tokens)",
      "description": "OKLCH lightness source for the danger status color (covers destructive actions and form validation errors).",
      "note": "OKLCH lightness source for the danger status color (covers destructive actions and form validation errors).",
      "value": "oklch(0.48 0.22 12)",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-danger-strong",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Status triplets",
      "description": "Three-shade status triplets (subtle / muted / strong) for each status role. Use subtle for backgrounds, muted for fills, strong for text on light surfaces.",
      "note": "High-contrast danger color for alert body text and icons.",
      "value": "light-dark( oklch(from var(--sf-color-danger-source-light) calc(l - 0.1) c h), oklch(from var(--sf-color-danger) clamp(0.70, calc(l + 0.15), 1) c h) )",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-danger-subtle",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Status triplets",
      "description": "Three-shade status triplets (subtle / muted / strong) for each status role. Use subtle for backgrounds, muted for fills, strong for text on light surfaces.",
      "note": "Light danger tint for error row backgrounds and alert container fills.",
      "value": "oklch(from var(--sf-color-danger) l c h / 0.12)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-danger-tint",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Status triplets",
      "description": "Three-shade status triplets (subtle / muted / strong) for each status role. Use subtle for backgrounds, muted for fills, strong for text on light surfaces.",
      "note": "Near-transparent danger tint (5% alpha) for hover-state washes and the most subtle backgrounds.",
      "value": "oklch(from var(--sf-color-danger) l c h / 0.05)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-dim",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Selection & backdrop",
      "description": "Absolute reference colors and overlay tints for selections, marks, and backdrops.",
      "note": "Backdrop overlay color for modals, drawers, and lightboxes.",
      "value": "oklch(0 0 0 / 0.5)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-heading",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Text",
      "description": "Semantic text colors for every content role. All tokens adapt to light and dark mode automatically.",
      "note": "Heading text color. Slightly stronger contrast than body text for visual hierarchy.",
      "value": "light-dark( oklch(from var(--sf-color-neutral-source-light) clamp(0.05, calc(l - 0.4 - var(--sf-contrast-bias)), 0.35) c h), oklch(from var(--sf-color-neutral) clamp(0.70, calc(l + 0.25 + var(--sf-contrast-bias)), 1) c h) )",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-info",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "DARK SOURCE TOKENS (-dark, animatable)",
      "description": "OKLCH dark source tokens for brand and status colors. Registered as typed <color> so scoped [data-theme=\"dark\"] sections inherit correct absolute values rather than an unresolved var() text string.",
      "note": "Informational color for neutral tips, hints, and non-urgent notices.",
      "value": "light-dark(var(--sf-color-info-source-light), var(--sf-color-info-source-dark, oklch(from var(--sf-color-info-source-light) clamp(0.65, calc(0.95 - l * 0.5), 0.88) calc(c * 0.9) h)))",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-info-muted",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Status triplets",
      "description": "Three-shade status triplets (subtle / muted / strong) for each status role. Use subtle for backgrounds, muted for fills, strong for text on light surfaces.",
      "note": "Medium info fill for info icons and hint chips.",
      "value": "oklch(from var(--sf-color-info) l c h / 0.3)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-info-source-dark",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "color",
      "category": "Core tokens",
      "group": "DARK SOURCE TOKENS (-dark, animatable)",
      "description": "OKLCH dark source tokens for brand and status colors. Registered as typed <color> so scoped [data-theme=\"dark\"] sections inherit correct absolute values rather than an unresolved var() text string.",
      "note": "Registered <color> dark counterpart of --sf-color-info.",
      "value": "oklch(0.71 0.162 235)",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-info-source-light",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "color",
      "category": "Core tokens",
      "group": "STATUS COLORS (-source-light source tokens)",
      "description": "OKLCH lightness source for the info status color.",
      "note": "OKLCH lightness source for the info status color.",
      "value": "oklch(0.48 0.18 235)",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-info-strong",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Status triplets",
      "description": "Three-shade status triplets (subtle / muted / strong) for each status role. Use subtle for backgrounds, muted for fills, strong for text on light surfaces.",
      "note": "High-contrast info color for hint body text.",
      "value": "light-dark( oklch(from var(--sf-color-info-source-light) calc(l - 0.1) c h), oklch(from var(--sf-color-info) clamp(0.70, calc(l + 0.15), 1) c h) )",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-info-subtle",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Status triplets",
      "description": "Three-shade status triplets (subtle / muted / strong) for each status role. Use subtle for backgrounds, muted for fills, strong for text on light surfaces.",
      "note": "Light info tint for informational note backgrounds.",
      "value": "oklch(from var(--sf-color-info) l c h / 0.12)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-info-tint",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Status triplets",
      "description": "Three-shade status triplets (subtle / muted / strong) for each status role. Use subtle for backgrounds, muted for fills, strong for text on light surfaces.",
      "note": "Near-transparent info tint (5% alpha) for hover-state washes and the most subtle backgrounds.",
      "value": "oklch(from var(--sf-color-info) l c h / 0.05)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-inset",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Surfaces",
      "description": "Background surface tokens from page-level to raised cards. Layer these to communicate visual depth.",
      "note": "Slightly inset surface for nested areas — inputs, code blocks, sidebar panels.",
      "value": "oklch(from var(--sf-color-base) calc(l - 0.02) c h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-inverse",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Surfaces",
      "description": "Background surface tokens from page-level to raised cards. Layer these to communicate visual depth.",
      "note": "Inverted (dark-on-light / light-on-dark) surface for high-contrast banners or tooltips.",
      "value": "oklch(from var(--sf-color-base) calc(1 - l) c h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-link",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Links",
      "description": "Colors and text-decoration properties for hyperlinks in every interactive state.",
      "note": "Default hyperlink color.",
      "value": "light-dark( oklch(from var(--sf-color-action) clamp(0, min(l - 0.07, 0.48), 1) c h), oklch(from var(--sf-color-action) clamp(0.68, l, 1) c h) )",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-link--active",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Links",
      "description": "Colors and text-decoration properties for hyperlinks in every interactive state.",
      "note": "Link color when actively pressed.",
      "value": "light-dark( oklch(from var(--sf-color-action) clamp(0, min(l - 0.21, 0.34), 1) c h), oklch(from var(--sf-color-action) clamp(0, max(l + 0.15, 0.74), 1) c h) )",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-link--disabled",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Links",
      "description": "Colors and text-decoration properties for hyperlinks in every interactive state.",
      "note": "Disabled link color (low contrast, no interaction).",
      "value": "var(--sf-color-text--disabled)",
      "aliasOf": "--sf-color-text--disabled",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-link--hover",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Links",
      "description": "Colors and text-decoration properties for hyperlinks in every interactive state.",
      "note": "Link color on hover.",
      "value": "light-dark( oklch(from var(--sf-color-action) clamp(0, min(l - 0.15, 0.40), 1) c h), oklch(from var(--sf-color-action) clamp(0, max(l + 0.10, 0.68), 1) c h) )",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-link--underline",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Link alpha token",
      "description": "Semi-transparent underline color token used to tint the link underline independently from the link text color.",
      "note": "Color of the link underline decoration. Defaults to a semi-transparent variant of the link color.",
      "value": "oklch(from var(--sf-color-action) l c h / 0.3)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-link--visited",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Links",
      "description": "Colors and text-decoration properties for hyperlinks in every interactive state.",
      "note": "Visited link color.",
      "value": "light-dark( oklch(from var(--sf-color-action) clamp(0, min(l - 0.07, 0.48), 1) c calc(h + 60)), oklch(from var(--sf-color-action) clamp(0.68, l, 1) c calc(h + 60)) )",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-mark-bg",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Selection & mark",
      "description": "Background and text colors for browser text selections and <mark> highlights. Adapts automatically in dark mode.",
      "note": "Background color for highlighted <mark> elements.",
      "value": "oklch(from var(--sf-color-warning) l c h / 0.25)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-mark-text",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Selection & backdrop",
      "description": "Absolute reference colors and overlay tints for selections, marks, and backdrops.",
      "note": "Text color inside highlighted <mark> elements.",
      "value": "inherit",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "DARK SOURCE TOKENS (-dark, animatable)",
      "description": "OKLCH dark source tokens for brand and status colors. Registered as typed <color> so scoped [data-theme=\"dark\"] sections inherit correct absolute values rather than an unresolved var() text string.",
      "note": "Neutral interactive color for low-emphasis actions and tertiary buttons.",
      "value": "light-dark(var(--sf-color-neutral-source-light), var(--sf-color-neutral-source-dark, oklch(from var(--sf-color-neutral-source-light) clamp(0.65, calc(0.95 - l * 0.5), 0.88) calc(c * 0.9) h)))",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral--active",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "neutral",
      "description": "Semantic neutral-color scale derived from --sf-color-neutral. Useful for muted UI chrome.",
      "note": "Neutral color at pressed/active brightness.",
      "value": "var(--sf-color-neutral-xdark)",
      "aliasOf": "--sf-color-neutral-xdark",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral--hover",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "neutral",
      "description": "Semantic neutral-color scale derived from --sf-color-neutral. Useful for muted UI chrome.",
      "note": "Neutral color at hover brightness.",
      "value": "var(--sf-color-neutral-darker)",
      "aliasOf": "--sf-color-neutral-darker",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral-100",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "neutral",
      "description": "Semantic neutral-color scale derived from --sf-color-neutral. Useful for muted UI chrome.",
      "note": "Very light neutral shade.",
      "value": "oklch(from var(--sf-color-neutral) max(l, calc(l + (var(--sf-palette-tint-l) - l) * 0.88)) calc(c * 0.3) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral-200",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "neutral",
      "description": "Semantic neutral-color scale derived from --sf-color-neutral. Useful for muted UI chrome.",
      "note": "Light neutral shade at step 200 on the numeric scale. Subtle fills and outlined badge backgrounds.",
      "value": "oklch(from var(--sf-color-neutral) max(l, calc(l + (var(--sf-palette-tint-l) - l) * 0.72)) calc(c * 0.5) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral-300",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "neutral",
      "description": "Semantic neutral-color scale derived from --sf-color-neutral. Useful for muted UI chrome.",
      "note": "Light-mid neutral shade.",
      "value": "oklch(from var(--sf-color-neutral) max(l, calc(l + (var(--sf-palette-tint-l) - l) * 0.52)) calc(c * 0.72) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral-400",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "neutral",
      "description": "Semantic neutral-color scale derived from --sf-color-neutral. Useful for muted UI chrome.",
      "note": "Mid-light neutral shade.",
      "value": "oklch(from var(--sf-color-neutral) max(l, calc(l + (var(--sf-palette-tint-l) - l) * 0.3)) calc(c * 0.88) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral-50",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "neutral",
      "description": "Semantic neutral-color scale derived from --sf-color-neutral. Useful for muted UI chrome.",
      "note": "Lightest neutral tint.",
      "value": "oklch(from var(--sf-color-neutral) max(l, calc(l + (var(--sf-palette-tint-l) - l) * 0.95)) calc(c * 0.2) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral-500",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "neutral",
      "description": "Semantic neutral-color scale derived from --sf-color-neutral. Useful for muted UI chrome.",
      "note": "Mid neutral shade — the 'pure' hue.",
      "value": "var(--sf-color-neutral)",
      "aliasOf": "--sf-color-neutral",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral-600",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "neutral",
      "description": "Semantic neutral-color scale derived from --sf-color-neutral. Useful for muted UI chrome.",
      "note": "Mid-dark neutral shade.",
      "value": "oklch(from var(--sf-color-neutral) min(l, calc(l + (var(--sf-palette-shade-l) - l) * 0.16)) calc(c * 0.96) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral-700",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "neutral",
      "description": "Semantic neutral-color scale derived from --sf-color-neutral. Useful for muted UI chrome.",
      "note": "Dark neutral shade.",
      "value": "oklch(from var(--sf-color-neutral) min(l, calc(l + (var(--sf-palette-shade-l) - l) * 0.36)) calc(c * 0.88) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral-800",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "neutral",
      "description": "Semantic neutral-color scale derived from --sf-color-neutral. Useful for muted UI chrome.",
      "note": "Very dark neutral shade.",
      "value": "oklch(from var(--sf-color-neutral) min(l, calc(l + (var(--sf-palette-shade-l) - l) * 0.58)) calc(c * 0.72) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral-900",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "neutral",
      "description": "Semantic neutral-color scale derived from --sf-color-neutral. Useful for muted UI chrome.",
      "note": "Near-black neutral shade at step 900 on the numeric scale. Extreme contrast on light surfaces.",
      "value": "oklch(from var(--sf-color-neutral) min(l, calc(l + (var(--sf-palette-shade-l) - l) * 0.78)) calc(c * 0.52) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral-950",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "neutral",
      "description": "Semantic neutral-color scale derived from --sf-color-neutral. Useful for muted UI chrome.",
      "note": "Darkest neutral tint.",
      "value": "oklch(from var(--sf-color-neutral) min(l, calc(l + (var(--sf-palette-shade-l) - l) * 0.9)) calc(c * 0.38) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral-a10",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "neutral",
      "description": "Semantic neutral-color scale derived from --sf-color-neutral. Useful for muted UI chrome.",
      "note": "10% opacity neutral tint.",
      "value": "oklch(from var(--sf-color-neutral) l c h / 0.10)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral-a30",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "neutral",
      "description": "Semantic neutral-color scale derived from --sf-color-neutral. Useful for muted UI chrome.",
      "note": "30% opacity neutral tint.",
      "value": "oklch(from var(--sf-color-neutral) l c h / 0.30)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral-a5",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "neutral",
      "description": "Semantic neutral-color scale derived from --sf-color-neutral. Useful for muted UI chrome.",
      "note": "5% opacity neutral tint.",
      "value": "oklch(from var(--sf-color-neutral) l c h / 0.05)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral-a50",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "neutral",
      "description": "Semantic neutral-color scale derived from --sf-color-neutral. Useful for muted UI chrome.",
      "note": "50% opacity neutral tint.",
      "value": "oklch(from var(--sf-color-neutral) l c h / 0.50)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral-a80",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "neutral",
      "description": "Semantic neutral-color scale derived from --sf-color-neutral. Useful for muted UI chrome.",
      "note": "80% opacity neutral tint.",
      "value": "oklch(from var(--sf-color-neutral) l c h / 0.80)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral-darker",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "neutral",
      "description": "Semantic neutral-color scale derived from --sf-color-neutral. Useful for muted UI chrome.",
      "note": "Deep neutral shade — alias of --sf-color-neutral-600.",
      "value": "var(--sf-color-neutral-600)",
      "aliasOf": "--sf-color-neutral-600",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral-lighter",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "neutral",
      "description": "Semantic neutral-color scale derived from --sf-color-neutral. Useful for muted UI chrome.",
      "note": "Light neutral shade for soft accents — alias of --sf-color-neutral-400.",
      "value": "var(--sf-color-neutral-400)",
      "aliasOf": "--sf-color-neutral-400",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral-muted",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "neutral",
      "description": "Semantic neutral-color scale derived from --sf-color-neutral. Useful for muted UI chrome.",
      "note": "Muted neutral fill for low-emphasis contexts.",
      "value": "var(--sf-color-neutral-a30)",
      "aliasOf": "--sf-color-neutral-a30",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral-source-dark",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "color",
      "category": "Core tokens",
      "group": "DARK SOURCE TOKENS (-dark, animatable)",
      "description": "OKLCH dark source tokens for brand and status colors. Registered as typed <color> so scoped [data-theme=\"dark\"] sections inherit correct absolute values rather than an unresolved var() text string.",
      "note": "Registered <color> dark counterpart of --sf-color-neutral.",
      "value": "oklch(0.69 0.0225 260)",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral-source-light",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "color",
      "category": "Core tokens",
      "group": "BRAND COLORS (-source-light source tokens, animatable)",
      "description": "OKLCH lightness source for the neutral color.",
      "note": "OKLCH lightness source for the neutral color.",
      "value": "oklch(0.52 0.025 260)",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral-subtle",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "neutral",
      "description": "Semantic neutral-color scale derived from --sf-color-neutral. Useful for muted UI chrome.",
      "note": "Lightest neutral semantic tint.",
      "value": "var(--sf-color-neutral-a10)",
      "aliasOf": "--sf-color-neutral-a10",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral-superdark",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "neutral",
      "description": "Semantic neutral-color scale derived from --sf-color-neutral. Useful for muted UI chrome.",
      "note": "Near-black neutral shade for maximum contrast on light surfaces — alias of --sf-color-neutral-950.",
      "value": "var(--sf-color-neutral-950)",
      "aliasOf": "--sf-color-neutral-950",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral-superlight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "neutral",
      "description": "Semantic neutral-color scale derived from --sf-color-neutral. Useful for muted UI chrome.",
      "note": "Near-white neutral shade — alias of --sf-color-neutral-50.",
      "value": "var(--sf-color-neutral-50)",
      "aliasOf": "--sf-color-neutral-50",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral-tint",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "neutral",
      "description": "Semantic neutral-color scale derived from --sf-color-neutral. Useful for muted UI chrome.",
      "note": "Near-transparent neutral tint (5% alpha) for hover-state washes and the most subtle backgrounds — alias of --sf-color-neutral-a5.",
      "value": "var(--sf-color-neutral-a5)",
      "aliasOf": "--sf-color-neutral-a5",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral-xdark",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "neutral",
      "description": "Semantic neutral-color scale derived from --sf-color-neutral. Useful for muted UI chrome.",
      "note": "Extra-dark neutral shade — alias of --sf-color-neutral-800.",
      "value": "var(--sf-color-neutral-800)",
      "aliasOf": "--sf-color-neutral-800",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-neutral-xlight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "neutral",
      "description": "Semantic neutral-color scale derived from --sf-color-neutral. Useful for muted UI chrome.",
      "note": "Extra-light neutral shade — alias of --sf-color-neutral-200.",
      "value": "var(--sf-color-neutral-200)",
      "aliasOf": "--sf-color-neutral-200",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-overlay",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Surfaces",
      "description": "Background surface tokens from page-level to raised cards. Layer these to communicate visual depth.",
      "note": "Overlay surface for floating panels, sheets, and modals.",
      "value": "oklch(from var(--sf-color-base) l c h / 0.9)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "DARK SOURCE TOKENS (-dark, animatable)",
      "description": "OKLCH dark source tokens for brand and status colors. Registered as typed <color> so scoped [data-theme=\"dark\"] sections inherit correct absolute values rather than an unresolved var() text string.",
      "note": "Primary brand palette color. Independent from --sf-color-action by default; override either source token to couple or separate brand and action roles.",
      "value": "light-dark(var(--sf-color-primary-source-light), var(--sf-color-primary-source-dark, oklch(from var(--sf-color-primary-source-light) clamp(0.65, calc(0.95 - l * 0.5), 0.88) calc(c * 0.9) h)))",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary--active",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "primary",
      "description": "Semantic primary-color scale derived from --sf-color-primary. Covers fills, hover/active states, and tint variants for the primary palette role.",
      "note": "Primary color at pressed/active brightness.",
      "value": "var(--sf-color-primary-xdark)",
      "aliasOf": "--sf-color-primary-xdark",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary--hover",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "primary",
      "description": "Semantic primary-color scale derived from --sf-color-primary. Covers fills, hover/active states, and tint variants for the primary palette role.",
      "note": "Primary color at hover brightness.",
      "value": "var(--sf-color-primary-darker)",
      "aliasOf": "--sf-color-primary-darker",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary-100",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "primary",
      "description": "Semantic primary-color scale derived from --sf-color-primary. Covers fills, hover/active states, and tint variants for the primary palette role.",
      "note": "Very light primary shade.",
      "value": "oklch(from var(--sf-color-primary) max(l, calc(l + (var(--sf-palette-tint-l) - l) * 0.88)) calc(c * 0.3) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary-200",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "primary",
      "description": "Semantic primary-color scale derived from --sf-color-primary. Covers fills, hover/active states, and tint variants for the primary palette role.",
      "note": "Light primary shade at step 200 on the numeric scale. Subtle fills and outlined badge backgrounds.",
      "value": "oklch(from var(--sf-color-primary) max(l, calc(l + (var(--sf-palette-tint-l) - l) * 0.72)) calc(c * 0.5) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary-300",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "primary",
      "description": "Semantic primary-color scale derived from --sf-color-primary. Covers fills, hover/active states, and tint variants for the primary palette role.",
      "note": "Light-mid primary shade.",
      "value": "oklch(from var(--sf-color-primary) max(l, calc(l + (var(--sf-palette-tint-l) - l) * 0.52)) calc(c * 0.72) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary-400",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "primary",
      "description": "Semantic primary-color scale derived from --sf-color-primary. Covers fills, hover/active states, and tint variants for the primary palette role.",
      "note": "Mid-light primary shade.",
      "value": "oklch(from var(--sf-color-primary) max(l, calc(l + (var(--sf-palette-tint-l) - l) * 0.3)) calc(c * 0.88) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary-50",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "primary",
      "description": "Semantic primary-color scale derived from --sf-color-primary. Covers fills, hover/active states, and tint variants for the primary palette role.",
      "note": "Lightest primary tint.",
      "value": "oklch(from var(--sf-color-primary) max(l, calc(l + (var(--sf-palette-tint-l) - l) * 0.95)) calc(c * 0.2) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary-500",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "primary",
      "description": "Semantic primary-color scale derived from --sf-color-primary. Covers fills, hover/active states, and tint variants for the primary palette role.",
      "note": "Mid primary shade — the 'pure' hue.",
      "value": "var(--sf-color-primary)",
      "aliasOf": "--sf-color-primary",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary-600",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "primary",
      "description": "Semantic primary-color scale derived from --sf-color-primary. Covers fills, hover/active states, and tint variants for the primary palette role.",
      "note": "Mid-dark primary shade.",
      "value": "oklch(from var(--sf-color-primary) min(l, calc(l + (var(--sf-palette-shade-l) - l) * 0.16)) calc(c * 0.96) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary-700",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "primary",
      "description": "Semantic primary-color scale derived from --sf-color-primary. Covers fills, hover/active states, and tint variants for the primary palette role.",
      "note": "Dark primary shade.",
      "value": "oklch(from var(--sf-color-primary) min(l, calc(l + (var(--sf-palette-shade-l) - l) * 0.36)) calc(c * 0.88) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary-800",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "primary",
      "description": "Semantic primary-color scale derived from --sf-color-primary. Covers fills, hover/active states, and tint variants for the primary palette role.",
      "note": "Very dark primary shade.",
      "value": "oklch(from var(--sf-color-primary) min(l, calc(l + (var(--sf-palette-shade-l) - l) * 0.58)) calc(c * 0.72) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary-900",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "primary",
      "description": "Semantic primary-color scale derived from --sf-color-primary. Covers fills, hover/active states, and tint variants for the primary palette role.",
      "note": "Near-black primary shade at step 900 on the numeric scale. Extreme contrast on light surfaces.",
      "value": "oklch(from var(--sf-color-primary) min(l, calc(l + (var(--sf-palette-shade-l) - l) * 0.78)) calc(c * 0.52) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary-950",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "primary",
      "description": "Semantic primary-color scale derived from --sf-color-primary. Covers fills, hover/active states, and tint variants for the primary palette role.",
      "note": "Darkest primary tint.",
      "value": "oklch(from var(--sf-color-primary) min(l, calc(l + (var(--sf-palette-shade-l) - l) * 0.9)) calc(c * 0.38) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary-a10",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "primary",
      "description": "Semantic primary-color scale derived from --sf-color-primary. Covers fills, hover/active states, and tint variants for the primary palette role.",
      "note": "10% opacity primary tint.",
      "value": "oklch(from var(--sf-color-primary) l c h / 0.10)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary-a30",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "primary",
      "description": "Semantic primary-color scale derived from --sf-color-primary. Covers fills, hover/active states, and tint variants for the primary palette role.",
      "note": "30% opacity primary tint.",
      "value": "oklch(from var(--sf-color-primary) l c h / 0.30)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary-a5",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "primary",
      "description": "Semantic primary-color scale derived from --sf-color-primary. Covers fills, hover/active states, and tint variants for the primary palette role.",
      "note": "5% opacity primary tint.",
      "value": "oklch(from var(--sf-color-primary) l c h / 0.05)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary-a50",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "primary",
      "description": "Semantic primary-color scale derived from --sf-color-primary. Covers fills, hover/active states, and tint variants for the primary palette role.",
      "note": "50% opacity primary tint.",
      "value": "oklch(from var(--sf-color-primary) l c h / 0.50)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary-a80",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "primary",
      "description": "Semantic primary-color scale derived from --sf-color-primary. Covers fills, hover/active states, and tint variants for the primary palette role.",
      "note": "80% opacity primary tint.",
      "value": "oklch(from var(--sf-color-primary) l c h / 0.80)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary-darker",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "primary",
      "description": "Semantic primary-color scale derived from --sf-color-primary. Covers fills, hover/active states, and tint variants for the primary palette role.",
      "note": "Deep primary shade — alias of --sf-color-primary-600.",
      "value": "var(--sf-color-primary-600)",
      "aliasOf": "--sf-color-primary-600",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary-lighter",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "primary",
      "description": "Semantic primary-color scale derived from --sf-color-primary. Covers fills, hover/active states, and tint variants for the primary palette role.",
      "note": "Light primary shade for soft accents — alias of --sf-color-primary-400.",
      "value": "var(--sf-color-primary-400)",
      "aliasOf": "--sf-color-primary-400",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary-muted",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "primary",
      "description": "Semantic primary-color scale derived from --sf-color-primary. Covers fills, hover/active states, and tint variants for the primary palette role.",
      "note": "Muted primary fill.",
      "value": "var(--sf-color-primary-a30)",
      "aliasOf": "--sf-color-primary-a30",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary-source-dark",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "color",
      "category": "Core tokens",
      "group": "DARK SOURCE TOKENS (-dark, animatable)",
      "description": "OKLCH dark source tokens for brand and status colors. Registered as typed <color> so scoped [data-theme=\"dark\"] sections inherit correct absolute values rather than an unresolved var() text string.",
      "note": "Registered <color> dark counterpart of --sf-color-primary.",
      "value": "oklch(0.715 0.243 264)",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary-source-light",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "color",
      "category": "Core tokens",
      "group": "BRAND COLORS (-source-light source tokens, animatable)",
      "description": "OKLCH lightness source for the primary color.",
      "note": "OKLCH lightness source for the primary color.",
      "value": "oklch(0.47 0.27 264)",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary-subtle",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "primary",
      "description": "Semantic primary-color scale derived from --sf-color-primary. Covers fills, hover/active states, and tint variants for the primary palette role.",
      "note": "Lightest primary semantic tint.",
      "value": "var(--sf-color-primary-a10)",
      "aliasOf": "--sf-color-primary-a10",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary-superdark",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "primary",
      "description": "Semantic primary-color scale derived from --sf-color-primary. Covers fills, hover/active states, and tint variants for the primary palette role.",
      "note": "Near-black primary shade for maximum contrast on light surfaces — alias of --sf-color-primary-950.",
      "value": "var(--sf-color-primary-950)",
      "aliasOf": "--sf-color-primary-950",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary-superlight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "primary",
      "description": "Semantic primary-color scale derived from --sf-color-primary. Covers fills, hover/active states, and tint variants for the primary palette role.",
      "note": "Near-white primary shade — alias of --sf-color-primary-50.",
      "value": "var(--sf-color-primary-50)",
      "aliasOf": "--sf-color-primary-50",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary-tint",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "primary",
      "description": "Semantic primary-color scale derived from --sf-color-primary. Covers fills, hover/active states, and tint variants for the primary palette role.",
      "note": "Near-transparent primary tint (5% alpha) for hover-state washes and the most subtle backgrounds — alias of --sf-color-primary-a5.",
      "value": "var(--sf-color-primary-a5)",
      "aliasOf": "--sf-color-primary-a5",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary-xdark",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "primary",
      "description": "Semantic primary-color scale derived from --sf-color-primary. Covers fills, hover/active states, and tint variants for the primary palette role.",
      "note": "Extra-dark primary shade — alias of --sf-color-primary-800.",
      "value": "var(--sf-color-primary-800)",
      "aliasOf": "--sf-color-primary-800",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-primary-xlight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "primary",
      "description": "Semantic primary-color scale derived from --sf-color-primary. Covers fills, hover/active states, and tint variants for the primary palette role.",
      "note": "Extra-light primary shade — alias of --sf-color-primary-200.",
      "value": "var(--sf-color-primary-200)",
      "aliasOf": "--sf-color-primary-200",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-raised",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Surfaces",
      "description": "Background surface tokens from page-level to raised cards. Layer these to communicate visual depth.",
      "note": "Elevated card surface that floats above the page background.",
      "value": "oklch(from var(--sf-color-base) calc(l + 0.04) c h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-scheme",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Color scheme",
      "description": "Preferred color-scheme hint sent to the browser (light / dark / normal).",
      "note": "Preferred color scheme hint (light / dark / normal). Sent to the browser to influence UA chrome styling.",
      "value": "light dark",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "DARK SOURCE TOKENS (-dark, animatable)",
      "description": "OKLCH dark source tokens for brand and status colors. Registered as typed <color> so scoped [data-theme=\"dark\"] sections inherit correct absolute values rather than an unresolved var() text string.",
      "note": "Raw secondary palette token for the secondary brand color.",
      "value": "light-dark(var(--sf-color-secondary-source-light), var(--sf-color-secondary-source-dark, oklch(from var(--sf-color-secondary-source-light) clamp(0.65, calc(0.95 - l * 0.5), 0.88) calc(c * 0.9) h)))",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary--active",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "secondary",
      "description": "Semantic secondary-color scale derived from --sf-color-secondary.",
      "note": "Secondary color at pressed/active brightness.",
      "value": "var(--sf-color-secondary-xdark)",
      "aliasOf": "--sf-color-secondary-xdark",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary--hover",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "secondary",
      "description": "Semantic secondary-color scale derived from --sf-color-secondary.",
      "note": "Secondary color at hover brightness.",
      "value": "var(--sf-color-secondary-darker)",
      "aliasOf": "--sf-color-secondary-darker",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary-100",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "secondary",
      "description": "Semantic secondary-color scale derived from --sf-color-secondary.",
      "note": "Very light secondary shade.",
      "value": "oklch(from var(--sf-color-secondary) max(l, calc(l + (var(--sf-palette-tint-l) - l) * 0.88)) calc(c * 0.3) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary-200",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "secondary",
      "description": "Semantic secondary-color scale derived from --sf-color-secondary.",
      "note": "Light secondary shade at step 200 on the numeric scale. Subtle fills and outlined badge backgrounds.",
      "value": "oklch(from var(--sf-color-secondary) max(l, calc(l + (var(--sf-palette-tint-l) - l) * 0.72)) calc(c * 0.5) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary-300",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "secondary",
      "description": "Semantic secondary-color scale derived from --sf-color-secondary.",
      "note": "Light-mid secondary shade.",
      "value": "oklch(from var(--sf-color-secondary) max(l, calc(l + (var(--sf-palette-tint-l) - l) * 0.52)) calc(c * 0.72) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary-400",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "secondary",
      "description": "Semantic secondary-color scale derived from --sf-color-secondary.",
      "note": "Mid-light secondary shade.",
      "value": "oklch(from var(--sf-color-secondary) max(l, calc(l + (var(--sf-palette-tint-l) - l) * 0.3)) calc(c * 0.88) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary-50",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "secondary",
      "description": "Semantic secondary-color scale derived from --sf-color-secondary.",
      "note": "Lightest secondary tint.",
      "value": "oklch(from var(--sf-color-secondary) max(l, calc(l + (var(--sf-palette-tint-l) - l) * 0.95)) calc(c * 0.2) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary-500",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "secondary",
      "description": "Semantic secondary-color scale derived from --sf-color-secondary.",
      "note": "Mid secondary shade — the 'pure' hue.",
      "value": "var(--sf-color-secondary)",
      "aliasOf": "--sf-color-secondary",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary-600",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "secondary",
      "description": "Semantic secondary-color scale derived from --sf-color-secondary.",
      "note": "Mid-dark secondary shade.",
      "value": "oklch(from var(--sf-color-secondary) min(l, calc(l + (var(--sf-palette-shade-l) - l) * 0.16)) calc(c * 0.96) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary-700",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "secondary",
      "description": "Semantic secondary-color scale derived from --sf-color-secondary.",
      "note": "Dark secondary shade.",
      "value": "oklch(from var(--sf-color-secondary) min(l, calc(l + (var(--sf-palette-shade-l) - l) * 0.36)) calc(c * 0.88) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary-800",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "secondary",
      "description": "Semantic secondary-color scale derived from --sf-color-secondary.",
      "note": "Very dark secondary shade.",
      "value": "oklch(from var(--sf-color-secondary) min(l, calc(l + (var(--sf-palette-shade-l) - l) * 0.58)) calc(c * 0.72) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary-900",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "secondary",
      "description": "Semantic secondary-color scale derived from --sf-color-secondary.",
      "note": "Near-black secondary shade at step 900 on the numeric scale. Extreme contrast on light surfaces.",
      "value": "oklch(from var(--sf-color-secondary) min(l, calc(l + (var(--sf-palette-shade-l) - l) * 0.78)) calc(c * 0.52) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary-950",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "secondary",
      "description": "Semantic secondary-color scale derived from --sf-color-secondary.",
      "note": "Darkest secondary tint.",
      "value": "oklch(from var(--sf-color-secondary) min(l, calc(l + (var(--sf-palette-shade-l) - l) * 0.9)) calc(c * 0.38) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary-a10",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "secondary",
      "description": "Semantic secondary-color scale derived from --sf-color-secondary.",
      "note": "10% opacity secondary tint.",
      "value": "oklch(from var(--sf-color-secondary) l c h / 0.10)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary-a30",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "secondary",
      "description": "Semantic secondary-color scale derived from --sf-color-secondary.",
      "note": "30% opacity secondary tint.",
      "value": "oklch(from var(--sf-color-secondary) l c h / 0.30)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary-a5",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "secondary",
      "description": "Semantic secondary-color scale derived from --sf-color-secondary.",
      "note": "5% opacity secondary tint.",
      "value": "oklch(from var(--sf-color-secondary) l c h / 0.05)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary-a50",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "secondary",
      "description": "Semantic secondary-color scale derived from --sf-color-secondary.",
      "note": "50% opacity secondary tint.",
      "value": "oklch(from var(--sf-color-secondary) l c h / 0.50)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary-a80",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "secondary",
      "description": "Semantic secondary-color scale derived from --sf-color-secondary.",
      "note": "80% opacity secondary tint.",
      "value": "oklch(from var(--sf-color-secondary) l c h / 0.80)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary-darker",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "secondary",
      "description": "Semantic secondary-color scale derived from --sf-color-secondary.",
      "note": "Deep secondary shade — alias of --sf-color-secondary-600.",
      "value": "var(--sf-color-secondary-600)",
      "aliasOf": "--sf-color-secondary-600",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary-lighter",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "secondary",
      "description": "Semantic secondary-color scale derived from --sf-color-secondary.",
      "note": "Light secondary shade for soft accents — alias of --sf-color-secondary-400.",
      "value": "var(--sf-color-secondary-400)",
      "aliasOf": "--sf-color-secondary-400",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary-muted",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "secondary",
      "description": "Semantic secondary-color scale derived from --sf-color-secondary.",
      "note": "Muted secondary fill.",
      "value": "var(--sf-color-secondary-a30)",
      "aliasOf": "--sf-color-secondary-a30",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary-source-dark",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "color",
      "category": "Core tokens",
      "group": "DARK SOURCE TOKENS (-dark, animatable)",
      "description": "OKLCH dark source tokens for brand and status colors. Registered as typed <color> so scoped [data-theme=\"dark\"] sections inherit correct absolute values rather than an unresolved var() text string.",
      "note": "Registered <color> dark counterpart of --sf-color-secondary.",
      "value": "oklch(0.84 0.036 264)",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary-source-light",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "color",
      "category": "Core tokens",
      "group": "BRAND COLORS (-source-light source tokens, animatable)",
      "description": "OKLCH lightness source for the secondary color.",
      "note": "OKLCH lightness source for the secondary color.",
      "value": "oklch(0.22 0.04 264)",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary-subtle",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "secondary",
      "description": "Semantic secondary-color scale derived from --sf-color-secondary.",
      "note": "Lightest secondary semantic tint.",
      "value": "var(--sf-color-secondary-a10)",
      "aliasOf": "--sf-color-secondary-a10",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary-superdark",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "secondary",
      "description": "Semantic secondary-color scale derived from --sf-color-secondary.",
      "note": "Near-black secondary shade for maximum contrast on light surfaces — alias of --sf-color-secondary-950.",
      "value": "var(--sf-color-secondary-950)",
      "aliasOf": "--sf-color-secondary-950",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary-superlight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "secondary",
      "description": "Semantic secondary-color scale derived from --sf-color-secondary.",
      "note": "Near-white secondary shade — alias of --sf-color-secondary-50.",
      "value": "var(--sf-color-secondary-50)",
      "aliasOf": "--sf-color-secondary-50",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary-tint",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "secondary",
      "description": "Semantic secondary-color scale derived from --sf-color-secondary.",
      "note": "Near-transparent secondary tint (5% alpha) for hover-state washes and the most subtle backgrounds — alias of --sf-color-secondary-a5.",
      "value": "var(--sf-color-secondary-a5)",
      "aliasOf": "--sf-color-secondary-a5",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary-xdark",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "secondary",
      "description": "Semantic secondary-color scale derived from --sf-color-secondary.",
      "note": "Extra-dark secondary shade — alias of --sf-color-secondary-800.",
      "value": "var(--sf-color-secondary-800)",
      "aliasOf": "--sf-color-secondary-800",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-secondary-xlight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "secondary",
      "description": "Semantic secondary-color scale derived from --sf-color-secondary.",
      "note": "Extra-light secondary shade — alias of --sf-color-secondary-200.",
      "value": "var(--sf-color-secondary-200)",
      "aliasOf": "--sf-color-secondary-200",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-selection-bg",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Selection",
      "description": "Text-selection background color.",
      "note": "Background color applied to browser text selections.",
      "value": "light-dark( oklch(from var(--sf-color-action-source-light) l c h / 0.28), oklch(from var(--sf-color-action-source-dark) clamp(0.62, calc(0.93 - l * 0.4), 0.78) c h / 0.55) )",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-selection-bg--alt",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Selection",
      "description": "Text-selection background color.",
      "note": "Alt selection background — the inverse-scheme highlight fill for surfaces that deliberately flip colour scheme (e.g. a dark hero in light mode).",
      "value": "light-dark( oklch(from var(--sf-color-action-source-dark) clamp(0.62, calc(0.93 - l * 0.4), 0.78) c h / 0.55), oklch(from var(--sf-color-action-source-light) l c h / 0.28) )",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-selection-text",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Selection & backdrop",
      "description": "Absolute reference colors and overlay tints for selections, marks, and backdrops.",
      "note": "Text color inside browser text selections.",
      "value": "inherit",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-selection-text--alt",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Selection",
      "description": "Text-selection background color.",
      "note": "Alt selection text colour paired with --sf-color-selection-bg--alt; inherits by default so the underlying text colour shows through.",
      "value": "inherit",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-success",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "DARK SOURCE TOKENS (-dark, animatable)",
      "description": "OKLCH dark source tokens for brand and status colors. Registered as typed <color> so scoped [data-theme=\"dark\"] sections inherit correct absolute values rather than an unresolved var() text string.",
      "note": "Positive / success color for confirmation messages and completed-state indicators.",
      "value": "light-dark(var(--sf-color-success-source-light), var(--sf-color-success-source-dark, oklch(from var(--sf-color-success-source-light) clamp(0.65, calc(0.95 - l * 0.5), 0.88) calc(c * 0.9) h)))",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-success-muted",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Status triplets",
      "description": "Three-shade status triplets (subtle / muted / strong) for each status role. Use subtle for backgrounds, muted for fills, strong for text on light surfaces.",
      "note": "Medium success fill for success icons and status chips.",
      "value": "oklch(from var(--sf-color-success) l c h / 0.3)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-success-source-dark",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "color",
      "category": "Core tokens",
      "group": "DARK SOURCE TOKENS (-dark, animatable)",
      "description": "OKLCH dark source tokens for brand and status colors. Registered as typed <color> so scoped [data-theme=\"dark\"] sections inherit correct absolute values rather than an unresolved var() text string.",
      "note": "Registered <color> dark counterpart of --sf-color-success.",
      "value": "oklch(0.70 0.144 145)",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-success-source-light",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "color",
      "category": "Core tokens",
      "group": "STATUS COLORS (-source-light source tokens)",
      "description": "OKLCH lightness source for the success status color.",
      "note": "OKLCH lightness source for the success status color.",
      "value": "oklch(0.50 0.16 145)",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-success-strong",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Status triplets",
      "description": "Three-shade status triplets (subtle / muted / strong) for each status role. Use subtle for backgrounds, muted for fills, strong for text on light surfaces.",
      "note": "High-contrast success color for confirmation message text.",
      "value": "light-dark( oklch(from var(--sf-color-success-source-light) calc(l - 0.15) c h), oklch(from var(--sf-color-success) clamp(0.70, calc(l + 0.15), 1) c h) )",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-success-subtle",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Status triplets",
      "description": "Three-shade status triplets (subtle / muted / strong) for each status role. Use subtle for backgrounds, muted for fills, strong for text on light surfaces.",
      "note": "Light success tint for confirmation backgrounds.",
      "value": "oklch(from var(--sf-color-success) l c h / 0.12)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-success-tint",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Status triplets",
      "description": "Three-shade status triplets (subtle / muted / strong) for each status role. Use subtle for backgrounds, muted for fills, strong for text on light surfaces.",
      "note": "Near-transparent success tint (5% alpha) for hover-state washes and the most subtle backgrounds.",
      "value": "oklch(from var(--sf-color-success) l c h / 0.05)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-surface",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Resolved color tokens",
      "description": "High-level semantic color aliases. Each resolves to the matching palette source token and adapts automatically between light and dark mode. Start here when applying your brand palette.",
      "note": "Default component surface color. Alias of --sf-color-base; use --sf-color-raised for an elevated card/background level.",
      "value": "var(--sf-color-base)",
      "aliasOf": "--sf-color-base",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "DARK SOURCE TOKENS (-dark, animatable)",
      "description": "OKLCH dark source tokens for brand and status colors. Registered as typed <color> so scoped [data-theme=\"dark\"] sections inherit correct absolute values rather than an unresolved var() text string.",
      "note": "Raw tertiary palette token for the third brand color.",
      "value": "light-dark(var(--sf-color-tertiary-source-light), var(--sf-color-tertiary-source-dark, oklch(from var(--sf-color-tertiary-source-light) clamp(0.65, calc(0.95 - l * 0.5), 0.88) calc(c * 0.9) h)))",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary--active",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "tertiary",
      "description": "Semantic tertiary-color scale derived from --sf-color-tertiary.",
      "note": "Tertiary color at pressed/active brightness.",
      "value": "var(--sf-color-tertiary-xdark)",
      "aliasOf": "--sf-color-tertiary-xdark",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary--hover",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "tertiary",
      "description": "Semantic tertiary-color scale derived from --sf-color-tertiary.",
      "note": "Tertiary color at hover brightness.",
      "value": "var(--sf-color-tertiary-darker)",
      "aliasOf": "--sf-color-tertiary-darker",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary-100",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "tertiary",
      "description": "Semantic tertiary-color scale derived from --sf-color-tertiary.",
      "note": "Very light tertiary shade.",
      "value": "oklch(from var(--sf-color-tertiary) max(l, calc(l + (var(--sf-palette-tint-l) - l) * 0.88)) calc(c * 0.3) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary-200",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "tertiary",
      "description": "Semantic tertiary-color scale derived from --sf-color-tertiary.",
      "note": "Light tertiary shade at step 200 on the numeric scale. Subtle fills and outlined badge backgrounds.",
      "value": "oklch(from var(--sf-color-tertiary) max(l, calc(l + (var(--sf-palette-tint-l) - l) * 0.72)) calc(c * 0.5) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary-300",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "tertiary",
      "description": "Semantic tertiary-color scale derived from --sf-color-tertiary.",
      "note": "Light-mid tertiary shade.",
      "value": "oklch(from var(--sf-color-tertiary) max(l, calc(l + (var(--sf-palette-tint-l) - l) * 0.52)) calc(c * 0.72) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary-400",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "tertiary",
      "description": "Semantic tertiary-color scale derived from --sf-color-tertiary.",
      "note": "Mid-light tertiary shade.",
      "value": "oklch(from var(--sf-color-tertiary) max(l, calc(l + (var(--sf-palette-tint-l) - l) * 0.3)) calc(c * 0.88) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary-50",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "tertiary",
      "description": "Semantic tertiary-color scale derived from --sf-color-tertiary.",
      "note": "Lightest tertiary tint.",
      "value": "oklch(from var(--sf-color-tertiary) max(l, calc(l + (var(--sf-palette-tint-l) - l) * 0.95)) calc(c * 0.2) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary-500",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "tertiary",
      "description": "Semantic tertiary-color scale derived from --sf-color-tertiary.",
      "note": "Mid tertiary shade — the 'pure' hue.",
      "value": "var(--sf-color-tertiary)",
      "aliasOf": "--sf-color-tertiary",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary-600",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "tertiary",
      "description": "Semantic tertiary-color scale derived from --sf-color-tertiary.",
      "note": "Mid-dark tertiary shade.",
      "value": "oklch(from var(--sf-color-tertiary) min(l, calc(l + (var(--sf-palette-shade-l) - l) * 0.16)) calc(c * 0.96) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary-700",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "tertiary",
      "description": "Semantic tertiary-color scale derived from --sf-color-tertiary.",
      "note": "Dark tertiary shade.",
      "value": "oklch(from var(--sf-color-tertiary) min(l, calc(l + (var(--sf-palette-shade-l) - l) * 0.36)) calc(c * 0.88) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary-800",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "tertiary",
      "description": "Semantic tertiary-color scale derived from --sf-color-tertiary.",
      "note": "Very dark tertiary shade.",
      "value": "oklch(from var(--sf-color-tertiary) min(l, calc(l + (var(--sf-palette-shade-l) - l) * 0.58)) calc(c * 0.72) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary-900",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "tertiary",
      "description": "Semantic tertiary-color scale derived from --sf-color-tertiary.",
      "note": "Near-black tertiary shade at step 900 on the numeric scale. Extreme contrast on light surfaces.",
      "value": "oklch(from var(--sf-color-tertiary) min(l, calc(l + (var(--sf-palette-shade-l) - l) * 0.78)) calc(c * 0.52) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary-950",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "tertiary",
      "description": "Semantic tertiary-color scale derived from --sf-color-tertiary.",
      "note": "Darkest tertiary tint.",
      "value": "oklch(from var(--sf-color-tertiary) min(l, calc(l + (var(--sf-palette-shade-l) - l) * 0.9)) calc(c * 0.38) h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary-a10",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "tertiary",
      "description": "Semantic tertiary-color scale derived from --sf-color-tertiary.",
      "note": "10% opacity tertiary tint.",
      "value": "oklch(from var(--sf-color-tertiary) l c h / 0.10)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary-a30",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "tertiary",
      "description": "Semantic tertiary-color scale derived from --sf-color-tertiary.",
      "note": "30% opacity tertiary tint.",
      "value": "oklch(from var(--sf-color-tertiary) l c h / 0.30)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary-a5",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "tertiary",
      "description": "Semantic tertiary-color scale derived from --sf-color-tertiary.",
      "note": "5% opacity tertiary tint.",
      "value": "oklch(from var(--sf-color-tertiary) l c h / 0.05)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary-a50",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "tertiary",
      "description": "Semantic tertiary-color scale derived from --sf-color-tertiary.",
      "note": "50% opacity tertiary tint.",
      "value": "oklch(from var(--sf-color-tertiary) l c h / 0.50)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary-a80",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "tertiary",
      "description": "Semantic tertiary-color scale derived from --sf-color-tertiary.",
      "note": "80% opacity tertiary tint.",
      "value": "oklch(from var(--sf-color-tertiary) l c h / 0.80)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary-darker",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "tertiary",
      "description": "Semantic tertiary-color scale derived from --sf-color-tertiary.",
      "note": "Deep tertiary shade — alias of --sf-color-tertiary-600.",
      "value": "var(--sf-color-tertiary-600)",
      "aliasOf": "--sf-color-tertiary-600",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary-lighter",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "tertiary",
      "description": "Semantic tertiary-color scale derived from --sf-color-tertiary.",
      "note": "Light tertiary shade for soft accents — alias of --sf-color-tertiary-400.",
      "value": "var(--sf-color-tertiary-400)",
      "aliasOf": "--sf-color-tertiary-400",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary-muted",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "tertiary",
      "description": "Semantic tertiary-color scale derived from --sf-color-tertiary.",
      "note": "Muted tertiary fill.",
      "value": "var(--sf-color-tertiary-a30)",
      "aliasOf": "--sf-color-tertiary-a30",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary-source-dark",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "color",
      "category": "Core tokens",
      "group": "DARK SOURCE TOKENS (-dark, animatable)",
      "description": "OKLCH dark source tokens for brand and status colors. Registered as typed <color> so scoped [data-theme=\"dark\"] sections inherit correct absolute values rather than an unresolved var() text string.",
      "note": "Registered <color> dark counterpart of --sf-color-tertiary.",
      "value": "oklch(0.74 0.198 295)",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary-source-light",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "color",
      "category": "Core tokens",
      "group": "BRAND COLORS (-source-light source tokens, animatable)",
      "description": "OKLCH lightness source for the tertiary color.",
      "note": "OKLCH lightness source for the tertiary color.",
      "value": "oklch(0.42 0.22 295)",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary-subtle",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "tertiary",
      "description": "Semantic tertiary-color scale derived from --sf-color-tertiary.",
      "note": "Lightest tertiary semantic tint.",
      "value": "var(--sf-color-tertiary-a10)",
      "aliasOf": "--sf-color-tertiary-a10",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary-superdark",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "tertiary",
      "description": "Semantic tertiary-color scale derived from --sf-color-tertiary.",
      "note": "Near-black tertiary shade for maximum contrast on light surfaces — alias of --sf-color-tertiary-950.",
      "value": "var(--sf-color-tertiary-950)",
      "aliasOf": "--sf-color-tertiary-950",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary-superlight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "tertiary",
      "description": "Semantic tertiary-color scale derived from --sf-color-tertiary.",
      "note": "Near-white tertiary shade — alias of --sf-color-tertiary-50.",
      "value": "var(--sf-color-tertiary-50)",
      "aliasOf": "--sf-color-tertiary-50",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary-tint",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "tertiary",
      "description": "Semantic tertiary-color scale derived from --sf-color-tertiary.",
      "note": "Near-transparent tertiary tint (5% alpha) for hover-state washes and the most subtle backgrounds — alias of --sf-color-tertiary-a5.",
      "value": "var(--sf-color-tertiary-a5)",
      "aliasOf": "--sf-color-tertiary-a5",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary-xdark",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "tertiary",
      "description": "Semantic tertiary-color scale derived from --sf-color-tertiary.",
      "note": "Extra-dark tertiary shade — alias of --sf-color-tertiary-800.",
      "value": "var(--sf-color-tertiary-800)",
      "aliasOf": "--sf-color-tertiary-800",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-tertiary-xlight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "tertiary",
      "description": "Semantic tertiary-color scale derived from --sf-color-tertiary.",
      "note": "Extra-light tertiary shade — alias of --sf-color-tertiary-200.",
      "value": "var(--sf-color-tertiary-200)",
      "aliasOf": "--sf-color-tertiary-200",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-text",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Text",
      "description": "Semantic text colors for every content role. All tokens adapt to light and dark mode automatically.",
      "note": "Primary text color. Contrasts against --sf-color-bg for body copy.",
      "value": "light-dark( oklch(from var(--sf-color-neutral-source-light) clamp(0.05, calc(l - 0.4 - var(--sf-contrast-bias)), 0.35) c h), oklch(from var(--sf-color-neutral) clamp(0.70, calc(l + 0.25 + var(--sf-contrast-bias)), 1) c h) )",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-text--disabled",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Text",
      "description": "Semantic text colors for every content role. All tokens adapt to light and dark mode automatically.",
      "note": "Text color for disabled UI elements. Intentionally low contrast.",
      "value": "light-dark( oklch(from var(--sf-color-neutral-source-light) clamp(0.55, calc(l + 0.25), 0.82) c h), oklch(from var(--sf-color-neutral) clamp(0.25, calc(l - 0.2), 0.55) c h) )",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-text--inverse",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Text",
      "description": "Semantic text colors for every content role. All tokens adapt to light and dark mode automatically.",
      "note": "Text color for use on dark/inverted backgrounds.",
      "value": "light-dark( oklch(from var(--sf-color-neutral-source-light) clamp(0.85, calc(l + 0.4), 0.98) c h), oklch(from var(--sf-color-neutral) clamp(0.05, calc(l - 0.4), 0.35) c h) )",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-text--muted",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Text",
      "description": "Semantic text colors for every content role. All tokens adapt to light and dark mode automatically.",
      "note": "Muted text for metadata, timestamps, and low-priority annotations.",
      "value": "light-dark( oklch(from var(--sf-color-neutral-source-light) clamp(0.35, calc(l - var(--sf-contrast-bias)), 0.62) c h), oklch(from var(--sf-color-neutral) clamp(0.48, calc(l + var(--sf-contrast-bias)), 0.74) c h) )",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-text--on-action",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Text-on-color",
      "description": "Accessible foreground colors guaranteed to pass WCAG contrast on each colored background surface.",
      "note": "Accessible foreground color for text on action-colored backgrounds.",
      "value": "oklch(from var(--sf-color-action) clamp(0.1, sign(var(--sf-contrast-threshold) - l) * 999, 0.95) 0 0)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-text--on-base",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Text-on-color",
      "description": "Accessible foreground colors guaranteed to pass WCAG contrast on each colored background surface.",
      "note": "Accessible foreground for text on base-colored backgrounds.",
      "value": "var(--sf-color-text)",
      "aliasOf": "--sf-color-text",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-text--on-danger",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Text-on-color",
      "description": "Accessible foreground colors guaranteed to pass WCAG contrast on each colored background surface.",
      "note": "Accessible foreground for text on danger-colored backgrounds.",
      "value": "oklch(from var(--sf-color-danger) clamp(0.1, sign(var(--sf-contrast-threshold) - l) * 999, 0.95) 0 0)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-text--on-info",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Text-on-color",
      "description": "Accessible foreground colors guaranteed to pass WCAG contrast on each colored background surface.",
      "note": "Accessible foreground for text on info-colored backgrounds.",
      "value": "oklch(from var(--sf-color-info) clamp(0.1, sign(var(--sf-contrast-threshold) - l) * 999, 0.95) 0 0)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-text--on-inverse",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Text-on-color",
      "description": "Accessible foreground colors guaranteed to pass WCAG contrast on each colored background surface.",
      "note": "Accessible foreground for text on inverted (dark-on-light / light-on-dark) backgrounds.",
      "value": "oklch(from var(--sf-color-inverse) clamp(0.1, sign(var(--sf-contrast-threshold) - l) * 999, 0.95) 0 0)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-text--on-neutral",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Text-on-color",
      "description": "Accessible foreground colors guaranteed to pass WCAG contrast on each colored background surface.",
      "note": "Accessible foreground for text placed on neutral-colored backgrounds.",
      "value": "oklch(from var(--sf-color-neutral) clamp(0.1, sign(var(--sf-contrast-threshold) - l) * 999, 0.95) 0 0)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-text--on-primary",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Text-on-color",
      "description": "Accessible foreground colors guaranteed to pass WCAG contrast on each colored background surface.",
      "note": "Accessible foreground for text placed on primary-colored backgrounds.",
      "value": "oklch(from var(--sf-color-primary) clamp(0.1, sign(var(--sf-contrast-threshold) - l) * 999, 0.95) 0 0)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-text--on-secondary",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Text-on-color",
      "description": "Accessible foreground colors guaranteed to pass WCAG contrast on each colored background surface.",
      "note": "Accessible foreground for text placed on secondary-colored backgrounds.",
      "value": "oklch(from var(--sf-color-secondary) clamp(0.1, sign(var(--sf-contrast-threshold) - l) * 999, 0.95) 0 0)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-text--on-success",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Text-on-color",
      "description": "Accessible foreground colors guaranteed to pass WCAG contrast on each colored background surface.",
      "note": "Accessible foreground for text on success-colored backgrounds.",
      "value": "oklch(from var(--sf-color-success) clamp(0.1, sign(var(--sf-contrast-threshold) - l) * 999, 0.95) 0 0)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-text--on-tertiary",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Text-on-color",
      "description": "Accessible foreground colors guaranteed to pass WCAG contrast on each colored background surface.",
      "note": "Accessible foreground for text placed on tertiary-colored backgrounds.",
      "value": "oklch(from var(--sf-color-tertiary) clamp(0.1, sign(var(--sf-contrast-threshold) - l) * 999, 0.95) 0 0)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-text--on-warning",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Text-on-color",
      "description": "Accessible foreground colors guaranteed to pass WCAG contrast on each colored background surface.",
      "note": "Accessible foreground for text on warning-colored backgrounds.",
      "value": "oklch(from var(--sf-color-warning) clamp(0.1, sign(var(--sf-contrast-threshold) - l) * 999, 0.95) 0 0)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-text--placeholder",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Text",
      "description": "Semantic text colors for every content role. All tokens adapt to light and dark mode automatically.",
      "note": "Placeholder text color for inputs and textareas.",
      "value": "light-dark( oklch(from var(--sf-color-neutral-source-light) clamp(0.45, calc(l + 0.15), 0.75) c h), oklch(from var(--sf-color-neutral) clamp(0.35, calc(l - 0.1), 0.65) c h) )",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-text--subtle",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Text",
      "description": "Semantic text colors for every content role. All tokens adapt to light and dark mode automatically.",
      "note": "De-emphasised, lower-emphasis text (captions, labels, supporting copy). Second tier below --sf-color-text; sits between it and --sf-color-text--muted.",
      "value": "light-dark( oklch(from var(--sf-color-neutral-source-light) clamp(0.15, calc(l - 0.25 - var(--sf-contrast-bias)), 0.45) c h), oklch(from var(--sf-color-neutral) clamp(0.55, calc(l + 0.1 + var(--sf-contrast-bias)), 0.90) c h) )",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-warning",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "DARK SOURCE TOKENS (-dark, animatable)",
      "description": "OKLCH dark source tokens for brand and status colors. Registered as typed <color> so scoped [data-theme=\"dark\"] sections inherit correct absolute values rather than an unresolved var() text string.",
      "note": "Warning / caution color for non-critical alerts and degraded-state indicators.",
      "value": "light-dark(var(--sf-color-warning-source-light), var(--sf-color-warning-source-dark, oklch(from var(--sf-color-warning-source-light) clamp(0.65, calc(0.95 - l * 0.5), 0.88) calc(c * 0.9) h)))",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-warning-muted",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Status triplets",
      "description": "Three-shade status triplets (subtle / muted / strong) for each status role. Use subtle for backgrounds, muted for fills, strong for text on light surfaces.",
      "note": "Medium warning fill for icons and caution chips.",
      "value": "oklch(from var(--sf-color-warning) l c h / 0.3)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-warning-source-dark",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "color",
      "category": "Core tokens",
      "group": "DARK SOURCE TOKENS (-dark, animatable)",
      "description": "OKLCH dark source tokens for brand and status colors. Registered as typed <color> so scoped [data-theme=\"dark\"] sections inherit correct absolute values rather than an unresolved var() text string.",
      "note": "Registered <color> dark counterpart of --sf-color-warning.",
      "value": "oklch(0.65 0.153 80)",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-warning-source-light",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "color",
      "category": "Core tokens",
      "group": "STATUS COLORS (-source-light source tokens)",
      "description": "OKLCH lightness source for the warning status color.",
      "note": "OKLCH lightness source for the warning status color.",
      "value": "oklch(0.75 0.17 80)",
      "aliasOf": null,
      "registered": true,
      "syntax": "<color>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-warning-strong",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Status triplets",
      "description": "Three-shade status triplets (subtle / muted / strong) for each status role. Use subtle for backgrounds, muted for fills, strong for text on light surfaces.",
      "note": "High-contrast warning color for caution text.",
      "value": "light-dark( oklch(from var(--sf-color-warning-source-light) calc(l - 0.25) c h), oklch(from var(--sf-color-warning) clamp(0.70, calc(l + 0.05), 1) c h) )",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-warning-subtle",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Status triplets",
      "description": "Three-shade status triplets (subtle / muted / strong) for each status role. Use subtle for backgrounds, muted for fills, strong for text on light surfaces.",
      "note": "Light warning tint for warning notification backgrounds.",
      "value": "oklch(from var(--sf-color-warning) l c h / 0.12)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-warning-tint",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Status triplets",
      "description": "Three-shade status triplets (subtle / muted / strong) for each status role. Use subtle for backgrounds, muted for fills, strong for text on light surfaces.",
      "note": "Near-transparent warning tint (5% alpha) for hover-state washes and the most subtle backgrounds.",
      "value": "oklch(from var(--sf-color-warning) l c h / 0.05)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-color-white",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "color",
      "category": "Core tokens",
      "group": "Selection & backdrop",
      "description": "Absolute reference colors and overlay tints for selections, marks, and backdrops.",
      "note": "Absolute white reference value.",
      "value": "oklch(100% 0 0)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-component-pad",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "component",
      "category": "Core tokens",
      "group": "Semantic gap tokens",
      "description": "Standard inner padding for interactive components (buttons, form inputs, chips).",
      "note": "Standard inner padding for interactive components (buttons, form inputs, chips).",
      "value": "var(--sf-space-m)",
      "aliasOf": "--sf-space-m",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-container-default",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "container",
      "category": "Core tokens",
      "group": "Containers",
      "description": "Max-width container tokens for page-level layout.",
      "note": "Default content container max-width (~1200px).",
      "value": "75rem",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-container-full",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "container",
      "category": "Core tokens",
      "group": "Containers",
      "description": "Max-width container tokens for page-level layout.",
      "note": "Full-width container — removes the max-width constraint.",
      "value": "100%",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-container-narrow",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "container",
      "category": "Core tokens",
      "group": "Containers",
      "description": "Max-width container tokens for page-level layout.",
      "note": "Narrow content max-width — ideal for article body and blog posts (~65ch).",
      "value": "38rem",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-container-prose",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "container",
      "category": "Core tokens",
      "group": "Containers",
      "description": "Max-width container tokens for page-level layout.",
      "note": "Prose max-width — optimised for readability (~75ch).",
      "value": "65ch",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-container-wide",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "container",
      "category": "Core tokens",
      "group": "Containers",
      "description": "Max-width container tokens for page-level layout.",
      "note": "Wide container for marketing / dashboard layouts (~1440px).",
      "value": "90rem",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-content-gap",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "content",
      "category": "Core tokens",
      "group": "Semantic gap tokens",
      "description": "Tight gap within related content (stack, flow, prose). Override globally to retune all tight primitives at once.",
      "note": "Tight gap within related content (stack, flow, prose). Override globally to retune all tight primitives at once.",
      "value": "var(--sf-space-s)",
      "aliasOf": "--sf-space-s",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-content-intrinsic-size",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "content",
      "category": "Macro tokens",
      "group": "Content visibility",
      "description": "intrinsic-size hint for content-visibility: auto (lazy off-screen rendering).",
      "note": "Intrinsic-size hint for content-visibility: auto (prevents layout shift on first reveal).",
      "value": "500px",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-content-width",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "content",
      "category": "Layout tokens",
      "group": "Content grid (breakout pattern)",
      "description": "Breakout width and content width for the content-grid pattern (full-bleed breakouts inside a constrained column).",
      "note": "Max-width of the main content column in a content grid.",
      "value": "var(--sf-container-default)",
      "aliasOf": "--sf-container-default",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-contrast-bias",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "contrast",
      "category": "Core tokens",
      "group": "Layout & a11y",
      "description": "Focus ring, header height, sticky offset, touch-target, text-contrast knobs, and device safe-area insets. These govern keyboard accessibility, scroll behaviour, and adaptive contrast globally.",
      "note": "Global text-contrast nudge. Positive values push derived reading-text colors toward the extremes (darker in light mode, lighter in dark). Default 0 (neutral).",
      "value": "0",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-contrast-threshold",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "contrast",
      "category": "Core tokens",
      "group": "Layout & a11y",
      "description": "Focus ring, header height, sticky offset, touch-target, text-contrast knobs, and device safe-area insets. These govern keyboard accessibility, scroll behaviour, and adaptive contrast globally.",
      "note": "OKLCH lightness crossover for auto-contrast on colored surfaces. Colors with L above this get dark text; below get light text. Default 0.6.",
      "value": "0.6",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-cover-min-height",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "cover",
      "category": "Layout tokens",
      "group": "Cover",
      "description": "Min-height and padding for the full-viewport cover layout.",
      "note": "Minimum height of the cover layout (typically 100svh).",
      "value": "100dvh",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-cover-padding",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "cover",
      "category": "Layout tokens",
      "group": "Cover",
      "description": "Min-height and padding for the full-viewport cover layout.",
      "note": "Inner padding for the cover layout.",
      "value": "var(--sf-section-pad)",
      "aliasOf": "--sf-section-pad",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-display-l-line-height",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "display",
      "category": "Core tokens",
      "group": "Line heights & letter spacing",
      "description": "Typographic fine-tuning tokens: leading (line-height) and tracking (letter-spacing) for every weight class.",
      "note": "Line height for large display text (--sf-text-display-l). Very tight to avoid excessive gaps at oversized sizes.",
      "value": "1",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-display-m-line-height",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "display",
      "category": "Core tokens",
      "group": "Line heights & letter spacing",
      "description": "Typographic fine-tuning tokens: leading (line-height) and tracking (letter-spacing) for every weight class.",
      "note": "Line height for medium display text (--sf-text-display-m).",
      "value": "1.05",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-display-s-line-height",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "display",
      "category": "Core tokens",
      "group": "Line heights & letter spacing",
      "description": "Typographic fine-tuning tokens: leading (line-height) and tracking (letter-spacing) for every weight class.",
      "note": "Line height for small display text (--sf-text-display-s).",
      "value": "var(--sf-leading-tight)",
      "aliasOf": "--sf-leading-tight",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-divider-color",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "divider",
      "category": "Core tokens",
      "group": "Divider",
      "description": "Horizontal/vertical rule (divider) properties.",
      "note": "Color of horizontal/vertical divider rules.",
      "value": "var(--sf-color-border)",
      "aliasOf": "--sf-color-border",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-divider-gap",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "divider",
      "category": "Core tokens",
      "group": "Divider",
      "description": "Horizontal/vertical rule (divider) properties.",
      "note": "Spacing (margin) around divider elements.",
      "value": "var(--sf-space-m)",
      "aliasOf": "--sf-space-m",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-divider-style",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "divider",
      "category": "Core tokens",
      "group": "Divider",
      "description": "Horizontal/vertical rule (divider) properties.",
      "note": "Border style of dividers.",
      "value": "solid",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-divider-width",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "divider",
      "category": "Core tokens",
      "group": "Divider",
      "description": "Horizontal/vertical rule (divider) properties.",
      "note": "Stroke width of horizontal and vertical divider rules.",
      "value": "var(--sf-border-width-1)",
      "aliasOf": "--sf-border-width-1",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-drop-shadow-l",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "drop",
      "category": "Core tokens",
      "group": "Output token @property registrations",
      "description": "Large CSS filter: drop-shadow for prominent illustrated or cut-out elements.",
      "note": "Large CSS filter: drop-shadow for prominent illustrated or cut-out elements.",
      "value": "drop-shadow(0 8px 16px oklch(from var(--sf-shadow-color) l c h / clamp(0, calc(var(--sf-shadow-strength) * 2.5), 0.7)))",
      "aliasOf": null,
      "registered": true,
      "syntax": "*",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-drop-shadow-m",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "drop",
      "category": "Core tokens",
      "group": "Output token @property registrations",
      "description": "Medium CSS filter: drop-shadow for elevated icons and card thumbnails.",
      "note": "Medium CSS filter: drop-shadow for elevated icons and card thumbnails.",
      "value": "drop-shadow(0 4px 6px oklch(from var(--sf-shadow-color) l c h / clamp(0, calc(var(--sf-shadow-strength) * 2), 0.7)))",
      "aliasOf": null,
      "registered": true,
      "syntax": "*",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-drop-shadow-s",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "drop",
      "category": "Core tokens",
      "group": "Output token @property registrations",
      "description": "Small CSS filter: drop-shadow. Use filter (not box-shadow) for elements with transparent areas — SVGs, PNGs, cutout images.",
      "note": "Small CSS filter: drop-shadow. Use filter (not box-shadow) for elements with transparent areas — SVGs, PNGs, cutout images.",
      "value": "drop-shadow(0 1px 2px oklch(from var(--sf-shadow-color) l c h / clamp(0, calc(var(--sf-shadow-strength) * 1.5), 0.7)))",
      "aliasOf": null,
      "registered": true,
      "syntax": "*",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-drop-shadow-xl",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "drop",
      "category": "Core tokens",
      "group": "Output token @property registrations",
      "description": "Extra-large CSS filter: drop-shadow for hero-scale illustrated or cut-out elements.",
      "note": "Extra-large CSS filter: drop-shadow for hero-scale illustrated or cut-out elements.",
      "value": "drop-shadow(0 16px 32px oklch(from var(--sf-shadow-color) l c h / clamp(0, calc(var(--sf-shadow-strength) * 3), 0.7)))",
      "aliasOf": null,
      "registered": true,
      "syntax": "*",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-drop-shadow-xs",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "drop",
      "category": "Core tokens",
      "group": "Output token @property registrations",
      "description": "Extra-small CSS filter: drop-shadow, for the subtlest depth on small icons and cutout images.",
      "note": "Extra-small CSS filter: drop-shadow, for the subtlest depth on small icons and cutout images.",
      "value": "drop-shadow(0 0.5px 1px oklch(from var(--sf-shadow-color) l c h / clamp(0, calc(var(--sf-shadow-strength) * 1), 0.7)))",
      "aliasOf": null,
      "registered": true,
      "syntax": "*",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-duration-fast",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "duration",
      "category": "Core tokens",
      "group": "Motion & easing",
      "description": "Duration and easing tokens. Build all transitions and animations from these to ensure consistent motion across the system.",
      "note": "Fast duration (~150ms). Hover transitions, tooltip appear.",
      "value": "calc(150ms * var(--sf-motion-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-duration-instant",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "duration",
      "category": "Core tokens",
      "group": "Motion & easing",
      "description": "Duration and easing tokens. Build all transitions and animations from these to ensure consistent motion across the system.",
      "note": "Near-instant duration (~100ms). Micro-interactions and cursor-follow effects.",
      "value": "calc(100ms * var(--sf-motion-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-duration-none",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "duration",
      "category": "Core tokens",
      "group": "Motion & easing",
      "description": "Duration and easing tokens. Build all transitions and animations from these to ensure consistent motion across the system.",
      "note": "0ms duration. Disables transitions (respects prefers-reduced-motion).",
      "value": "0ms",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-duration-normal",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "duration",
      "category": "Core tokens",
      "group": "Motion & easing",
      "description": "Duration and easing tokens. Build all transitions and animations from these to ensure consistent motion across the system.",
      "note": "Normal duration (~250ms). Default for most transitions.",
      "value": "calc(250ms * var(--sf-motion-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-duration-slow",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "duration",
      "category": "Core tokens",
      "group": "Motion & easing",
      "description": "Duration and easing tokens. Build all transitions and animations from these to ensure consistent motion across the system.",
      "note": "Slow duration (~400ms). Emphasis transitions, drawers.",
      "value": "calc(400ms * var(--sf-motion-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-duration-slower",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "duration",
      "category": "Core tokens",
      "group": "Motion & easing",
      "description": "Duration and easing tokens. Build all transitions and animations from these to ensure consistent motion across the system.",
      "note": "Extra-slow duration (~600ms). Page-level enter/exit transitions.",
      "value": "calc(600ms * var(--sf-motion-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-ease-bounce",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "ease",
      "category": "Core tokens",
      "group": "Motion & easing",
      "description": "Duration and easing tokens. Build all transitions and animations from these to ensure consistent motion across the system.",
      "note": "Bounce easing. Playful overshooting effect.",
      "value": "linear(0, 0.35 18%, 1 32%, 0.86 42%, 1.02 56%, 0.98 72%, 1)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-ease-elastic",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "ease",
      "category": "Core tokens",
      "group": "Motion & easing",
      "description": "Duration and easing tokens. Build all transitions and animations from these to ensure consistent motion across the system.",
      "note": "Elastic easing. Spring-like overshooting effect.",
      "value": "linear(0, 0.3, 1.2, 0.9, 1.05, 1)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-ease-in",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "ease",
      "category": "Core tokens",
      "group": "Motion & easing",
      "description": "Duration and easing tokens. Build all transitions and animations from these to ensure consistent motion across the system.",
      "note": "Accelerating easing. Use for elements leaving the viewport.",
      "value": "cubic-bezier(0.5, 0, 0.75, 0.25)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-ease-in-out",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "ease",
      "category": "Core tokens",
      "group": "Motion & easing",
      "description": "Duration and easing tokens. Build all transitions and animations from these to ensure consistent motion across the system.",
      "note": "Symmetric easing. Use for elements that move within the viewport.",
      "value": "cubic-bezier(0.4, 0, 0.2, 1)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-ease-linear",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "ease",
      "category": "Core tokens",
      "group": "Motion & easing",
      "description": "Duration and easing tokens. Build all transitions and animations from these to ensure consistent motion across the system.",
      "note": "Linear easing. Use for progress indicators and spinner rotations.",
      "value": "linear",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-ease-out",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "ease",
      "category": "Core tokens",
      "group": "Motion & easing",
      "description": "Duration and easing tokens. Build all transitions and animations from these to ensure consistent motion across the system.",
      "note": "Decelerating easing. Use for elements entering the viewport.",
      "value": "cubic-bezier(0.25, 0, 0.15, 1)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-ease-overshoot",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "ease",
      "category": "Core tokens",
      "group": "Motion & easing",
      "description": "Duration and easing tokens. Build all transitions and animations from these to ensure consistent motion across the system.",
      "note": "Subtle overshoot easing. Softer spring effect.",
      "value": "linear(0, 0.6 30%, 1.08 55%, 0.98 75%, 1)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-ease-spring",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "ease",
      "category": "Core tokens",
      "group": "Motion & easing",
      "description": "Duration and easing tokens. Build all transitions and animations from these to ensure consistent motion across the system.",
      "note": "Spring easing. Natural physics-based motion.",
      "value": "linear(0, 0.5, 1.1, 0.95, 1.02, 1)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-equal-gap",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "equal",
      "category": "Layout tokens",
      "group": "Equal columns",
      "description": "Gap between equal columns.",
      "note": "Gap between equal columns.",
      "value": "var(--sf-gap)",
      "aliasOf": "--sf-gap",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-equal-min-col",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "equal",
      "category": "Layout tokens",
      "group": "Equal columns",
      "description": "column-width floor for .sf-equal's flowing CSS multi-column layout (not a grid) — the browser won't go narrower than this.",
      "note": "column-width floor for .sf-equal's flowing CSS multi-column layout (not a grid) — the browser won't go narrower than this.",
      "value": "16rem",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-equal-rule-color",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "equal",
      "category": "Layout tokens",
      "group": "Equal columns",
      "description": "column-rule color between .sf-equal's flowing columns.",
      "note": "column-rule color between .sf-equal's flowing columns.",
      "value": "var(--sf-color-border)",
      "aliasOf": "--sf-color-border",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-equal-rule-style",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "equal",
      "category": "Layout tokens",
      "group": "Equal columns",
      "description": "column-rule style between .sf-equal's flowing columns.",
      "note": "column-rule style between .sf-equal's flowing columns.",
      "value": "solid",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-equal-rule-width",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "equal",
      "category": "Layout tokens",
      "group": "Equal columns",
      "description": "column-rule width between .sf-equal's flowing columns. 0 (default) means no rule.",
      "note": "column-rule width between .sf-equal's flowing columns. 0 (default) means no rule.",
      "value": "0",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-field-block",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "field",
      "category": "Core tokens",
      "group": "Semantic gap tokens",
      "description": "Vertical (block) padding inside form fields.",
      "note": "Vertical (block) padding inside form fields.",
      "value": "var(--sf-space-xs)",
      "aliasOf": "--sf-space-xs",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-field-padding-block",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "field",
      "category": "Component tokens",
      "group": "FIELD TOKENS",
      "description": "Padding and radius tokens that control form field geometry. Override these to give inputs a distinct visual language from buttons.",
      "note": "Vertical (block) inner padding for form field inputs. Reserved for a future .sf-field class — declared but not yet consumed by any shipped rule.",
      "value": "var(--sf-space-xs)",
      "aliasOf": "--sf-space-xs",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-field-padding-inline",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "field",
      "category": "Component tokens",
      "group": "FIELD TOKENS",
      "description": "Padding and radius tokens that control form field geometry. Override these to give inputs a distinct visual language from buttons.",
      "note": "Horizontal (inline) inner padding for form field inputs. Reserved for a future .sf-field class — declared but not yet consumed by any shipped rule.",
      "value": "var(--sf-space-s)",
      "aliasOf": "--sf-space-s",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-field-radius",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "field",
      "category": "Component tokens",
      "group": "FIELD TOKENS",
      "description": "Padding and radius tokens that control form field geometry. Override these to give inputs a distinct visual language from buttons.",
      "note": "Border radius for form field inputs. Defaults to --sf-radius-m; override to reshape all inputs at once. Reserved for a future .sf-field class — declared but not yet consumed by any shipped rule.",
      "value": "var(--sf-radius-m)",
      "aliasOf": "--sf-radius-m",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": true,
      "layer": "slashed.tokens",
      "bundles": [
        "full"
      ]
    },
    {
      "name": "--sf-field-required-marker",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "field",
      "category": "Core tokens",
      "group": "Semantic gap tokens",
      "description": "CSS content value for required-field markers (e.g. \" *\"). Used by pseudo-elements in the .required utility pattern.",
      "note": "CSS content value for required-field markers (e.g. \" *\"). Used by pseudo-elements in the .required utility pattern.",
      "value": "\" *\"",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-flow-space",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "flow",
      "category": "Macro tokens",
      "group": "Flow",
      "description": "Vertical rhythm gap between flow children (margin-block-start on all but the first child).",
      "note": "Margin-block-start applied to all flow children except the first.",
      "value": "var(--sf-content-gap)",
      "aliasOf": "--sf-content-gap",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-fluid-max-vw",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "fluid",
      "category": "Core tokens",
      "group": "FLUID SCALE ENGINE",
      "description": "Generative inputs that drive all fluid clamp() type and spacing scales at runtime. Override the base, ratio, and viewport range tokens to globally rescale the entire system without touching individual step tokens.",
      "note": "Maximum viewport width (in rem) at which the fluid scale clamps to its largest values. Default 90rem (~1440px). Part of the fluid scale engine.",
      "value": "90",
      "aliasOf": null,
      "registered": true,
      "syntax": "<number>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-fluid-min-vw",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "fluid",
      "category": "Core tokens",
      "group": "FLUID SCALE ENGINE",
      "description": "Generative inputs that drive all fluid clamp() type and spacing scales at runtime. Override the base, ratio, and viewport range tokens to globally rescale the entire system without touching individual step tokens.",
      "note": "Minimum viewport width (in rem) at which the fluid scale clamps to its smallest values. Default 22.5rem (~360px). Part of the fluid scale engine.",
      "value": "22.5",
      "aliasOf": null,
      "registered": true,
      "syntax": "<number>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-fluid-width",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "fluid",
      "category": "Core tokens",
      "group": "FLUID SCALE ENGINE",
      "description": "Generative inputs that drive all fluid clamp() type and spacing scales at runtime. Override the base, ratio, and viewport range tokens to globally rescale the entire system without touching individual step tokens.",
      "note": "",
      "value": "100vw",
      "aliasOf": null,
      "registered": true,
      "syntax": "*",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-focus-ring-color",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "focus",
      "category": "Core tokens",
      "group": "Focus / form colors",
      "description": "Focus ring and form caret colors. Centralised here so keyboard navigation is consistently styled.",
      "note": "Color of the keyboard focus ring. Ensure sufficient contrast against all background surfaces.",
      "value": "var(--sf-color-action)",
      "aliasOf": "--sf-color-action",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-focus-ring-offset",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "focus",
      "category": "Core tokens",
      "group": "Layout & a11y",
      "description": "Focus ring, header height, sticky offset, touch-target, text-contrast knobs, and device safe-area insets. These govern keyboard accessibility, scroll behaviour, and adaptive contrast globally.",
      "note": "Gap between the element edge and the focus ring.",
      "value": "2px",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-focus-ring-shadow",
      "tier": "PUBLIC-ADVANCED",
      "role": "consumption",
      "namespace": "focus",
      "category": "Core tokens",
      "group": "Focus / form colors",
      "description": "Focus ring and form caret colors. Centralised here so keyboard navigation is consistently styled.",
      "note": "Computed box-shadow value for the focus ring — two-layer technique: offset shadow in bg color, then ring shadow in focus-ring color. Tune via --sf-focus-ring-width and --sf-focus-ring-color instead of overriding this directly.",
      "value": "0 0 0 var(--sf-focus-ring-offset) var(--sf-color-bg, var(--sf-color-base-source-light, #fff)), 0 0 0 calc(var(--sf-focus-ring-offset) + var(--sf-focus-ring-width)) var(--sf-focus-ring-color)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-focus-ring-style",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "focus",
      "category": "Core tokens",
      "group": "Layout & a11y",
      "description": "Focus ring, header height, sticky offset, touch-target, text-contrast knobs, and device safe-area insets. These govern keyboard accessibility, scroll behaviour, and adaptive contrast globally.",
      "note": "Border style of the focus ring (solid, dashed, dotted).",
      "value": "solid",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-focus-ring-width",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "focus",
      "category": "Core tokens",
      "group": "Layout & a11y",
      "description": "Focus ring, header height, sticky offset, touch-target, text-contrast knobs, and device safe-area insets. These govern keyboard accessibility, scroll behaviour, and adaptive contrast globally.",
      "note": "Stroke width of the focus ring outline.",
      "value": "2px",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-font-body",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "font",
      "category": "Core tokens",
      "group": "Font families",
      "description": "Font family stacks for every typographic role. Override these to swap typefaces without touching individual text styles.",
      "note": "Font family stack for body text. Override to set your primary typeface.",
      "value": "system-ui, -apple-system, sans-serif",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-font-display",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "font",
      "category": "Core tokens",
      "group": "Font families",
      "description": "Font family stacks for every typographic role. Override these to swap typefaces without touching individual text styles.",
      "note": "Font family for display/marketing text. Override for large headline typefaces.",
      "value": "var(--sf-font-heading)",
      "aliasOf": "--sf-font-heading",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-font-features",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "font",
      "category": "Core tokens",
      "group": "Font families",
      "description": "Font family stacks for every typographic role. Override these to swap typefaces without touching individual text styles.",
      "note": "OpenType feature-settings string for body text (e.g. 'ss01', 'cv11'). Default 'normal'. Override on :root or a subtree to enable ligatures, alternate glyphs, etc.",
      "value": "normal",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-font-heading",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "font",
      "category": "Core tokens",
      "group": "Font families",
      "description": "Font family stacks for every typographic role. Override these to swap typefaces without touching individual text styles.",
      "note": "Font family for headings. Defaults to display if not overridden separately.",
      "value": "var(--sf-font-body)",
      "aliasOf": "--sf-font-body",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-font-mono",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "font",
      "category": "Core tokens",
      "group": "Font families",
      "description": "Font family stacks for every typographic role. Override these to swap typefaces without touching individual text styles.",
      "note": "Monospace font family for code, pre, and kbd elements.",
      "value": "ui-monospace, monospace",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-font-numeric",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "font",
      "category": "Core tokens",
      "group": "Line heights & letter spacing",
      "description": "Typographic fine-tuning tokens: leading (line-height) and tracking (letter-spacing) for every weight class.",
      "note": "font-variant-numeric shorthand (e.g. tabular-nums) for aligned numeric data.",
      "value": "tabular-nums",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-font-variation",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "font",
      "category": "Core tokens",
      "group": "Font families",
      "description": "Font family stacks for every typographic role. Override these to swap typefaces without touching individual text styles.",
      "note": "Variable-font axis settings for body text (e.g. \"wght\" 450). Default 'normal'. Override on :root or a subtree to activate variable-font axes.",
      "value": "normal",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-font-weight-body",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "font",
      "category": "Core tokens",
      "group": "Font weights",
      "description": "Numeric font-weight scale plus named aliases for common roles.",
      "note": "Font weight for body text (typically 400 / normal).",
      "value": "var(--sf-font-weight-normal)",
      "aliasOf": "--sf-font-weight-normal",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-font-weight-bold",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "font",
      "category": "Core tokens",
      "group": "Font weights",
      "description": "Numeric font-weight scale plus named aliases for common roles.",
      "note": "Strong emphasis weight (700).",
      "value": "700",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-font-weight-display",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "font",
      "category": "Core tokens",
      "group": "Font weights",
      "description": "Numeric font-weight scale plus named aliases for common roles.",
      "note": "Font weight for display-size text.",
      "value": "var(--sf-font-weight-bold)",
      "aliasOf": "--sf-font-weight-bold",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-font-weight-heading",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "font",
      "category": "Core tokens",
      "group": "Font weights",
      "description": "Numeric font-weight scale plus named aliases for common roles.",
      "note": "Font weight for headings (typically 600–700).",
      "value": "var(--sf-font-weight-semibold)",
      "aliasOf": "--sf-font-weight-semibold",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-font-weight-interactive",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "font",
      "category": "Core tokens",
      "group": "Font weights",
      "description": "Numeric font-weight scale plus named aliases for common roles.",
      "note": "Font weight for interactive role text — buttons, badges, and navigation labels. Defaults to semibold.",
      "value": "var(--sf-font-weight-semibold)",
      "aliasOf": "--sf-font-weight-semibold",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-font-weight-light",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "font",
      "category": "Core tokens",
      "group": "Font weights",
      "description": "Numeric font-weight scale plus named aliases for common roles.",
      "note": "Light weight (300). Use sparingly — check contrast at small sizes.",
      "value": "300",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-font-weight-medium",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "font",
      "category": "Core tokens",
      "group": "Font weights",
      "description": "Numeric font-weight scale plus named aliases for common roles.",
      "note": "Medium weight (500). Subtle emphasis without full bold.",
      "value": "500",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-font-weight-normal",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "font",
      "category": "Core tokens",
      "group": "Font weights",
      "description": "Numeric font-weight scale plus named aliases for common roles.",
      "note": "Normal / regular weight (400).",
      "value": "400",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-font-weight-semibold",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "font",
      "category": "Core tokens",
      "group": "Font weights",
      "description": "Numeric font-weight scale plus named aliases for common roles.",
      "note": "Semibold weight (600). Common for labels and subheadings.",
      "value": "600",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-font-weight-strong",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "font",
      "category": "Core tokens",
      "group": "Font weights",
      "description": "Numeric font-weight scale plus named aliases for common roles.",
      "note": "Font weight for strong/emphasis inline role. Defaults to bold.",
      "value": "var(--sf-font-weight-bold)",
      "aliasOf": "--sf-font-weight-bold",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-frame-ratio",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "frame",
      "category": "Layout tokens",
      "group": "Frame",
      "description": "Aspect ratio for the frame layout primitive (media container).",
      "note": "Aspect ratio for the frame (media container) layout.",
      "value": "16 / 9",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-gap",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "gap",
      "category": "Core tokens",
      "group": "Semantic gap tokens",
      "description": "Default gap between components (the loose rhythm). Layout primitives like cluster/grid/sidebar default to it. Override globally to retune them all at once, or set a primitive token (e.g. --sf-cluster-gap) for one element.",
      "note": "Default gap between components (the loose rhythm). Layout primitives like cluster/grid/sidebar default to it. Override globally to retune them all at once, or set a primitive token (e.g. --sf-cluster-gap) for one element.",
      "value": "var(--sf-space-m)",
      "aliasOf": "--sf-space-m",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-gradient-action",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "gradient",
      "category": "Core tokens",
      "group": "Gradients",
      "description": "Pre-built gradient shorthands for brand fills and directional fade effects.",
      "note": "Gradient using action palette colors (light to saturated). Core-4 parity with the primary/secondary/tertiary gradients; drives the default .sf-btn--gradient fill.",
      "value": "linear-gradient(in oklch 135deg, var(--sf-color-action), oklch(from var(--sf-color-action) calc(l - 0.08) c h))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-gradient-brand",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "gradient",
      "category": "Core tokens",
      "group": "Gradients",
      "description": "Pre-built gradient shorthands for brand fills and directional fade effects.",
      "note": "Multi-stop brand gradient spanning primary and secondary palette colors. Use for hero backgrounds and brand accents.",
      "value": "linear-gradient(in oklch 135deg, var(--sf-color-primary), oklch(from var(--sf-color-primary) l c calc(h + 30)))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-gradient-fade--b",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "gradient",
      "category": "Core tokens",
      "group": "Gradients",
      "description": "Pre-built gradient shorthands for brand fills and directional fade effects.",
      "note": "Fade-to-bottom gradient (transparent → surface). Use to fade content into a background below (infinite scroll fade, content cutoff).",
      "value": "linear-gradient(in oklch to bottom, transparent, var(--sf-color-bg))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-gradient-fade--l",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "gradient",
      "category": "Core tokens",
      "group": "Gradients",
      "description": "Pre-built gradient shorthands for brand fills and directional fade effects.",
      "note": "Fade-to-left gradient. Use to indicate left-side scrollable overflow.",
      "value": "linear-gradient(in oklch to left, transparent, var(--sf-color-bg))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-gradient-fade--r",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "gradient",
      "category": "Core tokens",
      "group": "Gradients",
      "description": "Pre-built gradient shorthands for brand fills and directional fade effects.",
      "note": "Fade-to-right gradient. Use to indicate right-side scrollable overflow.",
      "value": "linear-gradient(in oklch to right, transparent, var(--sf-color-bg))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-gradient-fade--t",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "gradient",
      "category": "Core tokens",
      "group": "Gradients",
      "description": "Pre-built gradient shorthands for brand fills and directional fade effects.",
      "note": "Fade-to-top gradient (transparent → surface). Use to fade content into a background above.",
      "value": "linear-gradient(in oklch to top, transparent, var(--sf-color-bg))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-gradient-primary",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "gradient",
      "category": "Core tokens",
      "group": "Gradients",
      "description": "Pre-built gradient shorthands for brand fills and directional fade effects.",
      "note": "Gradient using primary palette colors (light to saturated).",
      "value": "linear-gradient(in oklch 135deg, var(--sf-color-primary), oklch(from var(--sf-color-primary) calc(l - 0.08) c h))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-gradient-secondary",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "gradient",
      "category": "Core tokens",
      "group": "Gradients",
      "description": "Pre-built gradient shorthands for brand fills and directional fade effects.",
      "note": "Gradient using secondary palette colors.",
      "value": "linear-gradient(in oklch 135deg, var(--sf-color-secondary), oklch(from var(--sf-color-secondary) calc(l - 0.08) c h))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-gradient-surface",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "gradient",
      "category": "Core tokens",
      "group": "Gradients",
      "description": "Pre-built gradient shorthands for brand fills and directional fade effects.",
      "note": "Subtle surface-color gradient for depth layering and glass effects.",
      "value": "linear-gradient(in oklab 180deg, var(--sf-color-surface), var(--sf-color-bg))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-gradient-tertiary",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "gradient",
      "category": "Core tokens",
      "group": "Gradients",
      "description": "Pre-built gradient shorthands for brand fills and directional fade effects.",
      "note": "Gradient using tertiary palette colors.",
      "value": "linear-gradient(in oklch 135deg, var(--sf-color-tertiary), oklch(from var(--sf-color-tertiary) calc(l - 0.08) c h))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-grid-gap",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "grid",
      "category": "Layout tokens",
      "group": "Grid (auto-fill, breakpoint-free)",
      "description": "Configuration tokens for the responsive auto-fill grid. Set --sf-grid-min to control the minimum column width.",
      "note": "Gap between auto-fill grid cells.",
      "value": "var(--sf-gap)",
      "aliasOf": "--sf-gap",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-grid-min",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "grid",
      "category": "Layout tokens",
      "group": "Grid (auto-fill, breakpoint-free)",
      "description": "Configuration tokens for the responsive auto-fill grid. Set --sf-grid-min to control the minimum column width.",
      "note": "Minimum column width for the auto-fill grid.",
      "value": "16rem",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-grid-min-2xl",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "grid",
      "category": "Layout tokens",
      "group": "Grid (auto-fill, breakpoint-free)",
      "description": "Configuration tokens for the responsive auto-fill grid. Set --sf-grid-min to control the minimum column width.",
      "note": "Minimum column width at the 2× breakpoint.",
      "value": "28rem",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-grid-min-l",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "grid",
      "category": "Layout tokens",
      "group": "Grid (auto-fill, breakpoint-free)",
      "description": "Configuration tokens for the responsive auto-fill grid. Set --sf-grid-min to control the minimum column width.",
      "note": "Large minimum column width for the auto-fill grid.",
      "value": "20rem",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-grid-min-m",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "grid",
      "category": "Layout tokens",
      "group": "Grid (auto-fill, breakpoint-free)",
      "description": "Configuration tokens for the responsive auto-fill grid. Set --sf-grid-min to control the minimum column width.",
      "note": "Medium minimum column width for the auto-fill grid.",
      "value": "16rem",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-grid-min-s",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "grid",
      "category": "Layout tokens",
      "group": "Grid (auto-fill, breakpoint-free)",
      "description": "Configuration tokens for the responsive auto-fill grid. Set --sf-grid-min to control the minimum column width.",
      "note": "Small minimum column width for the auto-fill grid.",
      "value": "13rem",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-grid-min-xl",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "grid",
      "category": "Layout tokens",
      "group": "Grid (auto-fill, breakpoint-free)",
      "description": "Configuration tokens for the responsive auto-fill grid. Set --sf-grid-min to control the minimum column width.",
      "note": "Extra-large minimum column width for the auto-fill grid. Use for wide content cards.",
      "value": "24rem",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-grid-min-xs",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "grid",
      "category": "Layout tokens",
      "group": "Grid (auto-fill, breakpoint-free)",
      "description": "Configuration tokens for the responsive auto-fill grid. Set --sf-grid-min to control the minimum column width.",
      "note": "Extra-small minimum column width for the auto-fill grid. Use for very compact tile layouts (icon grids).",
      "value": "10rem",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-gutter",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "gutter",
      "category": "Core tokens",
      "group": "Semantic gap tokens",
      "description": "Wide page/section-edge gutter (used by center/container). Override to set the page-edge breathing room across breakpoints.",
      "note": "Wide page/section-edge gutter (used by center/container). Override to set the page-edge breathing room across breakpoints.",
      "value": "var(--sf-space-l)",
      "aliasOf": "--sf-space-l",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h1-font-weight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "h1",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Font weight for <h1>.",
      "value": "var(--sf-font-weight-heading)",
      "aliasOf": "--sf-font-weight-heading",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h1-letter-spacing",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "h1",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Letter-spacing for <h1>. Typically slightly negative at large sizes.",
      "value": "var(--sf-tracking-tight)",
      "aliasOf": "--sf-tracking-tight",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h1-line-height",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "h1",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Line height for <h1>. Tighter than body to avoid excessive whitespace at large sizes.",
      "value": "var(--sf-leading-tight)",
      "aliasOf": "--sf-leading-tight",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h1-max-width",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "h1",
      "category": "Core tokens",
      "group": "Heading line-length constraints",
      "description": "Per-heading max-inline-size caps. Default none (unconstrained). Set to a ch value to cap a heading level's line length for readability on wide screens.",
      "note": "Max-inline-size cap for <h1>. Default none (unconstrained). Set to a ch value (e.g. 20ch) to prevent wide headings from spanning the full column on large screens.",
      "value": "none",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h1-size",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "h1",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Font size for <h1>.",
      "value": "var(--sf-text-4xl)",
      "aliasOf": "--sf-text-4xl",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h2-font-weight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "h2",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Font weight for <h2>.",
      "value": "var(--sf-font-weight-heading)",
      "aliasOf": "--sf-font-weight-heading",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h2-letter-spacing",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "h2",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Letter-spacing for <h2>.",
      "value": "var(--sf-tracking-tight)",
      "aliasOf": "--sf-tracking-tight",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h2-line-height",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "h2",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Line height for <h2>.",
      "value": "var(--sf-leading-tight)",
      "aliasOf": "--sf-leading-tight",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h2-max-width",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "h2",
      "category": "Core tokens",
      "group": "Heading line-length constraints",
      "description": "Per-heading max-inline-size caps. Default none (unconstrained). Set to a ch value to cap a heading level's line length for readability on wide screens.",
      "note": "Max-inline-size cap for <h2>. Default none.",
      "value": "none",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h2-size",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "h2",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Font size for <h2>.",
      "value": "var(--sf-text-3xl)",
      "aliasOf": "--sf-text-3xl",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h3-font-weight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "h3",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Font weight for <h3>.",
      "value": "var(--sf-font-weight-heading)",
      "aliasOf": "--sf-font-weight-heading",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h3-letter-spacing",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "h3",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Letter-spacing for <h3>.",
      "value": "var(--sf-tracking-normal)",
      "aliasOf": "--sf-tracking-normal",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h3-line-height",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "h3",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Line height for <h3>.",
      "value": "var(--sf-leading-snug)",
      "aliasOf": "--sf-leading-snug",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h3-max-width",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "h3",
      "category": "Core tokens",
      "group": "Heading line-length constraints",
      "description": "Per-heading max-inline-size caps. Default none (unconstrained). Set to a ch value to cap a heading level's line length for readability on wide screens.",
      "note": "Max-inline-size cap for <h3>. Default none.",
      "value": "none",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h3-size",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "h3",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Font size for <h3>.",
      "value": "var(--sf-text-2xl)",
      "aliasOf": "--sf-text-2xl",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h4-font-weight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "h4",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Font weight for <h4>.",
      "value": "var(--sf-font-weight-heading)",
      "aliasOf": "--sf-font-weight-heading",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h4-letter-spacing",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "h4",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Letter-spacing for <h4>.",
      "value": "var(--sf-tracking-normal)",
      "aliasOf": "--sf-tracking-normal",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h4-line-height",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "h4",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Line height for <h4>.",
      "value": "var(--sf-leading-snug)",
      "aliasOf": "--sf-leading-snug",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h4-max-width",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "h4",
      "category": "Core tokens",
      "group": "Heading line-length constraints",
      "description": "Per-heading max-inline-size caps. Default none (unconstrained). Set to a ch value to cap a heading level's line length for readability on wide screens.",
      "note": "Max-inline-size cap for <h4>. Default none.",
      "value": "none",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h4-size",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "h4",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Font size for <h4>.",
      "value": "var(--sf-text-xl)",
      "aliasOf": "--sf-text-xl",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h5-font-weight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "h5",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Font weight for <h5>.",
      "value": "var(--sf-font-weight-heading)",
      "aliasOf": "--sf-font-weight-heading",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h5-letter-spacing",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "h5",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Letter-spacing for <h5>.",
      "value": "var(--sf-tracking-normal)",
      "aliasOf": "--sf-tracking-normal",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h5-line-height",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "h5",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Line height for <h5>.",
      "value": "var(--sf-leading-normal)",
      "aliasOf": "--sf-leading-normal",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h5-max-width",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "h5",
      "category": "Core tokens",
      "group": "Heading line-length constraints",
      "description": "Per-heading max-inline-size caps. Default none (unconstrained). Set to a ch value to cap a heading level's line length for readability on wide screens.",
      "note": "Max-inline-size cap for <h5>. Default none.",
      "value": "none",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h5-size",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "h5",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Font size for <h5>.",
      "value": "var(--sf-text-l)",
      "aliasOf": "--sf-text-l",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h6-font-weight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "h6",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Font weight for <h6>.",
      "value": "var(--sf-font-weight-heading)",
      "aliasOf": "--sf-font-weight-heading",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h6-letter-spacing",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "h6",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Letter-spacing for <h6>.",
      "value": "var(--sf-tracking-wide)",
      "aliasOf": "--sf-tracking-wide",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h6-line-height",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "h6",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Line height for <h6>.",
      "value": "var(--sf-leading-normal)",
      "aliasOf": "--sf-leading-normal",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h6-max-width",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "h6",
      "category": "Core tokens",
      "group": "Heading line-length constraints",
      "description": "Per-heading max-inline-size caps. Default none (unconstrained). Set to a ch value to cap a heading level's line length for readability on wide screens.",
      "note": "Max-inline-size cap for <h6>. Default none.",
      "value": "none",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-h6-size",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "h6",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Font size for <h6>.",
      "value": "var(--sf-text-m)",
      "aliasOf": "--sf-text-m",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-header-height",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "header",
      "category": "Core tokens",
      "group": "Layout & a11y",
      "description": "Focus ring, header height, sticky offset, touch-target, text-contrast knobs, and device safe-area insets. These govern keyboard accessibility, scroll behaviour, and adaptive contrast globally.",
      "note": "Total height of the sticky page header. Used by --sf-sticky-offset to prevent content from hiding under it.",
      "value": "clamp( var(--sf-header-height-mobile), calc((var(--sf-header-height-desktop) - var(--sf-header-height-mobile)) / ((var(--sf-fluid-max-vw) - var(--sf-fluid-min-vw)) * 1rem) * (100vw - var(--sf-fluid-min-vw) * 1rem) + var(--sf-header-height-mobile)), var(--sf-header-height-desktop))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-header-height-desktop",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "header",
      "category": "Core tokens",
      "group": "Layout & a11y",
      "description": "Focus ring, header height, sticky offset, touch-target, text-contrast knobs, and device safe-area insets. These govern keyboard accessibility, scroll behaviour, and adaptive contrast globally.",
      "note": "Header height at desktop breakpoints.",
      "value": "5rem",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-header-height-mobile",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "header",
      "category": "Core tokens",
      "group": "Layout & a11y",
      "description": "Focus ring, header height, sticky offset, touch-target, text-contrast knobs, and device safe-area insets. These govern keyboard accessibility, scroll behaviour, and adaptive contrast globally.",
      "note": "Header height at mobile breakpoints.",
      "value": "3.5rem",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-heading-color",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "heading",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Text color for all headings (h1–h6). Alias of --sf-color-heading.",
      "value": "var(--sf-color-heading)",
      "aliasOf": "--sf-color-heading",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-heading-font-family",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "heading",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "Font family for all headings. Alias of --sf-font-heading.",
      "value": "var(--sf-font-heading)",
      "aliasOf": "--sf-font-heading",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-heading-text-wrap",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "heading",
      "category": "Core tokens",
      "group": "TYPOGRAPHY ALIASES",
      "description": "Part of the per-style typography bundle for a named text role (body, code, heading, h1–h6, display). The full bundle spans font-family, size, weight, line-height, and letter-spacing across related tokens.",
      "note": "text-wrap for headings. 'balance' prevents orphaned short last lines in multi-line headings.",
      "value": "balance",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-hover-grow-scale",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "hover",
      "category": "Core tokens",
      "group": "Animation presets",
      "description": "Complete animation shorthand values — pair named @keyframes with duration and easing. Use directly as animation property values.",
      "note": "Scale factor applied by .sf-hover-grow on hover (>1 grows).",
      "value": "1.05",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-hover-lift",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "hover",
      "category": "Core tokens",
      "group": "Animation presets",
      "description": "Complete animation shorthand values — pair named @keyframes with duration and easing. Use directly as animation property values.",
      "note": "Translate distance for .sf-hover-float (up) and .sf-hover-sink (down) on hover.",
      "value": "0.25em",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-hover-shrink-scale",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "hover",
      "category": "Core tokens",
      "group": "Animation presets",
      "description": "Complete animation shorthand values — pair named @keyframes with duration and easing. Use directly as animation property values.",
      "note": "Scale factor applied by .sf-hover-shrink on hover (<1 shrinks).",
      "value": "0.95",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-hover-slide",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "hover",
      "category": "Core tokens",
      "group": "Animation presets",
      "description": "Complete animation shorthand values — pair named @keyframes with duration and easing. Use directly as animation property values.",
      "note": "Translate distance for .sf-hover-slide-start / .sf-hover-slide-end on hover.",
      "value": "0.5em",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-icon-2xl",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "icon",
      "category": "Core tokens",
      "group": "Icon sizes",
      "description": "Standard icon sizes tied to the type scale.",
      "note": "2× large icon size (~40px+). Hero or onboarding icons.",
      "value": "4em",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-icon-box-bg",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "icon",
      "category": "Layout tokens",
      "group": "Icon (boxed variant)",
      "description": "Background, border, and padding for boxed icon containers.",
      "note": "Background color for boxed icon containers.",
      "value": "var(--sf-color-inset)",
      "aliasOf": "--sf-color-inset",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-icon-box-border",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "icon",
      "category": "Layout tokens",
      "group": "Icon (boxed variant)",
      "description": "Background, border, and padding for boxed icon containers.",
      "note": "Border for boxed icon containers.",
      "value": "var(--sf-border-width-1) solid var(--sf-color-border)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-icon-box-pad",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "icon",
      "category": "Layout tokens",
      "group": "Icon (boxed variant)",
      "description": "Background, border, and padding for boxed icon containers.",
      "note": "Padding inside boxed icon containers.",
      "value": "0.5em",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-icon-box-radius",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "icon",
      "category": "Layout tokens",
      "group": "Icon (boxed variant)",
      "description": "Background, border, and padding for boxed icon containers.",
      "note": "Border radius for boxed icon containers.",
      "value": "var(--sf-radius-s)",
      "aliasOf": "--sf-radius-s",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-icon-l",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "icon",
      "category": "Core tokens",
      "group": "Icon sizes",
      "description": "Standard icon sizes tied to the type scale.",
      "note": "Large icon size (~24px). Standalone icon buttons.",
      "value": "2em",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-icon-m",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "icon",
      "category": "Core tokens",
      "group": "Icon sizes",
      "description": "Standard icon sizes tied to the type scale.",
      "note": "Medium icon size (~20px). Default for inline and button icons.",
      "value": "1.5em",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-icon-s",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "icon",
      "category": "Core tokens",
      "group": "Icon sizes",
      "description": "Standard icon sizes tied to the type scale.",
      "note": "Small icon size (~16px). Dense UI chrome.",
      "value": "1em",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-icon-xl",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "icon",
      "category": "Core tokens",
      "group": "Icon sizes",
      "description": "Standard icon sizes tied to the type scale.",
      "note": "Extra-large icon size (~32px). Feature icons.",
      "value": "3em",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-icon-xs",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "icon",
      "category": "Core tokens",
      "group": "Icon sizes",
      "description": "Standard icon sizes tied to the type scale.",
      "note": "Extra-small icon size (~12px). Inline indicators.",
      "value": "0.875em",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-imposter-margin",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "imposter",
      "category": "Layout tokens",
      "group": "Imposter (centered absolute/fixed overlay)",
      "description": "Margin for the imposter layout (centered fixed/absolute overlay).",
      "note": "Margin between the imposter overlay and the viewport edges.",
      "value": "var(--sf-space-m)",
      "aliasOf": "--sf-space-m",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-is-dark",
      "tier": "INTERNAL",
      "role": "knob",
      "namespace": "is",
      "category": "Core tokens",
      "group": "DARK SOURCE TOKENS (-dark, animatable)",
      "description": "OKLCH dark source tokens for brand and status colors. Registered as typed <color> so scoped [data-theme=\"dark\"] sections inherit correct absolute values rather than an unresolved var() text string.",
      "note": "Mode flag — 0 in light mode, 1 in dark mode. Set automatically by [data-theme='dark'] and prefers-color-scheme. Drives dark-mode formula branches in calc().",
      "value": "0",
      "aliasOf": null,
      "registered": true,
      "syntax": "<integer>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-leading-normal",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "leading",
      "category": "Core tokens",
      "group": "Line heights & letter spacing",
      "description": "Typographic fine-tuning tokens: leading (line-height) and tracking (letter-spacing) for every weight class.",
      "note": "Normal line height (~1.5). Default for body text.",
      "value": "1.5",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-leading-relaxed",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "leading",
      "category": "Core tokens",
      "group": "Line heights & letter spacing",
      "description": "Typographic fine-tuning tokens: leading (line-height) and tracking (letter-spacing) for every weight class.",
      "note": "Relaxed line height (~1.65). Long-form reading text.",
      "value": "1.625",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-leading-snug",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "leading",
      "category": "Core tokens",
      "group": "Line heights & letter spacing",
      "description": "Typographic fine-tuning tokens: leading (line-height) and tracking (letter-spacing) for every weight class.",
      "note": "Snug line height (~1.35). Use for sub-headings.",
      "value": "1.3",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-leading-taper",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "leading",
      "category": "Core tokens",
      "group": "Line heights & letter spacing",
      "description": "Typographic fine-tuning tokens: leading (line-height) and tracking (letter-spacing) for every weight class.",
      "note": "Progressive leading tightener: each step up the type scale subtracts step-index × taper from its per-size line-height token. Default 0 keeps the curated defaults.",
      "value": "0",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-leading-tight",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "leading",
      "category": "Core tokens",
      "group": "Line heights & letter spacing",
      "description": "Typographic fine-tuning tokens: leading (line-height) and tracking (letter-spacing) for every weight class.",
      "note": "Tight line height (~1.2). Use for large display headings.",
      "value": "1.1",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-line-clamp",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "line",
      "category": "Macro tokens",
      "group": "Line clamp",
      "description": "Number of lines before text truncates with an ellipsis.",
      "note": "Number of visible lines before text is clipped with an ellipsis.",
      "value": "3",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-link-external-label",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "link",
      "category": "Core tokens",
      "group": "Semantic gap tokens",
      "description": "Accessible name for the .sf-link-external marker glyph, read by screen readers via the CSS content alt-text syntax. Localise or clear alongside --sf-link-external-marker.",
      "note": "Accessible name for the .sf-link-external marker glyph, read by screen readers via the CSS content alt-text syntax. Localise or clear alongside --sf-link-external-marker.",
      "value": "\"opens in a new window or external site\"",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-link-external-marker",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "link",
      "category": "Core tokens",
      "group": "Semantic gap tokens",
      "description": "CSS content value appended to external links (e.g. \" ↗\"). Used by the .external-link pseudo-element pattern.",
      "note": "CSS content value appended to external links (e.g. \" ↗\"). Used by the .external-link pseudo-element pattern.",
      "value": "\" \\2197\"",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-link-underline-offset",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "link",
      "category": "Core tokens",
      "group": "Links",
      "description": "Colors and text-decoration properties for hyperlinks in every interactive state.",
      "note": "Vertical offset of the link underline from the text baseline.",
      "value": "0.15em",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-link-underline-thickness",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "link",
      "category": "Core tokens",
      "group": "Links",
      "description": "Colors and text-decoration properties for hyperlinks in every interactive state.",
      "note": "Stroke width of the link underline.",
      "value": "auto",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-lumlocker",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "lumlocker",
      "category": "Core tokens",
      "group": "LumLocker",
      "description": "OKLCH lightness lock for the data-lumlocker attribute. Pins surface brightness to a fixed L value — useful for always-dark or always-light sections that must stay stable while the rest of the page switches color-scheme.",
      "note": "OKLCH lightness lock value for light mode. When :root has [data-lumlocker], the 4 brand colors (primary, secondary, tertiary, action) are remapped to this L so their contrast remains constant as hues shift. Dark mode uses --sf-lumlocker-dark.",
      "value": "0.65",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-lumlocker-dark",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "lumlocker",
      "category": "Core tokens",
      "group": "LumLocker",
      "description": "OKLCH lightness lock for the data-lumlocker attribute. Pins surface brightness to a fixed L value — useful for always-dark or always-light sections that must stay stable while the rest of the page switches color-scheme.",
      "note": "OKLCH lightness lock value for dark mode under [data-lumlocker]. Defaults to clamp(0.5, calc(1.18 - var(--sf-lumlocker)), 0.92) — the mirror of the light L around the light/dark background midpoint — so the lock keeps equivalent contrast against the surface in both themes. Set explicitly to break the mirror.",
      "value": "clamp(0.5, calc(1.18 - var(--sf-lumlocker)), 0.92)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-marker-color",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "marker",
      "category": "Macro tokens",
      "group": "List markers",
      "description": "Shared list-marker (::marker) colour — single source of truth for the .sf-marker--* utilities and .sf-prose markers alike. Defaults to the primary brand colour; set it on any list (or globally) to retune every marker at once.",
      "note": "Shared list-marker (::marker) colour — single source of truth for the .sf-marker--* utilities and .sf-prose markers alike. Defaults to the primary brand colour; set it on any list (or globally) to retune every marker at once.",
      "value": "var(--sf-color-primary)",
      "aliasOf": "--sf-color-primary",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-mask-scrim-end",
      "tier": "PUBLIC-ADVANCED",
      "role": "consumption",
      "namespace": "mask",
      "category": "Core tokens",
      "group": "Mask scrim",
      "description": "Edge-fade stop positions for the scroll-shadow mask effect on overflowing containers. Expressed as percentages or lengths; consumed by mask-image gradients.",
      "note": "End stop for edge-fade mask gradients. Mirrors --sf-mask-scrim-start for the trailing edge of a scroll container.",
      "value": "var(--sf-space-l)",
      "aliasOf": "--sf-space-l",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-mask-scrim-start",
      "tier": "PUBLIC-ADVANCED",
      "role": "consumption",
      "namespace": "mask",
      "category": "Core tokens",
      "group": "Mask scrim",
      "description": "Edge-fade stop positions for the scroll-shadow mask effect on overflowing containers. Expressed as percentages or lengths; consumed by mask-image gradients.",
      "note": "Start stop for edge-fade mask gradients on scroll reels / overflow containers. Use in mask-image: linear-gradient(..., transparent var(--sf-mask-scrim-start)) to fade content near the leading edge.",
      "value": "var(--sf-space-l)",
      "aliasOf": "--sf-space-l",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-media-radius",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "media",
      "category": "Core tokens",
      "group": "Full/pill",
      "description": "Topological constants for rounding: full (50%) for circles, pill (9999px) for tags. Also provides --sf-radius-outer, a concentric-radius helper for outer containers wrapping inner rounded elements.",
      "note": "Opt-in global corner radius for <img>/<figure>. 0 (off) by default; set it to a --sf-radius-* value to round media globally. Applied via :where() so it never fights .sf-bg-layer or a component's own radius.",
      "value": "0",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-motion-scale",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "motion",
      "category": "Core tokens",
      "group": "Scale multipliers",
      "description": "Global proportional multipliers for the four main design axes (type, space, radius, motion). Adjusting one multiplier uniformly scales every clamp() value in that dimension.",
      "note": "Global motion multiplier. All transition and animation durations multiply by this factor. Set to 0 to disable all motion; reduce below 1 for snappier feel.",
      "value": "1",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-object-fit",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "object",
      "category": "Core tokens",
      "group": "Object fit / position",
      "description": "Defaults for object-fit and object-position on replaced elements (img, video).",
      "note": "Default object-fit value for replaced elements (img, video).",
      "value": "cover",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-object-position",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "object",
      "category": "Core tokens",
      "group": "Object fit / position",
      "description": "Defaults for object-fit and object-position on replaced elements (img, video).",
      "note": "Default object-position for replaced elements.",
      "value": "50% 50%",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-opacity-disabled",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "opacity",
      "category": "Core tokens",
      "group": "Opacity",
      "description": "Opacity tokens for specific UI states: --sf-opacity-disabled dims non-interactive elements.",
      "note": "Opacity for disabled UI elements (typically 0.4–0.5).",
      "value": "0.45",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-opacity-muted",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "opacity",
      "category": "Core tokens",
      "group": "Blur & opacity",
      "description": "Backdrop-filter blur scale and background-opacity tokens.",
      "note": "General de-emphasis opacity for secondary content, ghost elements, or non-primary layers. Default 0.5.",
      "value": "0.5",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-optical-sizing",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "optical",
      "category": "Core tokens",
      "group": "Font families",
      "description": "Font family stacks for every typographic role. Override these to swap typefaces without touching individual text styles.",
      "note": "CSS font-optical-sizing value. 'auto' lets the browser optimize letterforms for the rendered size. Set 'none' to disable optical sizing.",
      "value": "auto",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-palette-shade-l",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "palette",
      "category": "Core tokens",
      "group": "Palette ramp lightness anchors",
      "description": "Absolute OKLCH lightness the shade steps (600-950) pull toward; sets how dark the darkest palette step can reach. Default 0.1.",
      "note": "Absolute OKLCH lightness the shade steps (600-950) pull toward; sets how dark the darkest palette step can reach. Default 0.1.",
      "value": "0.1",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-palette-tint-l",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "palette",
      "category": "Core tokens",
      "group": "Palette ramp lightness anchors",
      "description": "Absolute OKLCH lightness the tint steps (50-400) pull toward; sets how light the lightest palette step can reach. Default 0.97.",
      "note": "Absolute OKLCH lightness the tint steps (50-400) pull toward; sets how light the lightest palette step can reach. Default 0.97.",
      "value": "0.97",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-prose-block-margin",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "prose",
      "category": "Macro tokens",
      "group": "Prose",
      "description": "Fine-grained typography controls for the .prose macro (margins, blockquote style, link decoration, etc.).",
      "note": "Block margin between prose elements (h2, p, ul, etc.).",
      "value": "var(--sf-space-m)",
      "aliasOf": "--sf-space-m",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-prose-blockquote-border",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "prose",
      "category": "Macro tokens",
      "group": "Prose",
      "description": "Fine-grained typography controls for the .prose macro (margins, blockquote style, link decoration, etc.).",
      "note": "Left border style for blockquotes inside prose.",
      "value": "var(--sf-border-width-2) solid var(--sf-color-border--subtle)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-prose-blockquote-padding",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "prose",
      "category": "Macro tokens",
      "group": "Prose",
      "description": "Fine-grained typography controls for the .prose macro (margins, blockquote style, link decoration, etc.).",
      "note": "Inner padding for blockquotes inside prose.",
      "value": "var(--sf-space-m)",
      "aliasOf": "--sf-space-m",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-prose-figcaption-size",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "prose",
      "category": "Macro tokens",
      "group": "Prose",
      "description": "Fine-grained typography controls for the .prose macro (margins, blockquote style, link decoration, etc.).",
      "note": "Font size for figure captions inside .prose. Typically smaller than body text.",
      "value": "var(--sf-text-s)",
      "aliasOf": "--sf-text-s",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-prose-figure-margin",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "prose",
      "category": "Macro tokens",
      "group": "Prose",
      "description": "Fine-grained typography controls for the .prose macro (margins, blockquote style, link decoration, etc.).",
      "note": "Block margin around <figure> elements inside .prose.",
      "value": "var(--sf-space-l)",
      "aliasOf": "--sf-space-l",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-prose-heading-gap",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "prose",
      "category": "Macro tokens",
      "group": "Prose",
      "description": "Fine-grained typography controls for the .prose macro (margins, blockquote style, link decoration, etc.).",
      "note": "Space between a heading and the content that follows it inside .prose.",
      "value": "var(--sf-space-s)",
      "aliasOf": "--sf-space-s",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-prose-hr-margin",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "prose",
      "category": "Macro tokens",
      "group": "Prose",
      "description": "Fine-grained typography controls for the .prose macro (margins, blockquote style, link decoration, etc.).",
      "note": "Block margin around <hr> rules inside .prose.",
      "value": "var(--sf-space-l)",
      "aliasOf": "--sf-space-l",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-prose-list-gap",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "prose",
      "category": "Macro tokens",
      "group": "Prose",
      "description": "Fine-grained typography controls for the .prose macro (margins, blockquote style, link decoration, etc.).",
      "note": "Gap between list items inside .prose.",
      "value": "var(--sf-space-xs)",
      "aliasOf": "--sf-space-xs",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-prose-marker-color",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "prose",
      "category": "Macro tokens",
      "group": "Prose",
      "description": "Fine-grained typography controls for the .prose macro (margins, blockquote style, link decoration, etc.).",
      "note": "Color of list bullets and ordered-list numbers inside .sf-prose. Defaults to the shared --sf-marker-color; override per-instance for prose-scoped marker colour.",
      "value": "var(--sf-marker-color)",
      "aliasOf": "--sf-marker-color",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-prose-media-margin",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "prose",
      "category": "Macro tokens",
      "group": "Prose",
      "description": "Fine-grained typography controls for the .prose macro (margins, blockquote style, link decoration, etc.).",
      "note": "Block margin around images, video, and figures inside .prose.",
      "value": "var(--sf-space-m)",
      "aliasOf": "--sf-space-m",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-prose-media-radius",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "prose",
      "category": "Macro tokens",
      "group": "Prose",
      "description": "Fine-grained typography controls for the .prose macro (margins, blockquote style, link decoration, etc.).",
      "note": "Border radius applied to images and media inside .prose.",
      "value": "var(--sf-radius-m)",
      "aliasOf": "--sf-radius-m",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-prose-nested-list-gap",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "prose",
      "category": "Macro tokens",
      "group": "Prose",
      "description": "Fine-grained typography controls for the .prose macro (margins, blockquote style, link decoration, etc.).",
      "note": "Gap between items in nested lists inside .prose.",
      "value": "var(--sf-space-2xs)",
      "aliasOf": "--sf-space-2xs",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-prose-paragraph",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "prose",
      "category": "Layout tokens",
      "group": "Prose",
      "description": "Max-width for the prose layout primitive (long-form reading column).",
      "note": "Max width of prose paragraphs (layout token for the prose layout).",
      "value": "var(--sf-content-gap)",
      "aliasOf": "--sf-content-gap",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-prose-table-pad",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "prose",
      "category": "Macro tokens",
      "group": "Prose",
      "description": "Fine-grained typography controls for the .prose macro (margins, blockquote style, link decoration, etc.).",
      "note": "Cell padding for tables inside .prose.",
      "value": "var(--sf-space-xs)",
      "aliasOf": "--sf-space-xs",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-radius-2xl",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "radius",
      "category": "Core tokens",
      "group": "Border radius",
      "description": "Border-radius scale from xs hairline to full circle. Stick to this scale so UI elements share a consistent curvature language.",
      "note": "2× large radius (~20px). Rounded card variants.",
      "value": "calc(24px * var(--sf-radius-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-radius-2xs",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "radius",
      "category": "Core tokens",
      "group": "Border radius",
      "description": "Border-radius scale from xs hairline to full circle. Stick to this scale so UI elements share a consistent curvature language.",
      "note": "Extra-extra-small radius (~1px). Minimal rounding for very tight UI elements.",
      "value": "calc(1px * var(--sf-radius-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-radius-3xl",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "radius",
      "category": "Core tokens",
      "group": "Border radius",
      "description": "Border-radius scale from xs hairline to full circle. Stick to this scale so UI elements share a consistent curvature language.",
      "note": "3× large radius (~24px). Large rounded surfaces.",
      "value": "calc(32px * var(--sf-radius-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-radius-4xl",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "radius",
      "category": "Core tokens",
      "group": "Border radius",
      "description": "Border-radius scale from xs hairline to full circle. Stick to this scale so UI elements share a consistent curvature language.",
      "note": "4× large radius (~32px). Near-pill rounding.",
      "value": "calc(48px * var(--sf-radius-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-radius-full",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "radius",
      "category": "Core tokens",
      "group": "Full/pill",
      "description": "Topological constants for rounding: full (50%) for circles, pill (9999px) for tags. Also provides --sf-radius-outer, a concentric-radius helper for outer containers wrapping inner rounded elements.",
      "note": "Full rounding (50%). For circular elements like avatars.",
      "value": "9999px",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-radius-l",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "radius",
      "category": "Core tokens",
      "group": "Border radius",
      "description": "Border-radius scale from xs hairline to full circle. Stick to this scale so UI elements share a consistent curvature language.",
      "note": "Large radius (~12px). Modals, popovers, panels.",
      "value": "calc(12px * var(--sf-radius-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-radius-m",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "radius",
      "category": "Core tokens",
      "group": "Border radius",
      "description": "Border-radius scale from xs hairline to full circle. Stick to this scale so UI elements share a consistent curvature language.",
      "note": "Medium radius (~6–8px). Default — inputs, standard buttons, cards.",
      "value": "calc(8px * var(--sf-radius-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-radius-none",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "radius",
      "category": "Core tokens",
      "group": "Border radius",
      "description": "Border-radius scale from xs hairline to full circle. Stick to this scale so UI elements share a consistent curvature language.",
      "note": "Zero border radius — square corners.",
      "value": "0",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-radius-outer",
      "tier": "PUBLIC-ADVANCED",
      "role": "consumption",
      "namespace": "radius",
      "category": "Core tokens",
      "group": "Full/pill",
      "description": "Topological constants for rounding: full (50%) for circles, pill (9999px) for tags. Also provides --sf-radius-outer, a concentric-radius helper for outer containers wrapping inner rounded elements.",
      "note": "Concentric corner helper: outer radius for a container that wraps content with inner radius of --sf-radius-m. Computed as --sf-radius-m + --sf-component-pad so corners align visually.",
      "value": "calc(var(--sf-radius-m) + var(--sf-component-pad))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-radius-pill",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "radius",
      "category": "Core tokens",
      "group": "Full/pill",
      "description": "Topological constants for rounding: full (50%) for circles, pill (9999px) for tags. Also provides --sf-radius-outer, a concentric-radius helper for outer containers wrapping inner rounded elements.",
      "note": "Pill rounding (9999px). Tags, toggle pills, status badges.",
      "value": "var(--sf-radius-full)",
      "aliasOf": "--sf-radius-full",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-radius-s",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "radius",
      "category": "Core tokens",
      "group": "Border radius",
      "description": "Border-radius scale from xs hairline to full circle. Stick to this scale so UI elements share a consistent curvature language.",
      "note": "Small radius (~4px). Badges, chips, small buttons.",
      "value": "calc(4px * var(--sf-radius-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-radius-scale",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "radius",
      "category": "Core tokens",
      "group": "Scale multipliers",
      "description": "Global proportional multipliers for the four main design axes (type, space, radius, motion). Adjusting one multiplier uniformly scales every clamp() value in that dimension.",
      "note": "Global border-radius multiplier. Scales the entire radius ramp up (>1) or down (<1) from one knob. Set to 0 for sharp corners everywhere.",
      "value": "1",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-radius-xl",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "radius",
      "category": "Core tokens",
      "group": "Border radius",
      "description": "Border-radius scale from xs hairline to full circle. Stick to this scale so UI elements share a consistent curvature language.",
      "note": "Extra-large radius (~16px). Prominent cards and feature blocks.",
      "value": "calc(16px * var(--sf-radius-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-radius-xs",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "radius",
      "category": "Core tokens",
      "group": "Border radius",
      "description": "Border-radius scale from xs hairline to full circle. Stick to this scale so UI elements share a consistent curvature language.",
      "note": "Hairline radius (~2px). Subtle rounding for tight components.",
      "value": "calc(2px * var(--sf-radius-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-ratio-3-2",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "ratio",
      "category": "Core tokens",
      "group": "Aspect ratios",
      "description": "Named aspect-ratio values for images, video embeds, and card thumbnails.",
      "note": "3:2 aspect ratio. Common for landscape photography.",
      "value": "3 / 2",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-ratio-4-3",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "ratio",
      "category": "Core tokens",
      "group": "Aspect ratios",
      "description": "Named aspect-ratio values for images, video embeds, and card thumbnails.",
      "note": "4:3 aspect ratio. Classic screen ratio.",
      "value": "4 / 3",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-ratio-cinema",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "ratio",
      "category": "Core tokens",
      "group": "Aspect ratios",
      "description": "Named aspect-ratio values for images, video embeds, and card thumbnails.",
      "note": "2.39:1 cinematic widescreen aspect ratio.",
      "value": "21 / 9",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-ratio-golden",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "ratio",
      "category": "Core tokens",
      "group": "Aspect ratios",
      "description": "Named aspect-ratio values for images, video embeds, and card thumbnails.",
      "note": "1.618:1 golden ratio. Harmonious proportions.",
      "value": "1.618 / 1",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-ratio-portrait",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "ratio",
      "category": "Core tokens",
      "group": "Aspect ratios",
      "description": "Named aspect-ratio values for images, video embeds, and card thumbnails.",
      "note": "2:3 portrait aspect ratio.",
      "value": "3 / 4",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-ratio-square",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "ratio",
      "category": "Core tokens",
      "group": "Aspect ratios",
      "description": "Named aspect-ratio values for images, video embeds, and card thumbnails.",
      "note": "1:1 square aspect ratio. Use for avatars, icon containers, and square thumbnails.",
      "value": "1",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-ratio-video",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "ratio",
      "category": "Core tokens",
      "group": "Aspect ratios",
      "description": "Named aspect-ratio values for images, video embeds, and card thumbnails.",
      "note": "16:9 widescreen video aspect ratio. Use for video embeds and video-thumbnail containers.",
      "value": "16 / 9",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-reel-gap",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "reel",
      "category": "Layout tokens",
      "group": "Reel",
      "description": "Configuration tokens for the reel layout (horizontal scroll container).",
      "note": "Gap between items in the horizontal reel.",
      "value": "var(--sf-gap)",
      "aliasOf": "--sf-gap",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-reel-height",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "reel",
      "category": "Layout tokens",
      "group": "Reel",
      "description": "Configuration tokens for the reel layout (horizontal scroll container).",
      "note": "Fixed height of the reel container.",
      "value": "auto",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-reel-item-width",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "reel",
      "category": "Layout tokens",
      "group": "Reel",
      "description": "Configuration tokens for the reel layout (horizontal scroll container).",
      "note": "Width of each item in the reel.",
      "value": "max-content",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-safe-bottom",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "safe",
      "category": "Core tokens",
      "group": "Layout & a11y",
      "description": "Focus ring, header height, sticky offset, touch-target, text-contrast knobs, and device safe-area insets. These govern keyboard accessibility, scroll behaviour, and adaptive contrast globally.",
      "note": "Device safe-area inset at the bottom edge (home indicator, gesture bar). Resolves to env(safe-area-inset-bottom, 0px). Use for fixed footers.",
      "value": "env(safe-area-inset-bottom, 0px)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-safe-left",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "safe",
      "category": "Core tokens",
      "group": "Layout & a11y",
      "description": "Focus ring, header height, sticky offset, touch-target, text-contrast knobs, and device safe-area insets. These govern keyboard accessibility, scroll behaviour, and adaptive contrast globally.",
      "note": "Device safe-area inset at the left edge. Resolves to env(safe-area-inset-left, 0px).",
      "value": "env(safe-area-inset-left, 0px)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-safe-right",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "safe",
      "category": "Core tokens",
      "group": "Layout & a11y",
      "description": "Focus ring, header height, sticky offset, touch-target, text-contrast knobs, and device safe-area insets. These govern keyboard accessibility, scroll behaviour, and adaptive contrast globally.",
      "note": "Device safe-area inset at the right edge (rounded corners, home indicator). Resolves to env(safe-area-inset-right, 0px).",
      "value": "env(safe-area-inset-right, 0px)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-safe-top",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "safe",
      "category": "Core tokens",
      "group": "Layout & a11y",
      "description": "Focus ring, header height, sticky offset, touch-target, text-contrast knobs, and device safe-area insets. These govern keyboard accessibility, scroll behaviour, and adaptive contrast globally.",
      "note": "Device safe-area inset at the top edge (notch, Dynamic Island). Resolves to env(safe-area-inset-top, 0px). Use for fixed headers on notched devices.",
      "value": "env(safe-area-inset-top, 0px)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-scrim-color",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "scrim",
      "category": "Macro tokens",
      "group": "Scrim",
      "description": "Gradient scrim configuration (direction, size, color) for overlaying images with readable text.",
      "note": "Base color of the gradient scrim overlay.",
      "value": "oklch(0 0 0 / 0.55)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-scrim-direction",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "scrim",
      "category": "Macro tokens",
      "group": "Scrim",
      "description": "Gradient scrim configuration (direction, size, color) for overlaying images with readable text.",
      "note": "Direction of the scrim gradient (to bottom, to top, etc.).",
      "value": "to top",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-scrim-gradient",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "scrim",
      "category": "Macro tokens",
      "group": "Scrim",
      "description": "Gradient scrim configuration (direction, size, color) for overlaying images with readable text.",
      "note": "Full gradient shorthand for the scrim. Override to customise the fade.",
      "value": "linear-gradient(var(--sf-scrim-direction), var(--sf-scrim-color), transparent)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-scrim-text-shadow",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "scrim",
      "category": "Macro tokens",
      "group": "Scrim",
      "description": "Gradient scrim configuration (direction, size, color) for overlaying images with readable text.",
      "note": "Text-shadow layered over the scrim gradient to ensure legibility for text placed directly on image backgrounds.",
      "value": "0 1px 3px oklch(0 0 0 / 0.6)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-scroll-offset-gap",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "scroll",
      "category": "Core tokens",
      "group": "Layout & a11y",
      "description": "Focus ring, header height, sticky offset, touch-target, text-contrast knobs, and device safe-area insets. These govern keyboard accessibility, scroll behaviour, and adaptive contrast globally.",
      "note": "Breathing room added below the header when scrolling to an in-page anchor (scroll-padding). Defaults to --sf-space-m so a heading lands a comfortable gap under the sticky header; set to 0 for the heading flush under the header, or any length to tune the gap without overriding the whole scroll-padding rule.",
      "value": "var(--sf-space-m)",
      "aliasOf": "--sf-space-m",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-scroll-shadow-size",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "scroll",
      "category": "Macro tokens",
      "group": "Scroll shadow / overflow fade",
      "description": "Size of the scroll-shadow fade effect on overflowing containers.",
      "note": "Size of the scroll-shadow fade effect on overflowing containers.",
      "value": "2rem",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-scroll-timeline-range-end",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "scroll",
      "category": "Core tokens",
      "group": "Scroll-driven animation range",
      "description": "animation-range start and end positions for scroll-driven entrance effects (animation-timeline: view()). Controls how far into the viewport an element must scroll before its entrance animation starts and ends.",
      "note": "animation-range end value for scroll-driven entrance effects. Default 'cover 30%'. Override on an element to control when its entrance animation finishes.",
      "value": "cover 30%",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-scroll-timeline-range-exit-end",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "scroll",
      "category": "Core tokens",
      "group": "Scroll-driven animation range",
      "description": "animation-range start and end positions for scroll-driven entrance effects (animation-timeline: view()). Controls how far into the viewport an element must scroll before its entrance animation starts and ends.",
      "note": "Scroll-timeline range at which a scroll-out exit animation finishes. Default: exit 100%.",
      "value": "exit 100%",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-scroll-timeline-range-exit-start",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "scroll",
      "category": "Core tokens",
      "group": "Scroll-driven animation range",
      "description": "animation-range start and end positions for scroll-driven entrance effects (animation-timeline: view()). Controls how far into the viewport an element must scroll before its entrance animation starts and ends.",
      "note": "Scroll-timeline range at which a scroll-out exit animation begins. Default: cover 70%.",
      "value": "cover 70%",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-scroll-timeline-range-start",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "scroll",
      "category": "Core tokens",
      "group": "Scroll-driven animation range",
      "description": "animation-range start and end positions for scroll-driven entrance effects (animation-timeline: view()). Controls how far into the viewport an element must scroll before its entrance animation starts and ends.",
      "note": "animation-range start value for scroll-driven entrance effects. Default 'entry 0%'. Override on an element to control when its entrance animation begins.",
      "value": "entry 0%",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-scrollbar-thumb",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "scrollbar",
      "category": "Core tokens",
      "group": "Scrollbar",
      "description": "Custom scrollbar thumb and track colors.",
      "note": "Color of the custom scrollbar thumb.",
      "value": "var(--sf-color-neutral)",
      "aliasOf": "--sf-color-neutral",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-scrollbar-track",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "scrollbar",
      "category": "Core tokens",
      "group": "Scrollbar",
      "description": "Custom scrollbar thumb and track colors.",
      "note": "Color of the custom scrollbar track.",
      "value": "transparent",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-section-pad",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "section",
      "category": "Core tokens",
      "group": "Section padding",
      "description": "Vertical padding for full-width page sections at each responsive tier.",
      "note": "Default vertical padding for full-width page sections.",
      "value": "var(--sf-section-pad--m)",
      "aliasOf": "--sf-section-pad--m",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-section-pad--2xl",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "section",
      "category": "Core tokens",
      "group": "Section padding",
      "description": "Vertical padding for full-width page sections at each responsive tier.",
      "note": "2× large section vertical padding for hero areas.",
      "value": "calc(var(--sf-space-4xl) * 2 * var(--sf-section-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-section-pad--l",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "section",
      "category": "Core tokens",
      "group": "Section padding",
      "description": "Vertical padding for full-width page sections at each responsive tier.",
      "note": "Large section vertical padding.",
      "value": "calc(var(--sf-space-4xl) * var(--sf-section-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-section-pad--m",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "section",
      "category": "Core tokens",
      "group": "Section padding",
      "description": "Vertical padding for full-width page sections at each responsive tier.",
      "note": "Medium section vertical padding.",
      "value": "calc(var(--sf-space-3xl) * var(--sf-section-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-section-pad--s",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "section",
      "category": "Core tokens",
      "group": "Section padding",
      "description": "Vertical padding for full-width page sections at each responsive tier.",
      "note": "Small section vertical padding.",
      "value": "calc(var(--sf-space-2xl) * var(--sf-section-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-section-pad--xl",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "section",
      "category": "Core tokens",
      "group": "Section padding",
      "description": "Vertical padding for full-width page sections at each responsive tier.",
      "note": "Extra-large vertical section padding for hero and feature sections.",
      "value": "calc(var(--sf-space-4xl) * 1.5 * var(--sf-section-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-section-pad--xs",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "section",
      "category": "Core tokens",
      "group": "Section padding",
      "description": "Vertical padding for full-width page sections at each responsive tier.",
      "note": "Extra-small vertical section padding for compact in-page modules.",
      "value": "calc(var(--sf-space-xl) * var(--sf-section-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-section-scale",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "section",
      "category": "Core tokens",
      "group": "Scale multipliers",
      "description": "Global proportional multipliers for the four main design axes (type, space, radius, motion). Adjusting one multiplier uniformly scales every clamp() value in that dimension.",
      "note": "Global multiplier applied to every --sf-section-pad--* size — one dial re-rhythms all section padding (default 1).",
      "value": "1",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-shadow-2xl",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "shadow",
      "category": "Core tokens",
      "group": "Output token @property registrations",
      "description": "Largest shadow for hero cards, feature highlights, and marketing surfaces.",
      "note": "Largest shadow for hero cards, feature highlights, and marketing surfaces.",
      "value": "0 4px 12px 0 oklch(from var(--sf-shadow-color) l c h / clamp(0, calc(var(--sf-shadow-strength) * 0.6), 0.7)), 0 20px 60px 0 oklch(from var(--sf-shadow-color) l c h / clamp(0, calc(var(--sf-shadow-strength) * 4), 0.7)), 0 40px 100px -8px oklch(from var(--sf-shadow-color) l c h / clamp(0, calc(var(--sf-shadow-strength) * 5), 0.7))",
      "aliasOf": null,
      "registered": true,
      "syntax": "*",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-shadow-color",
      "tier": "PUBLIC-ADVANCED",
      "role": "consumption",
      "namespace": "shadow",
      "category": "Core tokens",
      "group": "Shadow ramp (box-shadow, text-shadow, drop-shadow)",
      "description": "Elevation box-shadow ramp from xs to 2xl plus inner, text-shadow, and drop-shadow presets. All opacity values scale with --sf-shadow-strength so dark-mode contrast boost is automatic.",
      "note": "Near-black shadow tint derived from the neutral palette. Inherits the neutral's chroma and hue so colorless neutrals produce colorless shadows.",
      "value": "oklch(from var(--sf-color-neutral) var(--sf-shadow-lightness) c h)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-shadow-glow",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "shadow",
      "category": "Core tokens",
      "group": "Output token @property registrations",
      "description": "Glow box-shadow shorthand for decorative glow effects.",
      "note": "Glow box-shadow shorthand for decorative glow effects.",
      "value": "0 0 15px 2px oklch(from var(--sf-shadow-glow-color) l c h / clamp(0, calc(var(--sf-shadow-strength) * 2), 0.7))",
      "aliasOf": null,
      "registered": true,
      "syntax": "*",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-shadow-glow-color",
      "tier": "PUBLIC-ADVANCED",
      "role": "consumption",
      "namespace": "shadow",
      "category": "Core tokens",
      "group": "Shadow glow color",
      "description": "Tint color used by --sf-shadow-glow. Override to retint glows; opacity and dark-mode adaptation are handled automatically.",
      "note": "Ambient glow tint used by --sf-shadow-glow. Override to retint all glow shadows; opacity and dark-mode boost are controlled by --sf-shadow-strength.",
      "value": "var(--sf-color-primary)",
      "aliasOf": "--sf-color-primary",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-shadow-inner",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "shadow",
      "category": "Core tokens",
      "group": "Output token @property registrations",
      "description": "Inset shadow for pressed states, inset inputs, and recessed surfaces.",
      "note": "Inset shadow for pressed states, inset inputs, and recessed surfaces.",
      "value": "inset 0 2px 4px 0 oklch(from var(--sf-shadow-color) l c h / clamp(0, calc(var(--sf-shadow-strength) * 2), 0.7))",
      "aliasOf": null,
      "registered": true,
      "syntax": "*",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-shadow-l",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "shadow",
      "category": "Core tokens",
      "group": "Output token @property registrations",
      "description": "Large shadow for drawers, sidebars, and prominent elevated surfaces.",
      "note": "Large shadow for drawers, sidebars, and prominent elevated surfaces.",
      "value": "0 2px 4px 0 oklch(from var(--sf-shadow-color) l c h / clamp(0, calc(var(--sf-shadow-strength) * 0.5), 0.7)), 0 8px 24px 0 oklch(from var(--sf-shadow-color) l c h / clamp(0, calc(var(--sf-shadow-strength) * 3), 0.7)), 0 16px 48px 0 oklch(from var(--sf-shadow-color) l c h / clamp(0, calc(var(--sf-shadow-strength) * 2), 0.7))",
      "aliasOf": null,
      "registered": true,
      "syntax": "*",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-shadow-lightness",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "shadow",
      "category": "Core tokens",
      "group": "Shadow strength",
      "description": "Base opacity for the shadow ramp. --sf-shadow-lightness controls tonal density; --sf-shadow-strength is auto-boosted in dark mode so elevation reads on dark surfaces.",
      "note": "OKLCH lightness component of the shadow color. Lower = denser-looking shadows. Tune this independently of --sf-shadow-strength to control tonal weight without affecting opacity.",
      "value": "0.15",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-shadow-m",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "shadow",
      "category": "Core tokens",
      "group": "Output token @property registrations",
      "description": "Medium shadow for cards and content panels.",
      "note": "Medium shadow for cards and content panels.",
      "value": "0 1px 3px 0 oklch(from var(--sf-shadow-color) l c h / clamp(0, calc(var(--sf-shadow-strength) * 0.5), 0.7)), 0 4px 12px 0 oklch(from var(--sf-shadow-color) l c h / clamp(0, calc(var(--sf-shadow-strength) * 2), 0.7))",
      "aliasOf": null,
      "registered": true,
      "syntax": "*",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-shadow-none",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "shadow",
      "category": "Core tokens",
      "group": "Output token @property registrations",
      "description": "No box-shadow (resets inherited shadows). Use to explicitly remove elevation.",
      "note": "No box-shadow (resets inherited shadows). Use to explicitly remove elevation.",
      "value": "none",
      "aliasOf": null,
      "registered": true,
      "syntax": "*",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-shadow-s",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "shadow",
      "category": "Core tokens",
      "group": "Output token @property registrations",
      "description": "Small shadow for chips, tags, and inline elevated surfaces.",
      "note": "Small shadow for chips, tags, and inline elevated surfaces.",
      "value": "0 1px 2px 0 oklch(from var(--sf-shadow-color) l c h / clamp(0, calc(var(--sf-shadow-strength) * 0.5), 0.7)), 0 2px 6px 0 oklch(from var(--sf-shadow-color) l c h / clamp(0, var(--sf-shadow-strength), 0.7))",
      "aliasOf": null,
      "registered": true,
      "syntax": "*",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-shadow-strength",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "shadow",
      "category": "Core tokens",
      "group": "Shadow strength",
      "description": "Base opacity for the shadow ramp. --sf-shadow-lightness controls tonal density; --sf-shadow-strength is auto-boosted in dark mode so elevation reads on dark surfaces.",
      "note": "Base opacity for the entire shadow ramp. Auto-boosted in dark mode via --sf-is-dark. Override with calc() to preserve the adaptation: e.g. calc(0.12 + var(--sf-is-dark) * 0.17).",
      "value": "calc(0.08 + var(--sf-is-dark) * 0.17)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-shadow-xl",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "shadow",
      "category": "Core tokens",
      "group": "Output token @property registrations",
      "description": "Extra-large shadow for modals, dialogs, and high-elevation sheets.",
      "note": "Extra-large shadow for modals, dialogs, and high-elevation sheets.",
      "value": "0 2px 8px 0 oklch(from var(--sf-shadow-color) l c h / clamp(0, calc(var(--sf-shadow-strength) * 0.5), 0.7)), 0 12px 36px 0 oklch(from var(--sf-shadow-color) l c h / clamp(0, calc(var(--sf-shadow-strength) * 3.5), 0.7)), 0 24px 72px 0 oklch(from var(--sf-shadow-color) l c h / clamp(0, calc(var(--sf-shadow-strength) * 2.5), 0.7))",
      "aliasOf": null,
      "registered": true,
      "syntax": "*",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-shadow-xs",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "shadow",
      "category": "Core tokens",
      "group": "Output token @property registrations",
      "description": "Extra-small shadow for barely-elevated elements (focused inputs, small chips).",
      "note": "Extra-small shadow for barely-elevated elements (focused inputs, small chips).",
      "value": "0 1px 2px 0 oklch(from var(--sf-shadow-color) l c h / clamp(0, calc(var(--sf-shadow-strength) * 0.5), 0.7))",
      "aliasOf": null,
      "registered": true,
      "syntax": "*",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-sidebar-gap",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "sidebar",
      "category": "Layout tokens",
      "group": "Sidebar",
      "description": "Configuration tokens for the sidebar layout pattern (main content + fixed-width aside).",
      "note": "Gap between sidebar and main content column.",
      "value": "var(--sf-gap)",
      "aliasOf": "--sf-gap",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-sidebar-min-width",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "sidebar",
      "category": "Layout tokens",
      "group": "Sidebar",
      "description": "Configuration tokens for the sidebar layout pattern (main content + fixed-width aside).",
      "note": "Minimum sidebar width before the layout collapses to stacking.",
      "value": "50%",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-sidebar-width",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "sidebar",
      "category": "Layout tokens",
      "group": "Sidebar",
      "description": "Configuration tokens for the sidebar layout pattern (main content + fixed-width aside).",
      "note": "Preferred width of the sidebar column.",
      "value": "18rem",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-size-l",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "size",
      "category": "Core tokens",
      "group": "UI sizes",
      "description": "Fixed sizes for interactive components (buttons, inputs, chips) at S / M / L.",
      "note": "Large UI component height (~48px). Touch-friendly interactive elements.",
      "value": "3rem",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-size-m",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "size",
      "category": "Core tokens",
      "group": "UI sizes",
      "description": "Fixed sizes for interactive components (buttons, inputs, chips) at S / M / L.",
      "note": "~40px UI component height (scale rung `m`). The default `.sf-btn` min-height.",
      "value": "2.5rem",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-size-s",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "size",
      "category": "Core tokens",
      "group": "UI sizes",
      "description": "Fixed sizes for interactive components (buttons, inputs, chips) at S / M / L.",
      "note": "Small UI component height (~32px). Compact buttons and input variants.",
      "value": "2rem",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-size-xl",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "size",
      "category": "Core tokens",
      "group": "UI sizes",
      "description": "Fixed sizes for interactive components (buttons, inputs, chips) at S / M / L.",
      "note": "Extra-large interactive component height (~56px). For oversized or prominently touch-friendly controls.",
      "value": "3.5rem",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-size-xs",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "size",
      "category": "Core tokens",
      "group": "UI sizes",
      "description": "Fixed sizes for interactive components (buttons, inputs, chips) at S / M / L.",
      "note": "Extra-small interactive component height (~24px). For very compact inline elements and micro-controls.",
      "value": "1.5rem",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-space-2xl",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "space",
      "category": "Core tokens",
      "group": "Spacing",
      "description": "Fluid spacing scale from 0 to 4xl. Prefer these tokens over raw values to keep the rhythm consistent across breakpoints.",
      "note": "48px-equivalent spacing. Large section spacing.",
      "value": "calc(clamp(calc(var(--sf-space-base-min) * pow(var(--sf-space-ratio-min), 3) * 1rem), calc((var(--sf-space-base-max) * pow(var(--sf-space-ratio-max), 3) - var(--sf-space-base-min) * pow(var(--sf-space-ratio-min), 3)) / (var(--sf-fluid-max-vw) - var(--sf-fluid-min-vw)) * (var(--sf-fluid-width) - var(--sf-fluid-min-vw) * 1rem) + var(--sf-space-base-min) * pow(var(--sf-space-ratio-min), 3) * 1rem), calc(var(--sf-space-base-max) * pow(var(--sf-space-ratio-max), 3) * 1rem)) * var(--sf-space-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-space-2xs",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "space",
      "category": "Core tokens",
      "group": "Spacing",
      "description": "Fluid spacing scale from 0 to 4xl. Prefer these tokens over raw values to keep the rhythm consistent across breakpoints.",
      "note": "4px-equivalent spacing. Tight inline gaps, icon-to-text padding.",
      "value": "calc(clamp(calc(var(--sf-space-base-min) * pow(var(--sf-space-ratio-min), -3) * 1rem), calc((var(--sf-space-base-max) * pow(var(--sf-space-ratio-max), -3) - var(--sf-space-base-min) * pow(var(--sf-space-ratio-min), -3)) / (var(--sf-fluid-max-vw) - var(--sf-fluid-min-vw)) * (var(--sf-fluid-width) - var(--sf-fluid-min-vw) * 1rem) + var(--sf-space-base-min) * pow(var(--sf-space-ratio-min), -3) * 1rem), calc(var(--sf-space-base-max) * pow(var(--sf-space-ratio-max), -3) * 1rem)) * var(--sf-space-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-space-3xl",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "space",
      "category": "Core tokens",
      "group": "Spacing",
      "description": "Fluid spacing scale from 0 to 4xl. Prefer these tokens over raw values to keep the rhythm consistent across breakpoints.",
      "note": "64px-equivalent spacing. Extra-large layout gaps.",
      "value": "calc(clamp(calc(var(--sf-space-base-min) * pow(var(--sf-space-ratio-min), 4) * 1rem), calc((var(--sf-space-base-max) * pow(var(--sf-space-ratio-max), 4) - var(--sf-space-base-min) * pow(var(--sf-space-ratio-min), 4)) / (var(--sf-fluid-max-vw) - var(--sf-fluid-min-vw)) * (var(--sf-fluid-width) - var(--sf-fluid-min-vw) * 1rem) + var(--sf-space-base-min) * pow(var(--sf-space-ratio-min), 4) * 1rem), calc(var(--sf-space-base-max) * pow(var(--sf-space-ratio-max), 4) * 1rem)) * var(--sf-space-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-space-4xl",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "space",
      "category": "Core tokens",
      "group": "Spacing",
      "description": "Fluid spacing scale from 0 to 4xl. Prefer these tokens over raw values to keep the rhythm consistent across breakpoints.",
      "note": "96px-equivalent spacing. Hero / page-level section padding.",
      "value": "calc(clamp(calc(var(--sf-space-base-min) * pow(var(--sf-space-ratio-min), 5) * 1rem), calc((var(--sf-space-base-max) * pow(var(--sf-space-ratio-max), 5) - var(--sf-space-base-min) * pow(var(--sf-space-ratio-min), 5)) / (var(--sf-fluid-max-vw) - var(--sf-fluid-min-vw)) * (var(--sf-fluid-width) - var(--sf-fluid-min-vw) * 1rem) + var(--sf-space-base-min) * pow(var(--sf-space-ratio-min), 5) * 1rem), calc(var(--sf-space-base-max) * pow(var(--sf-space-ratio-max), 5) * 1rem)) * var(--sf-space-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-space-base-max",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "space",
      "category": "Core tokens",
      "group": "FLUID SCALE ENGINE",
      "description": "Generative inputs that drive all fluid clamp() type and spacing scales at runtime. Override the base, ratio, and viewport range tokens to globally rescale the entire system without touching individual step tokens.",
      "note": "Maximum base spacing unit (rem) at the widest viewport. Drives the top of the fluid spacing ramp. Part of the fluid scale engine.",
      "value": "2",
      "aliasOf": null,
      "registered": true,
      "syntax": "<number>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-space-base-min",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "space",
      "category": "Core tokens",
      "group": "FLUID SCALE ENGINE",
      "description": "Generative inputs that drive all fluid clamp() type and spacing scales at runtime. Override the base, ratio, and viewport range tokens to globally rescale the entire system without touching individual step tokens.",
      "note": "Minimum base spacing unit (rem) at the narrowest viewport. Drives the bottom of the fluid spacing ramp. Part of the fluid scale engine.",
      "value": "1",
      "aliasOf": null,
      "registered": true,
      "syntax": "<number>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-space-l",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "space",
      "category": "Core tokens",
      "group": "Spacing",
      "description": "Fluid spacing scale from 0 to 4xl. Prefer these tokens over raw values to keep the rhythm consistent across breakpoints.",
      "note": "24px-equivalent spacing. Card padding, section dividers.",
      "value": "calc(clamp(calc(var(--sf-space-base-min) * pow(var(--sf-space-ratio-min), 1) * 1rem), calc((var(--sf-space-base-max) * pow(var(--sf-space-ratio-max), 1) - var(--sf-space-base-min) * pow(var(--sf-space-ratio-min), 1)) / (var(--sf-fluid-max-vw) - var(--sf-fluid-min-vw)) * (var(--sf-fluid-width) - var(--sf-fluid-min-vw) * 1rem) + var(--sf-space-base-min) * pow(var(--sf-space-ratio-min), 1) * 1rem), calc(var(--sf-space-base-max) * pow(var(--sf-space-ratio-max), 1) * 1rem)) * var(--sf-space-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-space-m",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "space",
      "category": "Core tokens",
      "group": "Spacing",
      "description": "Fluid spacing scale from 0 to 4xl. Prefer these tokens over raw values to keep the rhythm consistent across breakpoints.",
      "note": "16px-equivalent spacing. Default unit, widely applicable.",
      "value": "calc(clamp(calc(var(--sf-space-base-min) * 1rem), calc((var(--sf-space-base-max) - var(--sf-space-base-min)) / (var(--sf-fluid-max-vw) - var(--sf-fluid-min-vw)) * (var(--sf-fluid-width) - var(--sf-fluid-min-vw) * 1rem) + var(--sf-space-base-min) * 1rem), calc(var(--sf-space-base-max) * 1rem)) * var(--sf-space-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-space-none",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "space",
      "category": "Core tokens",
      "group": "Spacing",
      "description": "Fluid spacing scale from 0 to 4xl. Prefer these tokens over raw values to keep the rhythm consistent across breakpoints.",
      "note": "Zero spacing. Explicit alias for clarity in utility classes.",
      "value": "0",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-space-px",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "space",
      "category": "Core tokens",
      "group": "Spacing",
      "description": "Fluid spacing scale from 0 to 4xl. Prefer these tokens over raw values to keep the rhythm consistent across breakpoints.",
      "note": "1px spacing. Hairline offset for fine adjustments.",
      "value": "1px",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-space-ratio-max",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "space",
      "category": "Core tokens",
      "group": "FLUID SCALE ENGINE",
      "description": "Generative inputs that drive all fluid clamp() type and spacing scales at runtime. Override the base, ratio, and viewport range tokens to globally rescale the entire system without touching individual step tokens.",
      "note": "Modular spacing ratio at the widest viewport. Controls step-to-step growth in the spacing ramp. Default 1.333 (perfect fourth). Part of the fluid scale engine.",
      "value": "1.333",
      "aliasOf": null,
      "registered": true,
      "syntax": "<number>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-space-ratio-min",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "space",
      "category": "Core tokens",
      "group": "FLUID SCALE ENGINE",
      "description": "Generative inputs that drive all fluid clamp() type and spacing scales at runtime. Override the base, ratio, and viewport range tokens to globally rescale the entire system without touching individual step tokens.",
      "note": "Modular spacing ratio at the narrowest viewport. Controls step-to-step growth in the spacing ramp. Default 1.25 (major third). Part of the fluid scale engine.",
      "value": "1.25",
      "aliasOf": null,
      "registered": true,
      "syntax": "<number>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-space-s",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "space",
      "category": "Core tokens",
      "group": "Spacing",
      "description": "Fluid spacing scale from 0 to 4xl. Prefer these tokens over raw values to keep the rhythm consistent across breakpoints.",
      "note": "12px-equivalent spacing. Form field inner padding, narrow gaps.",
      "value": "calc(clamp(calc(var(--sf-space-base-min) * pow(var(--sf-space-ratio-min), -1) * 1rem), calc((var(--sf-space-base-max) * pow(var(--sf-space-ratio-max), -1) - var(--sf-space-base-min) * pow(var(--sf-space-ratio-min), -1)) / (var(--sf-fluid-max-vw) - var(--sf-fluid-min-vw)) * (var(--sf-fluid-width) - var(--sf-fluid-min-vw) * 1rem) + var(--sf-space-base-min) * pow(var(--sf-space-ratio-min), -1) * 1rem), calc(var(--sf-space-base-max) * pow(var(--sf-space-ratio-max), -1) * 1rem)) * var(--sf-space-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-space-scale",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "space",
      "category": "Core tokens",
      "group": "Scale multipliers",
      "description": "Global proportional multipliers for the four main design axes (type, space, radius, motion). Adjusting one multiplier uniformly scales every clamp() value in that dimension.",
      "note": "Global spacing multiplier. Scales the fluid spacing ramp. Increase above 1 for airier layouts; reduce below 1 for compact UIs.",
      "value": "1",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-space-xl",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "space",
      "category": "Core tokens",
      "group": "Spacing",
      "description": "Fluid spacing scale from 0 to 4xl. Prefer these tokens over raw values to keep the rhythm consistent across breakpoints.",
      "note": "32px-equivalent spacing. Feature row gaps, generous section padding.",
      "value": "calc(clamp(calc(var(--sf-space-base-min) * pow(var(--sf-space-ratio-min), 2) * 1rem), calc((var(--sf-space-base-max) * pow(var(--sf-space-ratio-max), 2) - var(--sf-space-base-min) * pow(var(--sf-space-ratio-min), 2)) / (var(--sf-fluid-max-vw) - var(--sf-fluid-min-vw)) * (var(--sf-fluid-width) - var(--sf-fluid-min-vw) * 1rem) + var(--sf-space-base-min) * pow(var(--sf-space-ratio-min), 2) * 1rem), calc(var(--sf-space-base-max) * pow(var(--sf-space-ratio-max), 2) * 1rem)) * var(--sf-space-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-space-xs",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "space",
      "category": "Core tokens",
      "group": "Spacing",
      "description": "Fluid spacing scale from 0 to 4xl. Prefer these tokens over raw values to keep the rhythm consistent across breakpoints.",
      "note": "8px-equivalent spacing. Compact list rows, tab padding.",
      "value": "calc(clamp(calc(var(--sf-space-base-min) * pow(var(--sf-space-ratio-min), -2) * 1rem), calc((var(--sf-space-base-max) * pow(var(--sf-space-ratio-max), -2) - var(--sf-space-base-min) * pow(var(--sf-space-ratio-min), -2)) / (var(--sf-fluid-max-vw) - var(--sf-fluid-min-vw)) * (var(--sf-fluid-width) - var(--sf-fluid-min-vw) * 1rem) + var(--sf-space-base-min) * pow(var(--sf-space-ratio-min), -2) * 1rem), calc(var(--sf-space-base-max) * pow(var(--sf-space-ratio-max), -2) * 1rem)) * var(--sf-space-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-stack-gap",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "stack",
      "category": "Layout tokens",
      "group": "Stack",
      "description": "Gap for the stack layout primitive (vertically stacked blocks).",
      "note": "Vertical gap between stacked block-level elements in the stack layout.",
      "value": "var(--sf-content-gap)",
      "aliasOf": "--sf-content-gap",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-stagger-step",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "stagger",
      "category": "Core tokens",
      "group": "Animation presets",
      "description": "Complete animation shorthand values — pair named @keyframes with duration and easing. Use directly as animation property values.",
      "note": "Per-item delay increment for the .sf-stagger utility. One knob retunes the whole staggered sequence; the class multiplies it by each child's index and by --sf-motion-scale.",
      "value": "75ms",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-sticky-offset",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "sticky",
      "category": "Core tokens",
      "group": "Layout & a11y",
      "description": "Focus ring, header height, sticky offset, touch-target, text-contrast knobs, and device safe-area insets. These govern keyboard accessibility, scroll behaviour, and adaptive contrast globally.",
      "note": "top offset for position: sticky elements, accounting for the header height.",
      "value": "clamp( var(--sf-sticky-offset-mobile), calc((var(--sf-sticky-offset-desktop) - var(--sf-sticky-offset-mobile)) / ((var(--sf-fluid-max-vw) - var(--sf-fluid-min-vw)) * 1rem) * (100vw - var(--sf-fluid-min-vw) * 1rem) + var(--sf-sticky-offset-mobile)), var(--sf-sticky-offset-desktop))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-sticky-offset-desktop",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "sticky",
      "category": "Core tokens",
      "group": "Layout & a11y",
      "description": "Focus ring, header height, sticky offset, touch-target, text-contrast knobs, and device safe-area insets. These govern keyboard accessibility, scroll behaviour, and adaptive contrast globally.",
      "note": "Sticky offset at desktop breakpoints.",
      "value": "var(--sf-header-height-desktop)",
      "aliasOf": "--sf-header-height-desktop",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-sticky-offset-mobile",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "sticky",
      "category": "Core tokens",
      "group": "Layout & a11y",
      "description": "Focus ring, header height, sticky offset, touch-target, text-contrast knobs, and device safe-area insets. These govern keyboard accessibility, scroll behaviour, and adaptive contrast globally.",
      "note": "Sticky offset at mobile breakpoints.",
      "value": "var(--sf-header-height-mobile)",
      "aliasOf": "--sf-header-height-mobile",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-surface-bg-animation",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "surface",
      "category": "Macro tokens",
      "group": "Named background surface preset",
      "description": "animation shorthand applied to the .sf-surface-bg layer, e.g. a slow pan. Default: none.",
      "note": "animation shorthand applied to the .sf-surface-bg layer, e.g. a slow pan. Default: none.",
      "value": "none",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-surface-bg-attachment",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "surface",
      "category": "Macro tokens",
      "group": "Named background surface preset",
      "description": "background-attachment for the .sf-surface-bg image (scroll vs fixed). Default: scroll.",
      "note": "background-attachment for the .sf-surface-bg image (scroll vs fixed). Default: scroll.",
      "value": "scroll",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-surface-bg-color",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "surface",
      "category": "Macro tokens",
      "group": "Named background surface preset",
      "description": "Background colour slot for the .sf-surface-bg macro. Default: transparent.",
      "note": "Background colour slot for the .sf-surface-bg macro. Default: transparent.",
      "value": "transparent",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-surface-bg-image",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "surface",
      "category": "Macro tokens",
      "group": "Named background surface preset",
      "description": "Background image slot for the .sf-surface-bg macro (e.g. url(…)). Default: none.",
      "note": "Background image slot for the .sf-surface-bg macro (e.g. url(…)). Default: none.",
      "value": "none",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-surface-bg-overlay",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "surface",
      "category": "Macro tokens",
      "group": "Named background surface preset",
      "description": "Overlay layer composited above the image in .sf-surface-bg — e.g. a scrim gradient. Default: none.",
      "note": "Overlay layer composited above the image in .sf-surface-bg — e.g. a scrim gradient. Default: none.",
      "value": "none",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-surface-bg-position",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "surface",
      "category": "Macro tokens",
      "group": "Named background surface preset",
      "description": "background-position for the .sf-surface-bg image. Default: center.",
      "note": "background-position for the .sf-surface-bg image. Default: center.",
      "value": "center",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-surface-bg-repeat",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "surface",
      "category": "Macro tokens",
      "group": "Named background surface preset",
      "description": "background-repeat for the .sf-surface-bg image. Default: no-repeat.",
      "note": "background-repeat for the .sf-surface-bg image. Default: no-repeat.",
      "value": "no-repeat",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-surface-bg-size",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "surface",
      "category": "Macro tokens",
      "group": "Named background surface preset",
      "description": "background-size for the .sf-surface-bg image. Default: cover.",
      "note": "background-size for the .sf-surface-bg image. Default: cover.",
      "value": "cover",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-surface-color",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "surface",
      "category": "Macro tokens",
      "group": "Surface color",
      "description": "Input color for the generic .sf-surface macro. Set any color value; the macro derives the background, auto-contrast foreground, and contextual token set from it.",
      "note": "Input for the generic .sf-surface macro. Set any color (including palette shades); the macro derives background, auto-contrast foreground, and the contextual token set from it.",
      "value": "var(--sf-color-base)",
      "aliasOf": "--sf-color-base",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-switcher-gap",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "switcher",
      "category": "Layout tokens",
      "group": "Switcher",
      "description": "Configuration tokens for the switcher layout (horizontal → vertical breakpoint).",
      "note": "Gap between switcher columns / rows.",
      "value": "var(--sf-gap)",
      "aliasOf": "--sf-gap",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-switcher-threshold",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "switcher",
      "category": "Layout tokens",
      "group": "Switcher",
      "description": "Configuration tokens for the switcher layout (horizontal → vertical breakpoint).",
      "note": "Inline-size threshold below which the switcher flips from horizontal to vertical.",
      "value": "30rem",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-2xl",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Font sizes",
      "description": "Fluid font-size scale. Values interpolate between mobile and desktop sizes, so prefer these over fixed rem values.",
      "note": "2× large font size (~24px). Section headings.",
      "value": "calc(clamp(calc(var(--sf-text-base-min) * pow(var(--sf-text-ratio-min), 3) * 1rem), calc((var(--sf-text-base-max) * pow(var(--sf-text-ratio-max), 3) - var(--sf-text-base-min) * pow(var(--sf-text-ratio-min), 3)) / (var(--sf-fluid-max-vw) - var(--sf-fluid-min-vw)) * (var(--sf-fluid-width) - var(--sf-fluid-min-vw) * 1rem) + var(--sf-text-base-min) * pow(var(--sf-text-ratio-min), 3) * 1rem), calc(var(--sf-text-base-max) * pow(var(--sf-text-ratio-max), 3) * 1rem)) * var(--sf-text-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-2xl-font-weight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Font weight for 2×-large text.",
      "note": "Font weight for 2×-large text.",
      "value": "var(--sf-font-weight-heading)",
      "aliasOf": "--sf-font-weight-heading",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-2xl-letter-spacing",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Letter-spacing for 2×-large text.",
      "note": "Letter-spacing for 2×-large text.",
      "value": "var(--sf-tracking-normal)",
      "aliasOf": "--sf-tracking-normal",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-2xl-line-height",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Line height for 2×-large text.",
      "note": "Line height for 2×-large text.",
      "value": "calc(var(--sf-leading-snug) - 6 * var(--sf-leading-taper))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-2xl-max-width",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Optimal line length for 2×-large text.",
      "note": "Optimal line length for 2×-large text.",
      "value": "none",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-2xs",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Font sizes",
      "description": "Fluid font-size scale. Values interpolate between mobile and desktop sizes, so prefer these over fixed rem values.",
      "note": "Extra-extra-small font size (~11px). Fine print, badges.",
      "value": "calc(clamp(calc(var(--sf-text-base-min) * pow(var(--sf-text-ratio-min), -3) * 1rem), calc((var(--sf-text-base-max) * pow(var(--sf-text-ratio-max), -3) - var(--sf-text-base-min) * pow(var(--sf-text-ratio-min), -3)) / (var(--sf-fluid-max-vw) - var(--sf-fluid-min-vw)) * (var(--sf-fluid-width) - var(--sf-fluid-min-vw) * 1rem) + var(--sf-text-base-min) * pow(var(--sf-text-ratio-min), -3) * 1rem), calc(var(--sf-text-base-max) * pow(var(--sf-text-ratio-max), -3) * 1rem)) * var(--sf-text-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-2xs-font-weight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Font weight for 2×-extra-small text. Override to deviate from the global weight at this size.",
      "note": "Font weight for 2×-extra-small text. Override to deviate from the global weight at this size.",
      "value": "var(--sf-font-weight-body)",
      "aliasOf": "--sf-font-weight-body",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-2xs-letter-spacing",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Letter-spacing for 2×-extra-small text.",
      "note": "Letter-spacing for 2×-extra-small text.",
      "value": "var(--sf-tracking-normal)",
      "aliasOf": "--sf-tracking-normal",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-2xs-line-height",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Line height for 2×-extra-small text.",
      "note": "Line height for 2×-extra-small text.",
      "value": "var(--sf-leading-relaxed)",
      "aliasOf": "--sf-leading-relaxed",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-2xs-max-width",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Optimal line length (max-width in ch) for 2×-extra-small text.",
      "note": "Optimal line length (max-width in ch) for 2×-extra-small text.",
      "value": "55ch",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-3xl",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Font sizes",
      "description": "Fluid font-size scale. Values interpolate between mobile and desktop sizes, so prefer these over fixed rem values.",
      "note": "3× large font size (~30px). Major headings.",
      "value": "calc(clamp(calc(var(--sf-text-base-min) * pow(var(--sf-text-ratio-min), 4) * 1rem), calc((var(--sf-text-base-max) * pow(var(--sf-text-ratio-max), 4) - var(--sf-text-base-min) * pow(var(--sf-text-ratio-min), 4)) / (var(--sf-fluid-max-vw) - var(--sf-fluid-min-vw)) * (var(--sf-fluid-width) - var(--sf-fluid-min-vw) * 1rem) + var(--sf-text-base-min) * pow(var(--sf-text-ratio-min), 4) * 1rem), calc(var(--sf-text-base-max) * pow(var(--sf-text-ratio-max), 4) * 1rem)) * var(--sf-text-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-3xl-font-weight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Font weight for 3×-large text.",
      "note": "Font weight for 3×-large text.",
      "value": "var(--sf-font-weight-heading)",
      "aliasOf": "--sf-font-weight-heading",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-3xl-letter-spacing",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Letter-spacing for 3×-large text. Typically negative to tighten large headings.",
      "note": "Letter-spacing for 3×-large text. Typically negative to tighten large headings.",
      "value": "var(--sf-tracking-tight)",
      "aliasOf": "--sf-tracking-tight",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-3xl-line-height",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Line height for 3×-large text.",
      "note": "Line height for 3×-large text.",
      "value": "calc(var(--sf-leading-tight) - 7 * var(--sf-leading-taper))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-3xl-max-width",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Optimal line length for 3×-large text.",
      "note": "Optimal line length for 3×-large text.",
      "value": "none",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-4xl",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Font sizes",
      "description": "Fluid font-size scale. Values interpolate between mobile and desktop sizes, so prefer these over fixed rem values.",
      "note": "4× large font size (~36px). Display-level headings.",
      "value": "calc(clamp(calc(var(--sf-text-base-min) * pow(var(--sf-text-ratio-min), 5) * 1rem), calc((var(--sf-text-base-max) * pow(var(--sf-text-ratio-max), 5) - var(--sf-text-base-min) * pow(var(--sf-text-ratio-min), 5)) / (var(--sf-fluid-max-vw) - var(--sf-fluid-min-vw)) * (var(--sf-fluid-width) - var(--sf-fluid-min-vw) * 1rem) + var(--sf-text-base-min) * pow(var(--sf-text-ratio-min), 5) * 1rem), calc(var(--sf-text-base-max) * pow(var(--sf-text-ratio-max), 5) * 1rem)) * var(--sf-text-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-4xl-font-weight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Font weight for 4×-large text.",
      "note": "Font weight for 4×-large text.",
      "value": "var(--sf-font-weight-heading)",
      "aliasOf": "--sf-font-weight-heading",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-4xl-letter-spacing",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Letter-spacing for 4×-large text.",
      "note": "Letter-spacing for 4×-large text.",
      "value": "var(--sf-tracking-tight)",
      "aliasOf": "--sf-tracking-tight",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-4xl-line-height",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Line height for 4×-large text.",
      "note": "Line height for 4×-large text.",
      "value": "calc(var(--sf-leading-tight) - 8 * var(--sf-leading-taper))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-4xl-max-width",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Optimal line length for 4×-large text.",
      "note": "Optimal line length for 4×-large text.",
      "value": "none",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-base-max",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "text",
      "category": "Core tokens",
      "group": "FLUID SCALE ENGINE",
      "description": "Generative inputs that drive all fluid clamp() type and spacing scales at runtime. Override the base, ratio, and viewport range tokens to globally rescale the entire system without touching individual step tokens.",
      "note": "Maximum base font size (rem) at the widest viewport. End point for the fluid type scale at wide screens. Part of the fluid scale engine.",
      "value": "1.25",
      "aliasOf": null,
      "registered": true,
      "syntax": "<number>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-base-min",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "text",
      "category": "Core tokens",
      "group": "FLUID SCALE ENGINE",
      "description": "Generative inputs that drive all fluid clamp() type and spacing scales at runtime. Override the base, ratio, and viewport range tokens to globally rescale the entire system without touching individual step tokens.",
      "note": "Minimum base font size (rem) at the narrowest viewport. Starting point for the fluid type scale at narrow screens. Part of the fluid scale engine.",
      "value": "1",
      "aliasOf": null,
      "registered": true,
      "syntax": "<number>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-display-base-max",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "text",
      "category": "Core tokens",
      "group": "FLUID SCALE ENGINE",
      "description": "Generative inputs that drive all fluid clamp() type and spacing scales at runtime. Override the base, ratio, and viewport range tokens to globally rescale the entire system without touching individual step tokens.",
      "note": "Maximum display/hero font size (rem) at the widest viewport. Drives the ceiling of the fluid display type scale. Part of the fluid scale engine.",
      "value": "3",
      "aliasOf": null,
      "registered": true,
      "syntax": "<number>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-display-base-min",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "text",
      "category": "Core tokens",
      "group": "FLUID SCALE ENGINE",
      "description": "Generative inputs that drive all fluid clamp() type and spacing scales at runtime. Override the base, ratio, and viewport range tokens to globally rescale the entire system without touching individual step tokens.",
      "note": "Minimum display/hero font size (rem) at the narrowest viewport. Drives the floor of the fluid display type scale. Part of the fluid scale engine.",
      "value": "2.4",
      "aliasOf": null,
      "registered": true,
      "syntax": "<number>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-display-l",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Font sizes",
      "description": "Fluid font-size scale. Values interpolate between mobile and desktop sizes, so prefer these over fixed rem values.",
      "note": "Large display font size (~68px+). Oversized hero text.",
      "value": "calc(clamp(calc(var(--sf-text-display-base-min) * pow(var(--sf-text-ratio-min), 2) * 1rem), calc((var(--sf-text-display-base-max) * pow(var(--sf-text-ratio-max), 2) - var(--sf-text-display-base-min) * pow(var(--sf-text-ratio-min), 2)) / (var(--sf-fluid-max-vw) - var(--sf-fluid-min-vw)) * (var(--sf-fluid-width) - var(--sf-fluid-min-vw) * 1rem) + var(--sf-text-display-base-min) * pow(var(--sf-text-ratio-min), 2) * 1rem), calc(var(--sf-text-display-base-max) * pow(var(--sf-text-ratio-max), 2) * 1rem)) * var(--sf-text-display-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-display-m",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Font sizes",
      "description": "Fluid font-size scale. Values interpolate between mobile and desktop sizes, so prefer these over fixed rem values.",
      "note": "Medium display font size (~54px). Hero headings.",
      "value": "calc(clamp(calc(var(--sf-text-display-base-min) * pow(var(--sf-text-ratio-min), 1) * 1rem), calc((var(--sf-text-display-base-max) * pow(var(--sf-text-ratio-max), 1) - var(--sf-text-display-base-min) * pow(var(--sf-text-ratio-min), 1)) / (var(--sf-fluid-max-vw) - var(--sf-fluid-min-vw)) * (var(--sf-fluid-width) - var(--sf-fluid-min-vw) * 1rem) + var(--sf-text-display-base-min) * pow(var(--sf-text-ratio-min), 1) * 1rem), calc(var(--sf-text-display-base-max) * pow(var(--sf-text-ratio-max), 1) * 1rem)) * var(--sf-text-display-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-display-s",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Font sizes",
      "description": "Fluid font-size scale. Values interpolate between mobile and desktop sizes, so prefer these over fixed rem values.",
      "note": "Small display font size (~42px). Hero sub-headings.",
      "value": "calc(clamp(calc(var(--sf-text-display-base-min) * 1rem), calc((var(--sf-text-display-base-max) - var(--sf-text-display-base-min)) / (var(--sf-fluid-max-vw) - var(--sf-fluid-min-vw)) * (var(--sf-fluid-width) - var(--sf-fluid-min-vw) * 1rem) + var(--sf-text-display-base-min) * 1rem), calc(var(--sf-text-display-base-max) * 1rem)) * var(--sf-text-display-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-display-scale",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Scale multipliers",
      "description": "Global proportional multipliers for the four main design axes (type, space, radius, motion). Adjusting one multiplier uniformly scales every clamp() value in that dimension.",
      "note": "Multiplier applied only to the display/hero type scale (--sf-text-display-*). Tune headline impact independently of body text.",
      "value": "1",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-l",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Font sizes",
      "description": "Fluid font-size scale. Values interpolate between mobile and desktop sizes, so prefer these over fixed rem values.",
      "note": "Large font size (~18px). Lead paragraphs, prominent labels.",
      "value": "calc(clamp(calc(var(--sf-text-base-min) * pow(var(--sf-text-ratio-min), 1) * 1rem), calc((var(--sf-text-base-max) * pow(var(--sf-text-ratio-max), 1) - var(--sf-text-base-min) * pow(var(--sf-text-ratio-min), 1)) / (var(--sf-fluid-max-vw) - var(--sf-fluid-min-vw)) * (var(--sf-fluid-width) - var(--sf-fluid-min-vw) * 1rem) + var(--sf-text-base-min) * pow(var(--sf-text-ratio-min), 1) * 1rem), calc(var(--sf-text-base-max) * pow(var(--sf-text-ratio-max), 1) * 1rem)) * var(--sf-text-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-l-font-weight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Font weight for large text.",
      "note": "Font weight for large text.",
      "value": "var(--sf-font-weight-body)",
      "aliasOf": "--sf-font-weight-body",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-l-letter-spacing",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Letter-spacing for large text.",
      "note": "Letter-spacing for large text.",
      "value": "var(--sf-tracking-normal)",
      "aliasOf": "--sf-tracking-normal",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-l-line-height",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Line height for large text.",
      "note": "Line height for large text.",
      "value": "calc(var(--sf-leading-normal) - 4 * var(--sf-leading-taper))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-l-max-width",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Optimal line length for large text.",
      "note": "Optimal line length for large text.",
      "value": "none",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-m",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Font sizes",
      "description": "Fluid font-size scale. Values interpolate between mobile and desktop sizes, so prefer these over fixed rem values.",
      "note": "Medium / base font size (~16px). Typical body text.",
      "value": "calc(clamp(calc(var(--sf-text-base-min) * 1rem), calc((var(--sf-text-base-max) - var(--sf-text-base-min)) / (var(--sf-fluid-max-vw) - var(--sf-fluid-min-vw)) * (var(--sf-fluid-width) - var(--sf-fluid-min-vw) * 1rem) + var(--sf-text-base-min) * 1rem), calc(var(--sf-text-base-max) * 1rem)) * var(--sf-text-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-m-font-weight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Font weight for medium (body) text.",
      "note": "Font weight for medium (body) text.",
      "value": "var(--sf-font-weight-body)",
      "aliasOf": "--sf-font-weight-body",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-m-letter-spacing",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Letter-spacing for medium text.",
      "note": "Letter-spacing for medium text.",
      "value": "var(--sf-tracking-normal)",
      "aliasOf": "--sf-tracking-normal",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-m-line-height",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Line height for medium text.",
      "note": "Line height for medium text.",
      "value": "calc(var(--sf-leading-normal) - 3 * var(--sf-leading-taper))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-m-max-width",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Optimal reading line length for medium text (~65–75ch).",
      "note": "Optimal reading line length for medium text (~65–75ch).",
      "value": "65ch",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-ratio-max",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "text",
      "category": "Core tokens",
      "group": "FLUID SCALE ENGINE",
      "description": "Generative inputs that drive all fluid clamp() type and spacing scales at runtime. Override the base, ratio, and viewport range tokens to globally rescale the entire system without touching individual step tokens.",
      "note": "Modular type scale ratio at the widest viewport. Controls step-to-step size growth. Default 1.333. Part of the fluid scale engine.",
      "value": "1.333",
      "aliasOf": null,
      "registered": true,
      "syntax": "<number>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-ratio-min",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "text",
      "category": "Core tokens",
      "group": "FLUID SCALE ENGINE",
      "description": "Generative inputs that drive all fluid clamp() type and spacing scales at runtime. Override the base, ratio, and viewport range tokens to globally rescale the entire system without touching individual step tokens.",
      "note": "Modular type scale ratio at the narrowest viewport. Controls step-to-step size growth in the fluid type ramp. Default 1.25. Part of the fluid scale engine.",
      "value": "1.25",
      "aliasOf": null,
      "registered": true,
      "syntax": "<number>",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-s",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Font sizes",
      "description": "Fluid font-size scale. Values interpolate between mobile and desktop sizes, so prefer these over fixed rem values.",
      "note": "Small font size (~14px). Secondary content, UI annotations.",
      "value": "calc(clamp(calc(var(--sf-text-base-min) * pow(var(--sf-text-ratio-min), -1) * 1rem), calc((var(--sf-text-base-max) * pow(var(--sf-text-ratio-max), -1) - var(--sf-text-base-min) * pow(var(--sf-text-ratio-min), -1)) / (var(--sf-fluid-max-vw) - var(--sf-fluid-min-vw)) * (var(--sf-fluid-width) - var(--sf-fluid-min-vw) * 1rem) + var(--sf-text-base-min) * pow(var(--sf-text-ratio-min), -1) * 1rem), calc(var(--sf-text-base-max) * pow(var(--sf-text-ratio-max), -1) * 1rem)) * var(--sf-text-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-s-font-weight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Font weight for small text.",
      "note": "Font weight for small text.",
      "value": "var(--sf-font-weight-body)",
      "aliasOf": "--sf-font-weight-body",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-s-letter-spacing",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Letter-spacing for small text.",
      "note": "Letter-spacing for small text.",
      "value": "var(--sf-tracking-normal)",
      "aliasOf": "--sf-tracking-normal",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-s-line-height",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Line height for small text.",
      "note": "Line height for small text.",
      "value": "calc(var(--sf-leading-relaxed) - 2 * var(--sf-leading-taper))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-s-max-width",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Optimal line length for small text.",
      "note": "Optimal line length for small text.",
      "value": "65ch",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-scale",
      "tier": "PUBLIC-ADVANCED",
      "role": "knob",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Scale multipliers",
      "description": "Global proportional multipliers for the four main design axes (type, space, radius, motion). Adjusting one multiplier uniformly scales every clamp() value in that dimension.",
      "note": "Global type-size multiplier. Scales the entire fluid type scale. 1.08 gives noticeably larger body text without breaking layout.",
      "value": "1",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-shadow-l",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Output token @property registrations",
      "description": "Large text-shadow for high-contrast text over busy or dark image backgrounds.",
      "note": "Large text-shadow for high-contrast text over busy or dark image backgrounds.",
      "value": "0 4px 8px oklch(from var(--sf-shadow-color) l c h / clamp(0, calc(var(--sf-shadow-strength) * 2.5), 0.7))",
      "aliasOf": null,
      "registered": true,
      "syntax": "*",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-shadow-m",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Output token @property registrations",
      "description": "Medium text-shadow. Use for text overlaid on images to improve legibility.",
      "note": "Medium text-shadow. Use for text overlaid on images to improve legibility.",
      "value": "0 2px 4px oklch(from var(--sf-shadow-color) l c h / clamp(0, calc(var(--sf-shadow-strength) * 2), 0.7))",
      "aliasOf": null,
      "registered": true,
      "syntax": "*",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-shadow-none",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Output token @property registrations",
      "description": "Removes text-shadow (use to explicitly reset inherited shadows).",
      "note": "Removes text-shadow (use to explicitly reset inherited shadows).",
      "value": "none",
      "aliasOf": null,
      "registered": true,
      "syntax": "*",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-shadow-s",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Output token @property registrations",
      "description": "Small text-shadow for subtle depth on display headings.",
      "note": "Small text-shadow for subtle depth on display headings.",
      "value": "0 1px 2px oklch(from var(--sf-shadow-color) l c h / clamp(0, calc(var(--sf-shadow-strength) * 1.5), 0.7))",
      "aliasOf": null,
      "registered": true,
      "syntax": "*",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-shadow-xl",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Output token @property registrations",
      "description": "Extra-large text-shadow for maximum legibility over busy or high-contrast image backgrounds.",
      "note": "Extra-large text-shadow for maximum legibility over busy or high-contrast image backgrounds.",
      "value": "0 8px 16px oklch(from var(--sf-shadow-color) l c h / clamp(0, calc(var(--sf-shadow-strength) * 3), 0.7))",
      "aliasOf": null,
      "registered": true,
      "syntax": "*",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-shadow-xs",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Output token @property registrations",
      "description": "Extra-small text-shadow for the subtlest depth on body text.",
      "note": "Extra-small text-shadow for the subtlest depth on body text.",
      "value": "0 0.5px 1px oklch(from var(--sf-shadow-color) l c h / clamp(0, calc(var(--sf-shadow-strength) * 1), 0.7))",
      "aliasOf": null,
      "registered": true,
      "syntax": "*",
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-xl",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Font sizes",
      "description": "Fluid font-size scale. Values interpolate between mobile and desktop sizes, so prefer these over fixed rem values.",
      "note": "Extra-large font size (~20px). Sub-headings, callout text.",
      "value": "calc(clamp(calc(var(--sf-text-base-min) * pow(var(--sf-text-ratio-min), 2) * 1rem), calc((var(--sf-text-base-max) * pow(var(--sf-text-ratio-max), 2) - var(--sf-text-base-min) * pow(var(--sf-text-ratio-min), 2)) / (var(--sf-fluid-max-vw) - var(--sf-fluid-min-vw)) * (var(--sf-fluid-width) - var(--sf-fluid-min-vw) * 1rem) + var(--sf-text-base-min) * pow(var(--sf-text-ratio-min), 2) * 1rem), calc(var(--sf-text-base-max) * pow(var(--sf-text-ratio-max), 2) * 1rem)) * var(--sf-text-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-xl-font-weight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Font weight for extra-large text.",
      "note": "Font weight for extra-large text.",
      "value": "var(--sf-font-weight-body)",
      "aliasOf": "--sf-font-weight-body",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-xl-letter-spacing",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Letter-spacing for extra-large text.",
      "note": "Letter-spacing for extra-large text.",
      "value": "var(--sf-tracking-normal)",
      "aliasOf": "--sf-tracking-normal",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-xl-line-height",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Line height for extra-large text.",
      "note": "Line height for extra-large text.",
      "value": "calc(var(--sf-leading-snug) - 5 * var(--sf-leading-taper))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-xl-max-width",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Optimal line length for extra-large text.",
      "note": "Optimal line length for extra-large text.",
      "value": "none",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-xs",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Font sizes",
      "description": "Fluid font-size scale. Values interpolate between mobile and desktop sizes, so prefer these over fixed rem values.",
      "note": "Extra-small font size (~12px). Labels, captions, metadata.",
      "value": "calc(clamp(calc(var(--sf-text-base-min) * pow(var(--sf-text-ratio-min), -2) * 1rem), calc((var(--sf-text-base-max) * pow(var(--sf-text-ratio-max), -2) - var(--sf-text-base-min) * pow(var(--sf-text-ratio-min), -2)) / (var(--sf-fluid-max-vw) - var(--sf-fluid-min-vw)) * (var(--sf-fluid-width) - var(--sf-fluid-min-vw) * 1rem) + var(--sf-text-base-min) * pow(var(--sf-text-ratio-min), -2) * 1rem), calc(var(--sf-text-base-max) * pow(var(--sf-text-ratio-max), -2) * 1rem)) * var(--sf-text-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-xs-font-weight",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Font weight for extra-small text.",
      "note": "Font weight for extra-small text.",
      "value": "var(--sf-font-weight-body)",
      "aliasOf": "--sf-font-weight-body",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-xs-letter-spacing",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Letter-spacing for extra-small text.",
      "note": "Letter-spacing for extra-small text.",
      "value": "var(--sf-tracking-normal)",
      "aliasOf": "--sf-tracking-normal",
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-xs-line-height",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Line height for extra-small text.",
      "note": "Line height for extra-small text.",
      "value": "calc(var(--sf-leading-relaxed) - 1 * var(--sf-leading-taper))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-text-xs-max-width",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "text",
      "category": "Core tokens",
      "group": "Per-size typography sub-properties",
      "description": "Optimal line length for extra-small text.",
      "note": "Optimal line length for extra-small text.",
      "value": "60ch",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-theme-transition-duration",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "theme",
      "category": "Core tokens",
      "group": "Motion & easing",
      "description": "Duration and easing tokens. Build all transitions and animations from these to ensure consistent motion across the system.",
      "note": "Duration of the .sf-theme-transition animated color-scheme crossfade. Scales with --sf-motion-scale so reduced-motion preferences are respected. Default 300ms.",
      "value": "calc(300ms * var(--sf-motion-scale))",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-touch-target",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "touch",
      "category": "Core tokens",
      "group": "Layout & a11y",
      "description": "Focus ring, header height, sticky offset, touch-target, text-contrast knobs, and device safe-area insets. These govern keyboard accessibility, scroll behaviour, and adaptive contrast globally.",
      "note": "Minimum touch-target size for interactive elements per WCAG 2.5.5. Fixed 44px anchor, independent of the --sf-size-* scale.",
      "value": "2.75rem",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-tracking-normal",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "tracking",
      "category": "Core tokens",
      "group": "Line heights & letter spacing",
      "description": "Typographic fine-tuning tokens: leading (line-height) and tracking (letter-spacing) for every weight class.",
      "note": "Normal letter-spacing (0). Default for body text.",
      "value": "0",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-tracking-tight",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "tracking",
      "category": "Core tokens",
      "group": "Line heights & letter spacing",
      "description": "Typographic fine-tuning tokens: leading (line-height) and tracking (letter-spacing) for every weight class.",
      "note": "Tight letter-spacing (slightly negative). Suitable for large headings.",
      "value": "-0.025em",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-tracking-wide",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "tracking",
      "category": "Core tokens",
      "group": "Line heights & letter spacing",
      "description": "Typographic fine-tuning tokens: leading (line-height) and tracking (letter-spacing) for every weight class.",
      "note": "Wide letter-spacing. Use for small-caps labels.",
      "value": "0.025em",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-tracking-wider",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "tracking",
      "category": "Core tokens",
      "group": "Line heights & letter spacing",
      "description": "Typographic fine-tuning tokens: leading (line-height) and tracking (letter-spacing) for every weight class.",
      "note": "Wider letter-spacing for strongly spaced labels.",
      "value": "0.05em",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-tracking-widest",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "tracking",
      "category": "Core tokens",
      "group": "Line heights & letter spacing",
      "description": "Typographic fine-tuning tokens: leading (line-height) and tracking (letter-spacing) for every weight class.",
      "note": "Widest letter-spacing for all-caps microcopy.",
      "value": "0.1em",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-transition-colors",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "transition",
      "category": "Core tokens",
      "group": "Transition shorthands",
      "description": "Pre-built transition shorthand values for the most common animated properties.",
      "note": "Transition shorthand for color-related properties (color, background, border-color).",
      "value": "color var(--sf-duration-normal) var(--sf-ease-out), background-color var(--sf-duration-normal) var(--sf-ease-out), border-color var(--sf-duration-normal) var(--sf-ease-out), text-decoration-color var(--sf-duration-normal) var(--sf-ease-out), fill var(--sf-duration-normal) var(--sf-ease-out), stroke var(--sf-duration-normal) var(--sf-ease-out)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-transition-enter",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "transition",
      "category": "Core tokens",
      "group": "Transition shorthands",
      "description": "Pre-built transition shorthand values for the most common animated properties.",
      "note": "Enter-phase transition (ease-out). Use on elements appearing in the viewport.",
      "value": "color var(--sf-duration-normal) var(--sf-ease-out), background-color var(--sf-duration-normal) var(--sf-ease-out), border-color var(--sf-duration-normal) var(--sf-ease-out), box-shadow var(--sf-duration-normal) var(--sf-ease-out), opacity var(--sf-duration-normal) var(--sf-ease-out), transform var(--sf-duration-normal) var(--sf-ease-out), filter var(--sf-duration-normal) var(--sf-ease-out)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-transition-exit",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "transition",
      "category": "Core tokens",
      "group": "Transition shorthands",
      "description": "Pre-built transition shorthand values for the most common animated properties.",
      "note": "Exit-phase transition (ease-in). Use on elements leaving the viewport.",
      "value": "color var(--sf-duration-fast) var(--sf-ease-in), background-color var(--sf-duration-fast) var(--sf-ease-in), border-color var(--sf-duration-fast) var(--sf-ease-in), box-shadow var(--sf-duration-fast) var(--sf-ease-in), opacity var(--sf-duration-fast) var(--sf-ease-in), transform var(--sf-duration-fast) var(--sf-ease-in), filter var(--sf-duration-fast) var(--sf-ease-in)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-transition-fast",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "transition",
      "category": "Core tokens",
      "group": "Transition shorthands",
      "description": "Pre-built transition shorthand values for the most common animated properties.",
      "note": "Fast-duration transition shorthand.",
      "value": "color var(--sf-duration-fast) var(--sf-ease-out), background-color var(--sf-duration-fast) var(--sf-ease-out), border-color var(--sf-duration-fast) var(--sf-ease-out), box-shadow var(--sf-duration-fast) var(--sf-ease-out), opacity var(--sf-duration-fast) var(--sf-ease-out), transform var(--sf-duration-fast) var(--sf-ease-out), filter var(--sf-duration-fast) var(--sf-ease-out)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-transition-form-field",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "transition",
      "category": "Core tokens",
      "group": "Transition shorthands",
      "description": "Pre-built transition shorthand values for the most common animated properties.",
      "note": "Transition shorthand optimised for form fields: color and background at normal pace so label color shifts feel natural; border, shadow, and opacity at fast pace so focus rings appear crisply.",
      "value": "color var(--sf-duration-normal) var(--sf-ease-out), background-color var(--sf-duration-normal) var(--sf-ease-out), text-decoration-color var(--sf-duration-normal) var(--sf-ease-out), fill var(--sf-duration-normal) var(--sf-ease-out), stroke var(--sf-duration-normal) var(--sf-ease-out), border-color var(--sf-duration-fast) var(--sf-ease-out), box-shadow var(--sf-duration-fast) var(--sf-ease-out), opacity var(--sf-duration-fast) var(--sf-ease-out)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-transition-opacity",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "transition",
      "category": "Core tokens",
      "group": "Transition shorthands",
      "description": "Pre-built transition shorthand values for the most common animated properties.",
      "note": "Transition shorthand for opacity.",
      "value": "opacity var(--sf-duration-normal) var(--sf-ease-out)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-transition-overlay",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "transition",
      "category": "Core tokens",
      "group": "Transition shorthands",
      "description": "Pre-built transition shorthand values for the most common animated properties.",
      "note": "Transition shorthand for overlay fades (opacity + visibility).",
      "value": "overlay var(--sf-duration-normal) allow-discrete, display var(--sf-duration-normal) allow-discrete",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-transition-shadow",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "transition",
      "category": "Core tokens",
      "group": "Transition shorthands",
      "description": "Pre-built transition shorthand values for the most common animated properties.",
      "note": "Transition shorthand for box-shadow.",
      "value": "box-shadow var(--sf-duration-normal) var(--sf-ease-out)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-transition-slow",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "transition",
      "category": "Core tokens",
      "group": "Transition shorthands",
      "description": "Pre-built transition shorthand values for the most common animated properties.",
      "note": "Slow-duration transition shorthand.",
      "value": "color var(--sf-duration-slow) var(--sf-ease-in-out), background-color var(--sf-duration-slow) var(--sf-ease-in-out), border-color var(--sf-duration-slow) var(--sf-ease-in-out), box-shadow var(--sf-duration-slow) var(--sf-ease-in-out), opacity var(--sf-duration-slow) var(--sf-ease-in-out), transform var(--sf-duration-slow) var(--sf-ease-in-out), filter var(--sf-duration-slow) var(--sf-ease-in-out)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-transition-transform",
      "tier": "PUBLIC",
      "role": "consumption",
      "namespace": "transition",
      "category": "Core tokens",
      "group": "Transition shorthands",
      "description": "Pre-built transition shorthand values for the most common animated properties.",
      "note": "Transition shorthand for transform.",
      "value": "transform var(--sf-duration-normal) var(--sf-ease-out)",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-z-base",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "z",
      "category": "Core tokens",
      "group": "Z-index",
      "description": "Z-index scale using named layers. Never use raw numbers — always reference a token from this scale.",
      "note": "Base stacking level (1). Establishes a stacking context without elevation.",
      "value": "0",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-z-below",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "z",
      "category": "Core tokens",
      "group": "Z-index",
      "description": "Z-index scale using named layers. Never use raw numbers — always reference a token from this scale.",
      "note": "Z-index below stacking context base. For decorative pseudo-elements.",
      "value": "-1",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-z-dropdown",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "z",
      "category": "Core tokens",
      "group": "Z-index",
      "description": "Z-index scale using named layers. Never use raw numbers — always reference a token from this scale.",
      "note": "Z-index for dropdown menus and select popups.",
      "value": "1020",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-z-fixed",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "z",
      "category": "Core tokens",
      "group": "Z-index",
      "description": "Z-index scale using named layers. Never use raw numbers — always reference a token from this scale.",
      "note": "Z-index for position: fixed elements.",
      "value": "1010",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-z-modal",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "z",
      "category": "Core tokens",
      "group": "Z-index",
      "description": "Z-index scale using named layers. Never use raw numbers — always reference a token from this scale.",
      "note": "Z-index for modal dialogs and their non-top-layer backdrop scrims. Sits above overlays and dropdowns. Default 1040.",
      "value": "1040",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-z-overlay",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "z",
      "category": "Core tokens",
      "group": "Z-index",
      "description": "Z-index scale using named layers. Never use raw numbers — always reference a token from this scale.",
      "note": "Z-index for modal / dialog backdrops.",
      "value": "1030",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-z-raised",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "z",
      "category": "Core tokens",
      "group": "Z-index",
      "description": "Z-index scale using named layers. Never use raw numbers — always reference a token from this scale.",
      "note": "Raised elevation (50). Cards, sticky headers.",
      "value": "1",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-z-sticky",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "z",
      "category": "Core tokens",
      "group": "Z-index",
      "description": "Z-index scale using named layers. Never use raw numbers — always reference a token from this scale.",
      "note": "Z-index for position: sticky elements (navbars, table headers).",
      "value": "1000",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-z-toast",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "z",
      "category": "Core tokens",
      "group": "Z-index",
      "description": "Z-index scale using named layers. Never use raw numbers — always reference a token from this scale.",
      "note": "Z-index for toast / snackbar notifications.",
      "value": "1050",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    },
    {
      "name": "--sf-z-tooltip",
      "tier": "PUBLIC",
      "role": "knob",
      "namespace": "z",
      "category": "Core tokens",
      "group": "Z-index",
      "description": "Z-index scale using named layers. Never use raw numbers — always reference a token from this scale.",
      "note": "Z-index for tooltips and transient floating notifications. Highest named layer in the z-index stack. Default 1060.",
      "value": "1060",
      "aliasOf": null,
      "registered": false,
      "syntax": null,
      "fallbackOnly": false,
      "optional": false,
      "layer": "slashed.tokens",
      "bundles": [
        "full",
        "optimal"
      ]
    }
  ]
}
